/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as AppAccountRouteRouteImport } from './routes/app/account/route'
import { Route as AppAdminRouteRouteImport } from './routes/app/admin/route'
import { Route as AppDeeplinksRouteRouteImport } from './routes/app/deeplinks/route'
import { Route as AppOrganizationsRouteRouteImport } from './routes/app/organizations/route'
import { Route as AppResourcesRouteRouteImport } from './routes/app/resources/route'
import { Route as AppAccountIndexRouteImport } from './routes/app/account/index'
import { Route as AppAccountCurriculaRouteImport } from './routes/app/account/curricula'
import { Route as AppAccountDashboardRouteImport } from './routes/app/account/dashboard'
import { Route as AppAccountDeactivateRouteImport } from './routes/app/account/deactivate'
import { Route as AppAccountFavoritesRouteImport } from './routes/app/account/favorites'
import { Route as AppAccountForgotRouteImport } from './routes/app/account/forgot'
import { Route as AppAccountLoggedOutRouteImport } from './routes/app/account/logged-out'
import { Route as AppAccountLoginRouteImport } from './routes/app/account/login'
import { Route as AppAccountLogoutRouteImport } from './routes/app/account/logout'
import { Route as AppAccountProfileRouteImport } from './routes/app/account/profile'
import { Route as AppAccountReactivateRouteImport } from './routes/app/account/reactivate'
import { Route as AppAccountWelcomeBackRouteImport } from './routes/app/account/welcome-back'
import { Route as AppAdminIndexRouteImport } from './routes/app/admin/index'
import { Route as AppAdminActivityLogRouteImport } from './routes/app/admin/activity-log'
import { Route as AppAdminContentRouteRouteImport } from './routes/app/admin/content/route'
import { Route as AppAdminCriteriaRouteRouteImport } from './routes/app/admin/criteria/route'
import { Route as AppAdminCriterionTopicsRouteRouteImport } from './routes/app/admin/criterion-topics/route'
import { Route as AppAdminDemosRouteImport } from './routes/app/admin/demos'
import { Route as AppAdminGuidesRouteImport } from './routes/app/admin/guides'
import { Route as AppAdminLmsRouteRouteImport } from './routes/app/admin/lms/route'
import { Route as AppAdminMetricsRouteImport } from './routes/app/admin/metrics'
import { Route as AppAdminOrganizationsRouteRouteImport } from './routes/app/admin/organizations/route'
import { Route as AppAdminPendingRouteRouteImport } from './routes/app/admin/pending/route'
import { Route as AppAdminProgramsRouteRouteImport } from './routes/app/admin/programs/route'
import { Route as AppAdminSetsRouteRouteImport } from './routes/app/admin/sets/route'
import { Route as AppAdminSettingsRouteRouteImport } from './routes/app/admin/settings/route'
import { Route as AppAdminSurveysRouteRouteImport } from './routes/app/admin/surveys/route'
import { Route as AppAdminTagsRouteRouteImport } from './routes/app/admin/tags/route'
import { Route as AppAdminTermsRouteRouteImport } from './routes/app/admin/terms/route'
import { Route as AppAdminUsersRouteRouteImport } from './routes/app/admin/users/route'
import { Route as AppDeeplinkQuestionQuestionIdRouteImport } from './routes/app/deeplink-question.$questionId'
import { Route as AppDeeplinkSetSetIdRouteImport } from './routes/app/deeplink-set.$setId'
import { Route as AppDeeplinksPlanRouteImport } from './routes/app/deeplinks/plan'
import { Route as AppDeeplinksTeamRouteImport } from './routes/app/deeplinks/team'
import { Route as AppDemosIndexRouteImport } from './routes/app/demos/index'
import { Route as AppMaterialsMaterialIdRouteImport } from './routes/app/materials/$materialId'
import { Route as AppOrganizationsIndexRouteImport } from './routes/app/organizations/index'
import { Route as AppOrganizationsOrganizationIdRouteRouteImport } from './routes/app/organizations/$organizationId/route'
import { Route as AppProgramsIndexRouteImport } from './routes/app/programs/index'
import { Route as AppProgramsProgramIdRouteImport } from './routes/app/programs/$programId'
import { Route as AppResourcesIndexRouteImport } from './routes/app/resources/index'
import { Route as AppResourcesResourceIdRouteImport } from './routes/app/resources/$resourceId'
import { Route as AppSurveyPreviewsSurveyIdRouteRouteImport } from './routes/app/survey-previews/$surveyId/route'
import { Route as AppSurveysSurveyOrganizationUuidRouteRouteImport } from './routes/app/surveys/$surveyOrganizationUuid/route'
import { Route as AppAccountActivityLogSplatRouteImport } from './routes/app/account/activity-log.$'
import { Route as AppAccountRedeemInviteInviteTokenRouteImport } from './routes/app/account/redeem-invite.$inviteToken'
import { Route as AppAccountRegisterIndexRouteImport } from './routes/app/account/register.index'
import { Route as AppAccountRegisterVerificationRouteImport } from './routes/app/account/register.verification'
import { Route as AppAccountResetPasswordTokenRouteImport } from './routes/app/account/reset-password.$token'
import { Route as AppAccountTwcIndexRouteImport } from './routes/app/account/twc/index'
import { Route as AppAccountTwcJoinRouteRouteImport } from './routes/app/account/twc/join/route'
import { Route as AppAccountWelcomeBackTokenRouteImport } from './routes/app/account/welcome-back.$token'
import { Route as AppAdminContentIndexRouteImport } from './routes/app/admin/content/index'
import { Route as AppAdminContentContentIdRouteImport } from './routes/app/admin/content/$contentId'
import { Route as AppAdminContentNewRouteImport } from './routes/app/admin/content/new'
import { Route as AppAdminCriteriaIndexRouteImport } from './routes/app/admin/criteria/index'
import { Route as AppAdminCriteriaCriterionIdRouteImport } from './routes/app/admin/criteria/$criterionId'
import { Route as AppAdminCriteriaNewRouteImport } from './routes/app/admin/criteria/new'
import { Route as AppAdminCriterionTopicsIndexRouteImport } from './routes/app/admin/criterion-topics/index'
import { Route as AppAdminCriterionTopicsCriterionTopicIdRouteImport } from './routes/app/admin/criterion-topics/$criterionTopicId'
import { Route as AppAdminCriterionTopicsNewRouteImport } from './routes/app/admin/criterion-topics/new'
import { Route as AppAdminDemosIndexRouteImport } from './routes/app/admin/demos/index'
import { Route as AppAdminGuidesIndexRouteImport } from './routes/app/admin/guides/index'
import { Route as AppAdminLmsIndexRouteImport } from './routes/app/admin/lms/index'
import { Route as AppAdminLmsAudioRouteRouteImport } from './routes/app/admin/lms/audio/route'
import { Route as AppAdminLmsCollectionsRouteRouteImport } from './routes/app/admin/lms/collections/route'
import { Route as AppAdminLmsCurriculaRouteRouteImport } from './routes/app/admin/lms/curricula/route'
import { Route as AppAdminLmsMicrolearningsRouteRouteImport } from './routes/app/admin/lms/microlearnings/route'
import { Route as AppAdminLmsResourcesRouteRouteImport } from './routes/app/admin/lms/resources/route'
import { Route as AppAdminLmsTrainingsLocalRouteRouteImport } from './routes/app/admin/lms/trainings-local/route'
import { Route as AppAdminOrganizationsIndexRouteImport } from './routes/app/admin/organizations/index'
import { Route as AppAdminOrganizationsOrganizationIdRouteRouteImport } from './routes/app/admin/organizations/$organizationId/route'
import { Route as AppAdminPendingInvitesRouteImport } from './routes/app/admin/pending/invites'
import { Route as AppAdminPendingRequestsRouteImport } from './routes/app/admin/pending/requests'
import { Route as AppAdminProgramsIndexRouteImport } from './routes/app/admin/programs/index'
import { Route as AppAdminProgramsProgramIdRouteRouteImport } from './routes/app/admin/programs/$programId/route'
import { Route as AppAdminSetsIndexRouteImport } from './routes/app/admin/sets/index'
import { Route as AppAdminSetsSetIdRouteRouteImport } from './routes/app/admin/sets/$setId/route'
import { Route as AppAdminSetsNewRouteImport } from './routes/app/admin/sets/new'
import { Route as AppAdminSettingsIndexRouteImport } from './routes/app/admin/settings/index'
import { Route as AppAdminSettingsSettingIdRouteImport } from './routes/app/admin/settings/$settingId'
import { Route as AppAdminSettingsNewRouteImport } from './routes/app/admin/settings/new'
import { Route as AppAdminSurveysIndexRouteImport } from './routes/app/admin/surveys/index'
import { Route as AppAdminSurveysNewRouteImport } from './routes/app/admin/surveys/new'
import { Route as AppAdminTagsIndexRouteImport } from './routes/app/admin/tags/index'
import { Route as AppAdminTagsTagIdRouteImport } from './routes/app/admin/tags/$tagId'
import { Route as AppAdminTagsNewRouteImport } from './routes/app/admin/tags/new'
import { Route as AppAdminTermsIndexRouteImport } from './routes/app/admin/terms/index'
import { Route as AppAdminTermsTermIdRouteImport } from './routes/app/admin/terms/$termId'
import { Route as AppAdminTermsNewRouteImport } from './routes/app/admin/terms/new'
import { Route as AppAdminUsersIndexRouteImport } from './routes/app/admin/users/index'
import { Route as AppAdminUsersUserIdRouteRouteImport } from './routes/app/admin/users/$userId/route'
import { Route as AppAdminUsersNewRouteImport } from './routes/app/admin/users/new'
import { Route as AppDemosSetsIndexRouteImport } from './routes/app/demos/sets/index'
import { Route as AppOrganizationsOrganizationIdIndexRouteImport } from './routes/app/organizations/$organizationId/index'
import { Route as AppOrganizationsOrganizationIdAhsRouteRouteImport } from './routes/app/organizations/$organizationId/ahs/route'
import { Route as AppOrganizationsOrganizationIdBuilderRouteRouteImport } from './routes/app/organizations/$organizationId/builder/route'
import { Route as AppOrganizationsOrganizationIdPendingRouteRouteImport } from './routes/app/organizations/$organizationId/pending/route'
import { Route as AppOrganizationsOrganizationIdPlanRouteRouteImport } from './routes/app/organizations/$organizationId/plan/route'
import { Route as AppOrganizationsOrganizationIdQuickStartRouteRouteImport } from './routes/app/organizations/$organizationId/quick-start/route'
import { Route as AppOrganizationsOrganizationIdReportsRouteRouteImport } from './routes/app/organizations/$organizationId/reports/route'
import { Route as AppOrganizationsOrganizationIdSetsRouteRouteImport } from './routes/app/organizations/$organizationId/sets/route'
import { Route as AppOrganizationsOrganizationIdSurveysRouteRouteImport } from './routes/app/organizations/$organizationId/surveys/route'
import { Route as AppOrganizationsOrganizationIdTeamRouteRouteImport } from './routes/app/organizations/$organizationId/team/route'
import { Route as AppOrganizationsJoinIndexRouteImport } from './routes/app/organizations/join/index'
import { Route as AppOrganizationsJoinOrgtypeMachineNameRouteRouteImport } from './routes/app/organizations/join/$orgtypeMachineName/route'
import { Route as AppProgramsProgramIdRegisterRouteImport } from './routes/app/programs/$programId/register'
import { Route as AppResourcesAudioIdRouteImport } from './routes/app/resources/audio.$id'
import { Route as AppResourcesCollectionsIdRouteImport } from './routes/app/resources/collections.$id'
import { Route as AppResourcesCurriculaIdRouteImport } from './routes/app/resources/curricula.$id'
import { Route as AppResourcesMicrolearningsIdRouteImport } from './routes/app/resources/microlearnings.$id'
import { Route as AppResourcesTrainingsLocalIdRouteImport } from './routes/app/resources/trainings-local.$id'
import { Route as AppResourcesTrainingsOnDemandIdRouteImport } from './routes/app/resources/trainings-on-demand.$id'
import { Route as AppResourcesTrainingsVirtualIdRouteImport } from './routes/app/resources/trainings-virtual.$id'
import { Route as AppSurveyPreviewsSurveyIdIndexRouteImport } from './routes/app/survey-previews/$surveyId/index'
import { Route as AppSurveysSurveyOrganizationUuidIndexRouteImport } from './routes/app/surveys/$surveyOrganizationUuid/index'
import { Route as AppAccountRegisterVerificationIndexRouteImport } from './routes/app/account/register.verification.index'
import { Route as AppAccountTwcJoinIndexRouteImport } from './routes/app/account/twc/join/index'
import { Route as AppAccountTwcJoinOrgTypeRouteImport } from './routes/app/account/twc/join/$orgType'
import { Route as AppAdminDemosSetsIndexRouteImport } from './routes/app/admin/demos/sets/index'
import { Route as AppAdminDemosSetsDefaultRouteImport } from './routes/app/admin/demos/sets/default'
import { Route as AppAdminLmsAudioAudioIdRouteImport } from './routes/app/admin/lms/audio/$audioId'
import { Route as AppAdminLmsAudioNewRouteImport } from './routes/app/admin/lms/audio/new'
import { Route as AppAdminLmsCollectionsCollectionIdRouteImport } from './routes/app/admin/lms/collections/$collectionId'
import { Route as AppAdminLmsCollectionsNewRouteImport } from './routes/app/admin/lms/collections/new'
import { Route as AppAdminLmsCurriculaCurriculumIdRouteImport } from './routes/app/admin/lms/curricula/$curriculumId'
import { Route as AppAdminLmsCurriculaNewRouteImport } from './routes/app/admin/lms/curricula/new'
import { Route as AppAdminLmsMaterialsMaterialIdRouteImport } from './routes/app/admin/lms/materials/$materialId'
import { Route as AppAdminLmsMicrolearningsMicrolearningIdRouteImport } from './routes/app/admin/lms/microlearnings/$microlearningId'
import { Route as AppAdminLmsMicrolearningsNewRouteImport } from './routes/app/admin/lms/microlearnings/new'
import { Route as AppAdminLmsResourcesResourceIdRouteImport } from './routes/app/admin/lms/resources/$resourceId'
import { Route as AppAdminLmsResourcesNewRouteImport } from './routes/app/admin/lms/resources/new'
import { Route as AppAdminLmsTrainingsLocalTrainingIdRouteImport } from './routes/app/admin/lms/trainings-local/$trainingId'
import { Route as AppAdminLmsTrainingsLocalNewRouteImport } from './routes/app/admin/lms/trainings-local/new'
import { Route as AppAdminLmsTrainingsOnDemandTrainingIdRouteImport } from './routes/app/admin/lms/trainings-on-demand/$trainingId'
import { Route as AppAdminLmsTrainingsVirtualTrainingIdRouteImport } from './routes/app/admin/lms/trainings-virtual/$trainingId'
import { Route as AppAdminOrganizationsOrganizationIdIndexRouteImport } from './routes/app/admin/organizations/$organizationId/index'
import { Route as AppAdminOrganizationsOrganizationIdTeamRouteImport } from './routes/app/admin/organizations/$organizationId/team'
import { Route as AppAdminProgramsProgramIdIndexRouteImport } from './routes/app/admin/programs/$programId/index'
import { Route as AppAdminProgramsProgramIdOrganizationsRouteImport } from './routes/app/admin/programs/$programId/organizations'
import { Route as AppAdminProgramsProgramIdSetsRouteImport } from './routes/app/admin/programs/$programId/sets'
import { Route as AppAdminSetsSetIdIndexRouteImport } from './routes/app/admin/sets/$setId/index'
import { Route as AppAdminSetsSetIdCloneRouteImport } from './routes/app/admin/sets/$setId/clone'
import { Route as AppAdminSetsSetIdDemoRouteImport } from './routes/app/admin/sets/$setId/demo'
import { Route as AppAdminSetsSetIdModulesRouteRouteImport } from './routes/app/admin/sets/$setId/modules/route'
import { Route as AppAdminSetsSetIdQuestionsRouteRouteImport } from './routes/app/admin/sets/$setId/questions/route'
import { Route as AppAdminSurveysSurveyIdIndexRouteImport } from './routes/app/admin/surveys/$surveyId/index'
import { Route as AppAdminSurveysSurveyIdQuestionsRouteRouteImport } from './routes/app/admin/surveys/$surveyId/questions/route'
import { Route as AppAdminSurveysSurveyIdTopicsRouteRouteImport } from './routes/app/admin/surveys/$surveyId/topics/route'
import { Route as AppAdminUsersUserIdIndexRouteImport } from './routes/app/admin/users/$userId/index'
import { Route as AppAdminUsersUserIdOrganizationsRouteRouteImport } from './routes/app/admin/users/$userId/organizations/route'
import { Route as AppAdminUsersUserIdPendingRouteImport } from './routes/app/admin/users/$userId/pending'
import { Route as AppDeeplinksProgramsProgramIdIndexRouteImport } from './routes/app/deeplinks/programs/$programId/index'
import { Route as AppDemosSetsSetIdIndexRouteImport } from './routes/app/demos/sets/$setId/index'
import { Route as AppOrganizationsOrganizationIdBuilderIndexRouteImport } from './routes/app/organizations/$organizationId/builder/index'
import { Route as AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteImport } from './routes/app/organizations/$organizationId/builder/$docbuilderSlug'
import { Route as AppOrganizationsOrganizationIdOverviewIndexRouteImport } from './routes/app/organizations/$organizationId/overview/index'
import { Route as AppOrganizationsOrganizationIdOverviewTabRouteImport } from './routes/app/organizations/$organizationId/overview/$tab'
import { Route as AppOrganizationsOrganizationIdPlanIndexRouteImport } from './routes/app/organizations/$organizationId/plan/index'
import { Route as AppOrganizationsOrganizationIdQuickStartIndexRouteImport } from './routes/app/organizations/$organizationId/quick-start/index'
import { Route as AppOrganizationsOrganizationIdReportsIndexRouteImport } from './routes/app/organizations/$organizationId/reports/index'
import { Route as AppOrganizationsOrganizationIdSetsIndexRouteImport } from './routes/app/organizations/$organizationId/sets/index'
import { Route as AppOrganizationsOrganizationIdSetsSetIdRouteRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/route'
import { Route as AppOrganizationsOrganizationIdSurveysSurveyIdRouteImport } from './routes/app/organizations/$organizationId/surveys/$surveyId'
import { Route as AppOrganizationsOrganizationIdTeamInviteRouteImport } from './routes/app/organizations/$organizationId/team/invite'
import { Route as AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRouteImport } from './routes/app/organizations/join/$orgtypeMachineName/$organizationId'
import { Route as AppOrganizationsJoinOrgtypeMachineNameFindRouteImport } from './routes/app/organizations/join/$orgtypeMachineName/find'
import { Route as AppProgramsProgramIdOrganizationsIndexRouteImport } from './routes/app/programs/$programId/organizations/index'
import { Route as AppSurveyPreviewsSurveyIdLanguageIdIndexRouteImport } from './routes/app/survey-previews/$surveyId/$languageId/index'
import { Route as AppSurveyPreviewsSurveyIdLanguageIdConfirmationRouteImport } from './routes/app/survey-previews/$surveyId/$languageId/confirmation'
import { Route as AppSurveysSurveyOrganizationUuidLanguageIdIndexRouteImport } from './routes/app/surveys/$surveyOrganizationUuid/$languageId/index'
import { Route as AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRouteImport } from './routes/app/surveys/$surveyOrganizationUuid/$languageId/confirmation'
import { Route as AppAccountRegisterVerificationUrlEncodedUrlRouteImport } from './routes/app/account/register.verification.url.$encodedUrl'
import { Route as AppAccountTwcJoinOrgTypeOrgIdRouteImport } from './routes/app/account/twc/join/$orgType.$orgId'
import { Route as AppAdminSetsSetIdModulesIndexRouteImport } from './routes/app/admin/sets/$setId/modules/index'
import { Route as AppAdminSetsSetIdModulesModuleIdRouteImport } from './routes/app/admin/sets/$setId/modules/$moduleId'
import { Route as AppAdminSetsSetIdModulesNewRouteImport } from './routes/app/admin/sets/$setId/modules/new'
import { Route as AppAdminSetsSetIdQuestionsIndexRouteImport } from './routes/app/admin/sets/$setId/questions/index'
import { Route as AppAdminSetsSetIdQuestionsQuestionIdRouteImport } from './routes/app/admin/sets/$setId/questions/$questionId'
import { Route as AppAdminSetsSetIdQuestionsNewRouteImport } from './routes/app/admin/sets/$setId/questions/new'
import { Route as AppAdminSurveysSurveyIdQuestionsIndexRouteImport } from './routes/app/admin/surveys/$surveyId/questions/index'
import { Route as AppAdminSurveysSurveyIdQuestionsQuestionIdRouteImport } from './routes/app/admin/surveys/$surveyId/questions/$questionId'
import { Route as AppAdminSurveysSurveyIdQuestionsNewRouteImport } from './routes/app/admin/surveys/$surveyId/questions/new'
import { Route as AppAdminSurveysSurveyIdTopicsIndexRouteImport } from './routes/app/admin/surveys/$surveyId/topics/index'
import { Route as AppAdminSurveysSurveyIdTopicsTopicIdRouteImport } from './routes/app/admin/surveys/$surveyId/topics/$topicId'
import { Route as AppAdminSurveysSurveyIdTopicsNewRouteImport } from './routes/app/admin/surveys/$surveyId/topics/new'
import { Route as AppAdminUsersUserIdOrganizationsIndexRouteImport } from './routes/app/admin/users/$userId/organizations/index'
import { Route as AppAdminUsersUserIdOrganizationsOrganizationIdRouteImport } from './routes/app/admin/users/$userId/organizations/$organizationId'
import { Route as AppDemosSetsSetIdViewIndexRouteImport } from './routes/app/demos/sets/$setId/view/index'
import { Route as AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRouteImport } from './routes/app/organizations/$organizationId/builder/$docbuilderSlug.index'
import { Route as AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteImport } from './routes/app/organizations/$organizationId/builder/$docbuilderSlug.$format'
import { Route as AppOrganizationsOrganizationIdPlanItemsItemIdRouteImport } from './routes/app/organizations/$organizationId/plan/items/$itemId'
import { Route as AppOrganizationsOrganizationIdPlanItemsNewRouteImport } from './routes/app/organizations/$organizationId/plan/items/new'
import { Route as AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteImport } from './routes/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/route'
import { Route as AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteImport } from './routes/app/organizations/$organizationId/reports/children.$childOrgTypeMachineName'
import { Route as AppOrganizationsOrganizationIdReportsModulesModuleIdRouteImport } from './routes/app/organizations/$organizationId/reports/modules.$moduleId'
import { Route as AppOrganizationsOrganizationIdReportsSetsSetIdRouteImport } from './routes/app/organizations/$organizationId/reports/sets.$setId'
import { Route as AppOrganizationsOrganizationIdSetsSetIdIndexRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/index'
import { Route as AppOrganizationsOrganizationIdSetsSetIdCalculatorRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/calculator'
import { Route as AppOrganizationsOrganizationIdSetsSetIdGlossaryRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/glossary'
import { Route as AppOrganizationsOrganizationIdSetsSetIdReportRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/report'
import { Route as AppAccountTwcJoinOrgTypeOrgIdUfcIdRouteImport } from './routes/app/account/twc/join/$orgType.$orgId.$ufcId'
import { Route as AppDeeplinksProgramsProgramIdSetsSetIdIndexRouteImport } from './routes/app/deeplinks/programs/$programId/sets/$setId/index'
import { Route as AppDemosSetsSetIdViewActiveDemoViewIndexRouteImport } from './routes/app/demos/sets/$setId/view/$activeDemoView/index'
import { Route as AppDemosSetsSetIdViewActiveDemoViewQuestionIdRouteImport } from './routes/app/demos/sets/$setId/view/$activeDemoView/$questionId'
import { Route as AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRouteImport } from './routes/app/organizations/$organizationId/builder/$docbuilderSlug.$format.index'
import { Route as AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRouteImport } from './routes/app/organizations/$organizationId/builder/$docbuilderSlug.$format.$subsectionId'
import { Route as AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRouteImport } from './routes/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/index'
import { Route as AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRouteImport } from './routes/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide'
import { Route as AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRouteImport } from './routes/app/organizations/$organizationId/reports/children.$childOrgTypeMachineName.index'
import { Route as AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/modules.$moduleId'
import { Route as AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/questions.$questionId'
import { Route as AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRouteImport } from './routes/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId'
import { Route as AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRouteImport } from './routes/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId'
import { Route as AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRouteImport } from './routes/app/organizations/$organizationId/reports/children.$childOrgTypeMachineName.modules.$moduleId'
import { Route as AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRouteImport } from './routes/app/organizations/$organizationId/reports/children.$childOrgTypeMachineName.sets.$setId'
import { Route as AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRouteImport } from './routes/app/organizations/$organizationId/sets/$setId/report/download.$format'
import { Route as AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRouteImport } from './routes/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator'
import { Route as AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRouteImport } from './routes/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRouteRoute = AppAccountRouteRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeeplinksRouteRoute = AppDeeplinksRouteRouteImport.update({
  id: '/deeplinks',
  path: '/deeplinks',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationsRouteRoute = AppOrganizationsRouteRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourcesRouteRoute = AppResourcesRouteRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountCurriculaRoute = AppAccountCurriculaRouteImport.update({
  id: '/curricula',
  path: '/curricula',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountDashboardRoute = AppAccountDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountDeactivateRoute = AppAccountDeactivateRouteImport.update({
  id: '/deactivate',
  path: '/deactivate',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountFavoritesRoute = AppAccountFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountForgotRoute = AppAccountForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountLoggedOutRoute = AppAccountLoggedOutRouteImport.update({
  id: '/logged-out',
  path: '/logged-out',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountLoginRoute = AppAccountLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountLogoutRoute = AppAccountLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountProfileRoute = AppAccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountReactivateRoute = AppAccountReactivateRouteImport.update({
  id: '/reactivate',
  path: '/reactivate',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountWelcomeBackRoute = AppAccountWelcomeBackRouteImport.update({
  id: '/welcome-back',
  path: '/welcome-back',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminActivityLogRoute = AppAdminActivityLogRouteImport.update({
  id: '/activity-log',
  path: '/activity-log',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminContentRouteRoute = AppAdminContentRouteRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCriteriaRouteRoute = AppAdminCriteriaRouteRouteImport.update({
  id: '/criteria',
  path: '/criteria',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCriterionTopicsRouteRoute =
  AppAdminCriterionTopicsRouteRouteImport.update({
    id: '/criterion-topics',
    path: '/criterion-topics',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminDemosRoute = AppAdminDemosRouteImport.update({
  id: '/demos',
  path: '/demos',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminGuidesRoute = AppAdminGuidesRouteImport.update({
  id: '/guides',
  path: '/guides',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminLmsRouteRoute = AppAdminLmsRouteRouteImport.update({
  id: '/lms',
  path: '/lms',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminMetricsRoute = AppAdminMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrganizationsRouteRoute =
  AppAdminOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminPendingRouteRoute = AppAdminPendingRouteRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminProgramsRouteRoute = AppAdminProgramsRouteRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSetsRouteRoute = AppAdminSetsRouteRouteImport.update({
  id: '/sets',
  path: '/sets',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSettingsRouteRoute = AppAdminSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSurveysRouteRoute = AppAdminSurveysRouteRouteImport.update({
  id: '/surveys',
  path: '/surveys',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminTagsRouteRoute = AppAdminTagsRouteRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminTermsRouteRoute = AppAdminTermsRouteRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUsersRouteRoute = AppAdminUsersRouteRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppDeeplinkQuestionQuestionIdRoute =
  AppDeeplinkQuestionQuestionIdRouteImport.update({
    id: '/deeplink-question/$questionId',
    path: '/deeplink-question/$questionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppDeeplinkSetSetIdRoute = AppDeeplinkSetSetIdRouteImport.update({
  id: '/deeplink-set/$setId',
  path: '/deeplink-set/$setId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeeplinksPlanRoute = AppDeeplinksPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AppDeeplinksRouteRoute,
} as any)
const AppDeeplinksTeamRoute = AppDeeplinksTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppDeeplinksRouteRoute,
} as any)
const AppDemosIndexRoute = AppDemosIndexRouteImport.update({
  id: '/demos/',
  path: '/demos/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMaterialsMaterialIdRoute = AppMaterialsMaterialIdRouteImport.update({
  id: '/materials/$materialId',
  path: '/materials/$materialId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationsIndexRoute = AppOrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizationsRouteRoute,
} as any)
const AppOrganizationsOrganizationIdRouteRoute =
  AppOrganizationsOrganizationIdRouteRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AppOrganizationsRouteRoute,
  } as any)
const AppProgramsIndexRoute = AppProgramsIndexRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProgramsProgramIdRoute = AppProgramsProgramIdRouteImport.update({
  id: '/programs/$programId',
  path: '/programs/$programId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppResourcesIndexRoute = AppResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppResourcesRouteRoute,
} as any)
const AppResourcesResourceIdRoute = AppResourcesResourceIdRouteImport.update({
  id: '/$resourceId',
  path: '/$resourceId',
  getParentRoute: () => AppResourcesRouteRoute,
} as any)
const AppSurveyPreviewsSurveyIdRouteRoute =
  AppSurveyPreviewsSurveyIdRouteRouteImport.update({
    id: '/survey-previews/$surveyId',
    path: '/survey-previews/$surveyId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSurveysSurveyOrganizationUuidRouteRoute =
  AppSurveysSurveyOrganizationUuidRouteRouteImport.update({
    id: '/surveys/$surveyOrganizationUuid',
    path: '/surveys/$surveyOrganizationUuid',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAccountActivityLogSplatRoute =
  AppAccountActivityLogSplatRouteImport.update({
    id: '/activity-log/$',
    path: '/activity-log/$',
    getParentRoute: () => AppAccountRouteRoute,
  } as any)
const AppAccountRedeemInviteInviteTokenRoute =
  AppAccountRedeemInviteInviteTokenRouteImport.update({
    id: '/redeem-invite/$inviteToken',
    path: '/redeem-invite/$inviteToken',
    getParentRoute: () => AppAccountRouteRoute,
  } as any)
const AppAccountRegisterIndexRoute = AppAccountRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountRegisterVerificationRoute =
  AppAccountRegisterVerificationRouteImport.update({
    id: '/register/verification',
    path: '/register/verification',
    getParentRoute: () => AppAccountRouteRoute,
  } as any)
const AppAccountResetPasswordTokenRoute =
  AppAccountResetPasswordTokenRouteImport.update({
    id: '/reset-password/$token',
    path: '/reset-password/$token',
    getParentRoute: () => AppAccountRouteRoute,
  } as any)
const AppAccountTwcIndexRoute = AppAccountTwcIndexRouteImport.update({
  id: '/twc/',
  path: '/twc/',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountTwcJoinRouteRoute = AppAccountTwcJoinRouteRouteImport.update({
  id: '/twc/join',
  path: '/twc/join',
  getParentRoute: () => AppAccountRouteRoute,
} as any)
const AppAccountWelcomeBackTokenRoute =
  AppAccountWelcomeBackTokenRouteImport.update({
    id: '/$token',
    path: '/$token',
    getParentRoute: () => AppAccountWelcomeBackRoute,
  } as any)
const AppAdminContentIndexRoute = AppAdminContentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminContentRouteRoute,
} as any)
const AppAdminContentContentIdRoute =
  AppAdminContentContentIdRouteImport.update({
    id: '/$contentId',
    path: '/$contentId',
    getParentRoute: () => AppAdminContentRouteRoute,
  } as any)
const AppAdminContentNewRoute = AppAdminContentNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminContentRouteRoute,
} as any)
const AppAdminCriteriaIndexRoute = AppAdminCriteriaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminCriteriaRouteRoute,
} as any)
const AppAdminCriteriaCriterionIdRoute =
  AppAdminCriteriaCriterionIdRouteImport.update({
    id: '/$criterionId',
    path: '/$criterionId',
    getParentRoute: () => AppAdminCriteriaRouteRoute,
  } as any)
const AppAdminCriteriaNewRoute = AppAdminCriteriaNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminCriteriaRouteRoute,
} as any)
const AppAdminCriterionTopicsIndexRoute =
  AppAdminCriterionTopicsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminCriterionTopicsRouteRoute,
  } as any)
const AppAdminCriterionTopicsCriterionTopicIdRoute =
  AppAdminCriterionTopicsCriterionTopicIdRouteImport.update({
    id: '/$criterionTopicId',
    path: '/$criterionTopicId',
    getParentRoute: () => AppAdminCriterionTopicsRouteRoute,
  } as any)
const AppAdminCriterionTopicsNewRoute =
  AppAdminCriterionTopicsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminCriterionTopicsRouteRoute,
  } as any)
const AppAdminDemosIndexRoute = AppAdminDemosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminDemosRoute,
} as any)
const AppAdminGuidesIndexRoute = AppAdminGuidesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminGuidesRoute,
} as any)
const AppAdminLmsIndexRoute = AppAdminLmsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminLmsRouteRoute,
} as any)
const AppAdminLmsAudioRouteRoute = AppAdminLmsAudioRouteRouteImport.update({
  id: '/audio',
  path: '/audio',
  getParentRoute: () => AppAdminLmsRouteRoute,
} as any)
const AppAdminLmsCollectionsRouteRoute =
  AppAdminLmsCollectionsRouteRouteImport.update({
    id: '/collections',
    path: '/collections',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminLmsCurriculaRouteRoute =
  AppAdminLmsCurriculaRouteRouteImport.update({
    id: '/curricula',
    path: '/curricula',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminLmsMicrolearningsRouteRoute =
  AppAdminLmsMicrolearningsRouteRouteImport.update({
    id: '/microlearnings',
    path: '/microlearnings',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminLmsResourcesRouteRoute =
  AppAdminLmsResourcesRouteRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminLmsTrainingsLocalRouteRoute =
  AppAdminLmsTrainingsLocalRouteRouteImport.update({
    id: '/trainings-local',
    path: '/trainings-local',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminOrganizationsIndexRoute =
  AppAdminOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminOrganizationsRouteRoute,
  } as any)
const AppAdminOrganizationsOrganizationIdRouteRoute =
  AppAdminOrganizationsOrganizationIdRouteRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AppAdminOrganizationsRouteRoute,
  } as any)
const AppAdminPendingInvitesRoute = AppAdminPendingInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppAdminPendingRouteRoute,
} as any)
const AppAdminPendingRequestsRoute = AppAdminPendingRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppAdminPendingRouteRoute,
} as any)
const AppAdminProgramsIndexRoute = AppAdminProgramsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminProgramsRouteRoute,
} as any)
const AppAdminProgramsProgramIdRouteRoute =
  AppAdminProgramsProgramIdRouteRouteImport.update({
    id: '/$programId',
    path: '/$programId',
    getParentRoute: () => AppAdminProgramsRouteRoute,
  } as any)
const AppAdminSetsIndexRoute = AppAdminSetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSetsRouteRoute,
} as any)
const AppAdminSetsSetIdRouteRoute = AppAdminSetsSetIdRouteRouteImport.update({
  id: '/$setId',
  path: '/$setId',
  getParentRoute: () => AppAdminSetsRouteRoute,
} as any)
const AppAdminSetsNewRoute = AppAdminSetsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminSetsRouteRoute,
} as any)
const AppAdminSettingsIndexRoute = AppAdminSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSettingsRouteRoute,
} as any)
const AppAdminSettingsSettingIdRoute =
  AppAdminSettingsSettingIdRouteImport.update({
    id: '/$settingId',
    path: '/$settingId',
    getParentRoute: () => AppAdminSettingsRouteRoute,
  } as any)
const AppAdminSettingsNewRoute = AppAdminSettingsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminSettingsRouteRoute,
} as any)
const AppAdminSurveysIndexRoute = AppAdminSurveysIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSurveysRouteRoute,
} as any)
const AppAdminSurveysNewRoute = AppAdminSurveysNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminSurveysRouteRoute,
} as any)
const AppAdminTagsIndexRoute = AppAdminTagsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminTagsRouteRoute,
} as any)
const AppAdminTagsTagIdRoute = AppAdminTagsTagIdRouteImport.update({
  id: '/$tagId',
  path: '/$tagId',
  getParentRoute: () => AppAdminTagsRouteRoute,
} as any)
const AppAdminTagsNewRoute = AppAdminTagsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminTagsRouteRoute,
} as any)
const AppAdminTermsIndexRoute = AppAdminTermsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminTermsRouteRoute,
} as any)
const AppAdminTermsTermIdRoute = AppAdminTermsTermIdRouteImport.update({
  id: '/$termId',
  path: '/$termId',
  getParentRoute: () => AppAdminTermsRouteRoute,
} as any)
const AppAdminTermsNewRoute = AppAdminTermsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminTermsRouteRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminUsersRouteRoute,
} as any)
const AppAdminUsersUserIdRouteRoute =
  AppAdminUsersUserIdRouteRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppAdminUsersRouteRoute,
  } as any)
const AppAdminUsersNewRoute = AppAdminUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminUsersRouteRoute,
} as any)
const AppDemosSetsIndexRoute = AppDemosSetsIndexRouteImport.update({
  id: '/demos/sets/',
  path: '/demos/sets/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationsOrganizationIdIndexRoute =
  AppOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdAhsRouteRoute =
  AppOrganizationsOrganizationIdAhsRouteRouteImport.update({
    id: '/ahs',
    path: '/ahs',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdBuilderRouteRoute =
  AppOrganizationsOrganizationIdBuilderRouteRouteImport.update({
    id: '/builder',
    path: '/builder',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdPendingRouteRoute =
  AppOrganizationsOrganizationIdPendingRouteRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdPlanRouteRoute =
  AppOrganizationsOrganizationIdPlanRouteRouteImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdQuickStartRouteRoute =
  AppOrganizationsOrganizationIdQuickStartRouteRouteImport.update({
    id: '/quick-start',
    path: '/quick-start',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdReportsRouteRoute =
  AppOrganizationsOrganizationIdReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsRouteRoute =
  AppOrganizationsOrganizationIdSetsRouteRouteImport.update({
    id: '/sets',
    path: '/sets',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSurveysRouteRoute =
  AppOrganizationsOrganizationIdSurveysRouteRouteImport.update({
    id: '/surveys',
    path: '/surveys',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdTeamRouteRoute =
  AppOrganizationsOrganizationIdTeamRouteRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsJoinIndexRoute =
  AppOrganizationsJoinIndexRouteImport.update({
    id: '/join/',
    path: '/join/',
    getParentRoute: () => AppOrganizationsRouteRoute,
  } as any)
const AppOrganizationsJoinOrgtypeMachineNameRouteRoute =
  AppOrganizationsJoinOrgtypeMachineNameRouteRouteImport.update({
    id: '/join/$orgtypeMachineName',
    path: '/join/$orgtypeMachineName',
    getParentRoute: () => AppOrganizationsRouteRoute,
  } as any)
const AppProgramsProgramIdRegisterRoute =
  AppProgramsProgramIdRegisterRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => AppProgramsProgramIdRoute,
  } as any)
const AppResourcesAudioIdRoute = AppResourcesAudioIdRouteImport.update({
  id: '/audio/$id',
  path: '/audio/$id',
  getParentRoute: () => AppResourcesRouteRoute,
} as any)
const AppResourcesCollectionsIdRoute =
  AppResourcesCollectionsIdRouteImport.update({
    id: '/collections/$id',
    path: '/collections/$id',
    getParentRoute: () => AppResourcesRouteRoute,
  } as any)
const AppResourcesCurriculaIdRoute = AppResourcesCurriculaIdRouteImport.update({
  id: '/curricula/$id',
  path: '/curricula/$id',
  getParentRoute: () => AppResourcesRouteRoute,
} as any)
const AppResourcesMicrolearningsIdRoute =
  AppResourcesMicrolearningsIdRouteImport.update({
    id: '/microlearnings/$id',
    path: '/microlearnings/$id',
    getParentRoute: () => AppResourcesRouteRoute,
  } as any)
const AppResourcesTrainingsLocalIdRoute =
  AppResourcesTrainingsLocalIdRouteImport.update({
    id: '/trainings-local/$id',
    path: '/trainings-local/$id',
    getParentRoute: () => AppResourcesRouteRoute,
  } as any)
const AppResourcesTrainingsOnDemandIdRoute =
  AppResourcesTrainingsOnDemandIdRouteImport.update({
    id: '/trainings-on-demand/$id',
    path: '/trainings-on-demand/$id',
    getParentRoute: () => AppResourcesRouteRoute,
  } as any)
const AppResourcesTrainingsVirtualIdRoute =
  AppResourcesTrainingsVirtualIdRouteImport.update({
    id: '/trainings-virtual/$id',
    path: '/trainings-virtual/$id',
    getParentRoute: () => AppResourcesRouteRoute,
  } as any)
const AppSurveyPreviewsSurveyIdIndexRoute =
  AppSurveyPreviewsSurveyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSurveyPreviewsSurveyIdRouteRoute,
  } as any)
const AppSurveysSurveyOrganizationUuidIndexRoute =
  AppSurveysSurveyOrganizationUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSurveysSurveyOrganizationUuidRouteRoute,
  } as any)
const AppAccountRegisterVerificationIndexRoute =
  AppAccountRegisterVerificationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAccountRegisterVerificationRoute,
  } as any)
const AppAccountTwcJoinIndexRoute = AppAccountTwcJoinIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountTwcJoinRouteRoute,
} as any)
const AppAccountTwcJoinOrgTypeRoute =
  AppAccountTwcJoinOrgTypeRouteImport.update({
    id: '/$orgType',
    path: '/$orgType',
    getParentRoute: () => AppAccountTwcJoinRouteRoute,
  } as any)
const AppAdminDemosSetsIndexRoute = AppAdminDemosSetsIndexRouteImport.update({
  id: '/sets/',
  path: '/sets/',
  getParentRoute: () => AppAdminDemosRoute,
} as any)
const AppAdminDemosSetsDefaultRoute =
  AppAdminDemosSetsDefaultRouteImport.update({
    id: '/sets/default',
    path: '/sets/default',
    getParentRoute: () => AppAdminDemosRoute,
  } as any)
const AppAdminLmsAudioAudioIdRoute = AppAdminLmsAudioAudioIdRouteImport.update({
  id: '/$audioId',
  path: '/$audioId',
  getParentRoute: () => AppAdminLmsAudioRouteRoute,
} as any)
const AppAdminLmsAudioNewRoute = AppAdminLmsAudioNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminLmsAudioRouteRoute,
} as any)
const AppAdminLmsCollectionsCollectionIdRoute =
  AppAdminLmsCollectionsCollectionIdRouteImport.update({
    id: '/$collectionId',
    path: '/$collectionId',
    getParentRoute: () => AppAdminLmsCollectionsRouteRoute,
  } as any)
const AppAdminLmsCollectionsNewRoute =
  AppAdminLmsCollectionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminLmsCollectionsRouteRoute,
  } as any)
const AppAdminLmsCurriculaCurriculumIdRoute =
  AppAdminLmsCurriculaCurriculumIdRouteImport.update({
    id: '/$curriculumId',
    path: '/$curriculumId',
    getParentRoute: () => AppAdminLmsCurriculaRouteRoute,
  } as any)
const AppAdminLmsCurriculaNewRoute = AppAdminLmsCurriculaNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminLmsCurriculaRouteRoute,
} as any)
const AppAdminLmsMaterialsMaterialIdRoute =
  AppAdminLmsMaterialsMaterialIdRouteImport.update({
    id: '/materials/$materialId',
    path: '/materials/$materialId',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminLmsMicrolearningsMicrolearningIdRoute =
  AppAdminLmsMicrolearningsMicrolearningIdRouteImport.update({
    id: '/$microlearningId',
    path: '/$microlearningId',
    getParentRoute: () => AppAdminLmsMicrolearningsRouteRoute,
  } as any)
const AppAdminLmsMicrolearningsNewRoute =
  AppAdminLmsMicrolearningsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminLmsMicrolearningsRouteRoute,
  } as any)
const AppAdminLmsResourcesResourceIdRoute =
  AppAdminLmsResourcesResourceIdRouteImport.update({
    id: '/$resourceId',
    path: '/$resourceId',
    getParentRoute: () => AppAdminLmsResourcesRouteRoute,
  } as any)
const AppAdminLmsResourcesNewRoute = AppAdminLmsResourcesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminLmsResourcesRouteRoute,
} as any)
const AppAdminLmsTrainingsLocalTrainingIdRoute =
  AppAdminLmsTrainingsLocalTrainingIdRouteImport.update({
    id: '/$trainingId',
    path: '/$trainingId',
    getParentRoute: () => AppAdminLmsTrainingsLocalRouteRoute,
  } as any)
const AppAdminLmsTrainingsLocalNewRoute =
  AppAdminLmsTrainingsLocalNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminLmsTrainingsLocalRouteRoute,
  } as any)
const AppAdminLmsTrainingsOnDemandTrainingIdRoute =
  AppAdminLmsTrainingsOnDemandTrainingIdRouteImport.update({
    id: '/trainings-on-demand/$trainingId',
    path: '/trainings-on-demand/$trainingId',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminLmsTrainingsVirtualTrainingIdRoute =
  AppAdminLmsTrainingsVirtualTrainingIdRouteImport.update({
    id: '/trainings-virtual/$trainingId',
    path: '/trainings-virtual/$trainingId',
    getParentRoute: () => AppAdminLmsRouteRoute,
  } as any)
const AppAdminOrganizationsOrganizationIdIndexRoute =
  AppAdminOrganizationsOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppAdminOrganizationsOrganizationIdTeamRoute =
  AppAdminOrganizationsOrganizationIdTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AppAdminOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppAdminProgramsProgramIdIndexRoute =
  AppAdminProgramsProgramIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminProgramsProgramIdRouteRoute,
  } as any)
const AppAdminProgramsProgramIdOrganizationsRoute =
  AppAdminProgramsProgramIdOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AppAdminProgramsProgramIdRouteRoute,
  } as any)
const AppAdminProgramsProgramIdSetsRoute =
  AppAdminProgramsProgramIdSetsRouteImport.update({
    id: '/sets',
    path: '/sets',
    getParentRoute: () => AppAdminProgramsProgramIdRouteRoute,
  } as any)
const AppAdminSetsSetIdIndexRoute = AppAdminSetsSetIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminSetsSetIdRouteRoute,
} as any)
const AppAdminSetsSetIdCloneRoute = AppAdminSetsSetIdCloneRouteImport.update({
  id: '/clone',
  path: '/clone',
  getParentRoute: () => AppAdminSetsSetIdRouteRoute,
} as any)
const AppAdminSetsSetIdDemoRoute = AppAdminSetsSetIdDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => AppAdminSetsSetIdRouteRoute,
} as any)
const AppAdminSetsSetIdModulesRouteRoute =
  AppAdminSetsSetIdModulesRouteRouteImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => AppAdminSetsSetIdRouteRoute,
  } as any)
const AppAdminSetsSetIdQuestionsRouteRoute =
  AppAdminSetsSetIdQuestionsRouteRouteImport.update({
    id: '/questions',
    path: '/questions',
    getParentRoute: () => AppAdminSetsSetIdRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdIndexRoute =
  AppAdminSurveysSurveyIdIndexRouteImport.update({
    id: '/$surveyId/',
    path: '/$surveyId/',
    getParentRoute: () => AppAdminSurveysRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdQuestionsRouteRoute =
  AppAdminSurveysSurveyIdQuestionsRouteRouteImport.update({
    id: '/$surveyId/questions',
    path: '/$surveyId/questions',
    getParentRoute: () => AppAdminSurveysRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdTopicsRouteRoute =
  AppAdminSurveysSurveyIdTopicsRouteRouteImport.update({
    id: '/$surveyId/topics',
    path: '/$surveyId/topics',
    getParentRoute: () => AppAdminSurveysRouteRoute,
  } as any)
const AppAdminUsersUserIdIndexRoute =
  AppAdminUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppAdminUsersUserIdOrganizationsRouteRoute =
  AppAdminUsersUserIdOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppAdminUsersUserIdPendingRoute =
  AppAdminUsersUserIdPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppDeeplinksProgramsProgramIdIndexRoute =
  AppDeeplinksProgramsProgramIdIndexRouteImport.update({
    id: '/programs/$programId/',
    path: '/programs/$programId/',
    getParentRoute: () => AppDeeplinksRouteRoute,
  } as any)
const AppDemosSetsSetIdIndexRoute = AppDemosSetsSetIdIndexRouteImport.update({
  id: '/demos/sets/$setId/',
  path: '/demos/sets/$setId/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrganizationsOrganizationIdBuilderIndexRoute =
  AppOrganizationsOrganizationIdBuilderIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdBuilderRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteImport.update({
    id: '/$docbuilderSlug',
    path: '/$docbuilderSlug',
    getParentRoute: () => AppOrganizationsOrganizationIdBuilderRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdOverviewIndexRoute =
  AppOrganizationsOrganizationIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdOverviewTabRoute =
  AppOrganizationsOrganizationIdOverviewTabRouteImport.update({
    id: '/overview/$tab',
    path: '/overview/$tab',
    getParentRoute: () => AppOrganizationsOrganizationIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdPlanIndexRoute =
  AppOrganizationsOrganizationIdPlanIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdPlanRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdQuickStartIndexRoute =
  AppOrganizationsOrganizationIdQuickStartIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdQuickStartRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdReportsIndexRoute =
  AppOrganizationsOrganizationIdReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdReportsRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsIndexRoute =
  AppOrganizationsOrganizationIdSetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsSetIdRouteRoute =
  AppOrganizationsOrganizationIdSetsSetIdRouteRouteImport.update({
    id: '/$setId',
    path: '/$setId',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSurveysSurveyIdRoute =
  AppOrganizationsOrganizationIdSurveysSurveyIdRouteImport.update({
    id: '/$surveyId',
    path: '/$surveyId',
    getParentRoute: () => AppOrganizationsOrganizationIdSurveysRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdTeamInviteRoute =
  AppOrganizationsOrganizationIdTeamInviteRouteImport.update({
    id: '/invite',
    path: '/invite',
    getParentRoute: () => AppOrganizationsOrganizationIdTeamRouteRoute,
  } as any)
const AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute =
  AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AppOrganizationsJoinOrgtypeMachineNameRouteRoute,
  } as any)
const AppOrganizationsJoinOrgtypeMachineNameFindRoute =
  AppOrganizationsJoinOrgtypeMachineNameFindRouteImport.update({
    id: '/find',
    path: '/find',
    getParentRoute: () => AppOrganizationsJoinOrgtypeMachineNameRouteRoute,
  } as any)
const AppProgramsProgramIdOrganizationsIndexRoute =
  AppProgramsProgramIdOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AppProgramsProgramIdRoute,
  } as any)
const AppSurveyPreviewsSurveyIdLanguageIdIndexRoute =
  AppSurveyPreviewsSurveyIdLanguageIdIndexRouteImport.update({
    id: '/$languageId/',
    path: '/$languageId/',
    getParentRoute: () => AppSurveyPreviewsSurveyIdRouteRoute,
  } as any)
const AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute =
  AppSurveyPreviewsSurveyIdLanguageIdConfirmationRouteImport.update({
    id: '/$languageId/confirmation',
    path: '/$languageId/confirmation',
    getParentRoute: () => AppSurveyPreviewsSurveyIdRouteRoute,
  } as any)
const AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute =
  AppSurveysSurveyOrganizationUuidLanguageIdIndexRouteImport.update({
    id: '/$languageId/',
    path: '/$languageId/',
    getParentRoute: () => AppSurveysSurveyOrganizationUuidRouteRoute,
  } as any)
const AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute =
  AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRouteImport.update({
    id: '/$languageId/confirmation',
    path: '/$languageId/confirmation',
    getParentRoute: () => AppSurveysSurveyOrganizationUuidRouteRoute,
  } as any)
const AppAccountRegisterVerificationUrlEncodedUrlRoute =
  AppAccountRegisterVerificationUrlEncodedUrlRouteImport.update({
    id: '/url/$encodedUrl',
    path: '/url/$encodedUrl',
    getParentRoute: () => AppAccountRegisterVerificationRoute,
  } as any)
const AppAccountTwcJoinOrgTypeOrgIdRoute =
  AppAccountTwcJoinOrgTypeOrgIdRouteImport.update({
    id: '/$orgId',
    path: '/$orgId',
    getParentRoute: () => AppAccountTwcJoinOrgTypeRoute,
  } as any)
const AppAdminSetsSetIdModulesIndexRoute =
  AppAdminSetsSetIdModulesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSetsSetIdModulesRouteRoute,
  } as any)
const AppAdminSetsSetIdModulesModuleIdRoute =
  AppAdminSetsSetIdModulesModuleIdRouteImport.update({
    id: '/$moduleId',
    path: '/$moduleId',
    getParentRoute: () => AppAdminSetsSetIdModulesRouteRoute,
  } as any)
const AppAdminSetsSetIdModulesNewRoute =
  AppAdminSetsSetIdModulesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSetsSetIdModulesRouteRoute,
  } as any)
const AppAdminSetsSetIdQuestionsIndexRoute =
  AppAdminSetsSetIdQuestionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSetsSetIdQuestionsRouteRoute,
  } as any)
const AppAdminSetsSetIdQuestionsQuestionIdRoute =
  AppAdminSetsSetIdQuestionsQuestionIdRouteImport.update({
    id: '/$questionId',
    path: '/$questionId',
    getParentRoute: () => AppAdminSetsSetIdQuestionsRouteRoute,
  } as any)
const AppAdminSetsSetIdQuestionsNewRoute =
  AppAdminSetsSetIdQuestionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSetsSetIdQuestionsRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdQuestionsIndexRoute =
  AppAdminSurveysSurveyIdQuestionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSurveysSurveyIdQuestionsRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdQuestionsQuestionIdRoute =
  AppAdminSurveysSurveyIdQuestionsQuestionIdRouteImport.update({
    id: '/$questionId',
    path: '/$questionId',
    getParentRoute: () => AppAdminSurveysSurveyIdQuestionsRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdQuestionsNewRoute =
  AppAdminSurveysSurveyIdQuestionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSurveysSurveyIdQuestionsRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdTopicsIndexRoute =
  AppAdminSurveysSurveyIdTopicsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminSurveysSurveyIdTopicsRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdTopicsTopicIdRoute =
  AppAdminSurveysSurveyIdTopicsTopicIdRouteImport.update({
    id: '/$topicId',
    path: '/$topicId',
    getParentRoute: () => AppAdminSurveysSurveyIdTopicsRouteRoute,
  } as any)
const AppAdminSurveysSurveyIdTopicsNewRoute =
  AppAdminSurveysSurveyIdTopicsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAdminSurveysSurveyIdTopicsRouteRoute,
  } as any)
const AppAdminUsersUserIdOrganizationsIndexRoute =
  AppAdminUsersUserIdOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminUsersUserIdOrganizationsRouteRoute,
  } as any)
const AppAdminUsersUserIdOrganizationsOrganizationIdRoute =
  AppAdminUsersUserIdOrganizationsOrganizationIdRouteImport.update({
    id: '/$organizationId',
    path: '/$organizationId',
    getParentRoute: () => AppAdminUsersUserIdOrganizationsRouteRoute,
  } as any)
const AppDemosSetsSetIdViewIndexRoute =
  AppDemosSetsSetIdViewIndexRouteImport.update({
    id: '/demos/sets/$setId/view/',
    path: '/demos/sets/$setId/view/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute,
  } as any)
const AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteImport.update({
    id: '/$format',
    path: '/$format',
    getParentRoute: () =>
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute,
  } as any)
const AppOrganizationsOrganizationIdPlanItemsItemIdRoute =
  AppOrganizationsOrganizationIdPlanItemsItemIdRouteImport.update({
    id: '/items/$itemId',
    path: '/items/$itemId',
    getParentRoute: () => AppOrganizationsOrganizationIdPlanRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdPlanItemsNewRoute =
  AppOrganizationsOrganizationIdPlanItemsNewRouteImport.update({
    id: '/items/new',
    path: '/items/new',
    getParentRoute: () => AppOrganizationsOrganizationIdPlanRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute =
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteImport.update(
    {
      id: '/subtopics/$subtopicId',
      path: '/subtopics/$subtopicId',
      getParentRoute: () => AppOrganizationsOrganizationIdQuickStartRouteRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute =
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteImport.update(
    {
      id: '/children/$childOrgTypeMachineName',
      path: '/children/$childOrgTypeMachineName',
      getParentRoute: () => AppOrganizationsOrganizationIdReportsRouteRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdReportsModulesModuleIdRoute =
  AppOrganizationsOrganizationIdReportsModulesModuleIdRouteImport.update({
    id: '/modules/$moduleId',
    path: '/modules/$moduleId',
    getParentRoute: () => AppOrganizationsOrganizationIdReportsRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdReportsSetsSetIdRoute =
  AppOrganizationsOrganizationIdReportsSetsSetIdRouteImport.update({
    id: '/sets/$setId',
    path: '/sets/$setId',
    getParentRoute: () => AppOrganizationsOrganizationIdReportsRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsSetIdIndexRoute =
  AppOrganizationsOrganizationIdSetsSetIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute =
  AppOrganizationsOrganizationIdSetsSetIdCalculatorRouteImport.update({
    id: '/calculator',
    path: '/calculator',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute =
  AppOrganizationsOrganizationIdSetsSetIdGlossaryRouteImport.update({
    id: '/glossary',
    path: '/glossary',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsSetIdReportRoute =
  AppOrganizationsOrganizationIdSetsSetIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdRouteRoute,
  } as any)
const AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute =
  AppAccountTwcJoinOrgTypeOrgIdUfcIdRouteImport.update({
    id: '/$ufcId',
    path: '/$ufcId',
    getParentRoute: () => AppAccountTwcJoinOrgTypeOrgIdRoute,
  } as any)
const AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute =
  AppDeeplinksProgramsProgramIdSetsSetIdIndexRouteImport.update({
    id: '/programs/$programId/sets/$setId/',
    path: '/programs/$programId/sets/$setId/',
    getParentRoute: () => AppDeeplinksRouteRoute,
  } as any)
const AppDemosSetsSetIdViewActiveDemoViewIndexRoute =
  AppDemosSetsSetIdViewActiveDemoViewIndexRouteImport.update({
    id: '/demos/sets/$setId/view/$activeDemoView/',
    path: '/demos/sets/$setId/view/$activeDemoView/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute =
  AppDemosSetsSetIdViewActiveDemoViewQuestionIdRouteImport.update({
    id: '/demos/sets/$setId/view/$activeDemoView/$questionId',
    path: '/demos/sets/$setId/view/$activeDemoView/$questionId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRouteImport.update(
    {
      id: '/$subsectionId',
      path: '/$subsectionId',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute =
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute =
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRouteImport.update(
    {
      id: '/guide',
      path: '/guide',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute =
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute =
  AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRouteImport.update({
    id: '/modules/$moduleId',
    path: '/modules/$moduleId',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute =
  AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRouteImport.update({
    id: '/questions/$questionId',
    path: '/questions/$questionId',
    getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdRouteRoute,
  } as any)
const AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute =
  AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRouteImport.update({
    id: '/programs/$programId/sets/$setId/modules/$moduleId',
    path: '/programs/$programId/sets/$setId/modules/$moduleId',
    getParentRoute: () => AppDeeplinksRouteRoute,
  } as any)
const AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute =
  AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRouteImport.update({
    id: '/programs/$programId/sets/$setId/questions/$questionId',
    path: '/programs/$programId/sets/$setId/questions/$questionId',
    getParentRoute: () => AppDeeplinksRouteRoute,
  } as any)
const AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute =
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRouteImport.update(
    {
      id: '/modules/$moduleId',
      path: '/modules/$moduleId',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute =
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRouteImport.update(
    {
      id: '/sets/$setId',
      path: '/sets/$setId',
      getParentRoute: () =>
        AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute,
    } as any,
  )
const AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute =
  AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRouteImport.update(
    {
      id: '/download/$format',
      path: '/download/$format',
      getParentRoute: () => AppOrganizationsOrganizationIdSetsSetIdReportRoute,
    } as any,
  )
const AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute =
  AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRouteImport.update(
    {
      id: '/organizations/$organizationId/sets/$setId/calculator',
      path: '/organizations/$organizationId/sets/$setId/calculator',
      getParentRoute: () => AppProgramsProgramIdRoute,
    } as any,
  )
const AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute =
  AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRouteImport.update(
    {
      id: '/organizations/$organizationId/sets/$setId/glossary',
      path: '/organizations/$organizationId/sets/$setId/glossary',
      getParentRoute: () => AppProgramsProgramIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/account': typeof AppAccountRouteRouteWithChildren
  '/app/admin': typeof AppAdminRouteRouteWithChildren
  '/app/deeplinks': typeof AppDeeplinksRouteRouteWithChildren
  '/app/organizations': typeof AppOrganizationsRouteRouteWithChildren
  '/app/resources': typeof AppResourcesRouteRouteWithChildren
  '/app/admin/content': typeof AppAdminContentRouteRouteWithChildren
  '/app/admin/criteria': typeof AppAdminCriteriaRouteRouteWithChildren
  '/app/admin/criterion-topics': typeof AppAdminCriterionTopicsRouteRouteWithChildren
  '/app/admin/lms': typeof AppAdminLmsRouteRouteWithChildren
  '/app/admin/organizations': typeof AppAdminOrganizationsRouteRouteWithChildren
  '/app/admin/pending': typeof AppAdminPendingRouteRouteWithChildren
  '/app/admin/programs': typeof AppAdminProgramsRouteRouteWithChildren
  '/app/admin/sets': typeof AppAdminSetsRouteRouteWithChildren
  '/app/admin/settings': typeof AppAdminSettingsRouteRouteWithChildren
  '/app/admin/surveys': typeof AppAdminSurveysRouteRouteWithChildren
  '/app/admin/tags': typeof AppAdminTagsRouteRouteWithChildren
  '/app/admin/terms': typeof AppAdminTermsRouteRouteWithChildren
  '/app/admin/users': typeof AppAdminUsersRouteRouteWithChildren
  '/app/organizations/$organizationId': typeof AppOrganizationsOrganizationIdRouteRouteWithChildren
  '/app/survey-previews/$surveyId': typeof AppSurveyPreviewsSurveyIdRouteRouteWithChildren
  '/app/surveys/$surveyOrganizationUuid': typeof AppSurveysSurveyOrganizationUuidRouteRouteWithChildren
  '/app/account/curricula': typeof AppAccountCurriculaRoute
  '/app/account/dashboard': typeof AppAccountDashboardRoute
  '/app/account/deactivate': typeof AppAccountDeactivateRoute
  '/app/account/favorites': typeof AppAccountFavoritesRoute
  '/app/account/forgot': typeof AppAccountForgotRoute
  '/app/account/logged-out': typeof AppAccountLoggedOutRoute
  '/app/account/login': typeof AppAccountLoginRoute
  '/app/account/logout': typeof AppAccountLogoutRoute
  '/app/account/profile': typeof AppAccountProfileRoute
  '/app/account/reactivate': typeof AppAccountReactivateRoute
  '/app/account/welcome-back': typeof AppAccountWelcomeBackRouteWithChildren
  '/app/admin/activity-log': typeof AppAdminActivityLogRoute
  '/app/admin/demos': typeof AppAdminDemosRouteWithChildren
  '/app/admin/guides': typeof AppAdminGuidesRouteWithChildren
  '/app/admin/metrics': typeof AppAdminMetricsRoute
  '/app/deeplink-question/$questionId': typeof AppDeeplinkQuestionQuestionIdRoute
  '/app/deeplink-set/$setId': typeof AppDeeplinkSetSetIdRoute
  '/app/deeplinks/plan': typeof AppDeeplinksPlanRoute
  '/app/deeplinks/team': typeof AppDeeplinksTeamRoute
  '/app/materials/$materialId': typeof AppMaterialsMaterialIdRoute
  '/app/programs/$programId': typeof AppProgramsProgramIdRouteWithChildren
  '/app/resources/$resourceId': typeof AppResourcesResourceIdRoute
  '/app/account/': typeof AppAccountIndexRoute
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/demos/': typeof AppDemosIndexRoute
  '/app/organizations/': typeof AppOrganizationsIndexRoute
  '/app/programs/': typeof AppProgramsIndexRoute
  '/app/resources/': typeof AppResourcesIndexRoute
  '/app/account/twc/join': typeof AppAccountTwcJoinRouteRouteWithChildren
  '/app/admin/lms/audio': typeof AppAdminLmsAudioRouteRouteWithChildren
  '/app/admin/lms/collections': typeof AppAdminLmsCollectionsRouteRouteWithChildren
  '/app/admin/lms/curricula': typeof AppAdminLmsCurriculaRouteRouteWithChildren
  '/app/admin/lms/microlearnings': typeof AppAdminLmsMicrolearningsRouteRouteWithChildren
  '/app/admin/lms/resources': typeof AppAdminLmsResourcesRouteRouteWithChildren
  '/app/admin/lms/trainings-local': typeof AppAdminLmsTrainingsLocalRouteRouteWithChildren
  '/app/admin/organizations/$organizationId': typeof AppAdminOrganizationsOrganizationIdRouteRouteWithChildren
  '/app/admin/programs/$programId': typeof AppAdminProgramsProgramIdRouteRouteWithChildren
  '/app/admin/sets/$setId': typeof AppAdminSetsSetIdRouteRouteWithChildren
  '/app/admin/users/$userId': typeof AppAdminUsersUserIdRouteRouteWithChildren
  '/app/organizations/$organizationId/ahs': typeof AppOrganizationsOrganizationIdAhsRouteRoute
  '/app/organizations/$organizationId/builder': typeof AppOrganizationsOrganizationIdBuilderRouteRouteWithChildren
  '/app/organizations/$organizationId/pending': typeof AppOrganizationsOrganizationIdPendingRouteRoute
  '/app/organizations/$organizationId/plan': typeof AppOrganizationsOrganizationIdPlanRouteRouteWithChildren
  '/app/organizations/$organizationId/quick-start': typeof AppOrganizationsOrganizationIdQuickStartRouteRouteWithChildren
  '/app/organizations/$organizationId/reports': typeof AppOrganizationsOrganizationIdReportsRouteRouteWithChildren
  '/app/organizations/$organizationId/sets': typeof AppOrganizationsOrganizationIdSetsRouteRouteWithChildren
  '/app/organizations/$organizationId/surveys': typeof AppOrganizationsOrganizationIdSurveysRouteRouteWithChildren
  '/app/organizations/$organizationId/team': typeof AppOrganizationsOrganizationIdTeamRouteRouteWithChildren
  '/app/organizations/join/$orgtypeMachineName': typeof AppOrganizationsJoinOrgtypeMachineNameRouteRouteWithChildren
  '/app/account/activity-log/$': typeof AppAccountActivityLogSplatRoute
  '/app/account/redeem-invite/$inviteToken': typeof AppAccountRedeemInviteInviteTokenRoute
  '/app/account/register/verification': typeof AppAccountRegisterVerificationRouteWithChildren
  '/app/account/reset-password/$token': typeof AppAccountResetPasswordTokenRoute
  '/app/account/welcome-back/$token': typeof AppAccountWelcomeBackTokenRoute
  '/app/admin/content/$contentId': typeof AppAdminContentContentIdRoute
  '/app/admin/content/new': typeof AppAdminContentNewRoute
  '/app/admin/criteria/$criterionId': typeof AppAdminCriteriaCriterionIdRoute
  '/app/admin/criteria/new': typeof AppAdminCriteriaNewRoute
  '/app/admin/criterion-topics/$criterionTopicId': typeof AppAdminCriterionTopicsCriterionTopicIdRoute
  '/app/admin/criterion-topics/new': typeof AppAdminCriterionTopicsNewRoute
  '/app/admin/pending/invites': typeof AppAdminPendingInvitesRoute
  '/app/admin/pending/requests': typeof AppAdminPendingRequestsRoute
  '/app/admin/sets/new': typeof AppAdminSetsNewRoute
  '/app/admin/settings/$settingId': typeof AppAdminSettingsSettingIdRoute
  '/app/admin/settings/new': typeof AppAdminSettingsNewRoute
  '/app/admin/surveys/new': typeof AppAdminSurveysNewRoute
  '/app/admin/tags/$tagId': typeof AppAdminTagsTagIdRoute
  '/app/admin/tags/new': typeof AppAdminTagsNewRoute
  '/app/admin/terms/$termId': typeof AppAdminTermsTermIdRoute
  '/app/admin/terms/new': typeof AppAdminTermsNewRoute
  '/app/admin/users/new': typeof AppAdminUsersNewRoute
  '/app/programs/$programId/register': typeof AppProgramsProgramIdRegisterRoute
  '/app/resources/audio/$id': typeof AppResourcesAudioIdRoute
  '/app/resources/collections/$id': typeof AppResourcesCollectionsIdRoute
  '/app/resources/curricula/$id': typeof AppResourcesCurriculaIdRoute
  '/app/resources/microlearnings/$id': typeof AppResourcesMicrolearningsIdRoute
  '/app/resources/trainings-local/$id': typeof AppResourcesTrainingsLocalIdRoute
  '/app/resources/trainings-on-demand/$id': typeof AppResourcesTrainingsOnDemandIdRoute
  '/app/resources/trainings-virtual/$id': typeof AppResourcesTrainingsVirtualIdRoute
  '/app/account/register/': typeof AppAccountRegisterIndexRoute
  '/app/account/twc/': typeof AppAccountTwcIndexRoute
  '/app/admin/content/': typeof AppAdminContentIndexRoute
  '/app/admin/criteria/': typeof AppAdminCriteriaIndexRoute
  '/app/admin/criterion-topics/': typeof AppAdminCriterionTopicsIndexRoute
  '/app/admin/demos/': typeof AppAdminDemosIndexRoute
  '/app/admin/guides/': typeof AppAdminGuidesIndexRoute
  '/app/admin/lms/': typeof AppAdminLmsIndexRoute
  '/app/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/app/admin/programs/': typeof AppAdminProgramsIndexRoute
  '/app/admin/sets/': typeof AppAdminSetsIndexRoute
  '/app/admin/settings/': typeof AppAdminSettingsIndexRoute
  '/app/admin/surveys/': typeof AppAdminSurveysIndexRoute
  '/app/admin/tags/': typeof AppAdminTagsIndexRoute
  '/app/admin/terms/': typeof AppAdminTermsIndexRoute
  '/app/admin/users/': typeof AppAdminUsersIndexRoute
  '/app/demos/sets/': typeof AppDemosSetsIndexRoute
  '/app/organizations/$organizationId/': typeof AppOrganizationsOrganizationIdIndexRoute
  '/app/organizations/join/': typeof AppOrganizationsJoinIndexRoute
  '/app/survey-previews/$surveyId/': typeof AppSurveyPreviewsSurveyIdIndexRoute
  '/app/surveys/$surveyOrganizationUuid/': typeof AppSurveysSurveyOrganizationUuidIndexRoute
  '/app/admin/sets/$setId/modules': typeof AppAdminSetsSetIdModulesRouteRouteWithChildren
  '/app/admin/sets/$setId/questions': typeof AppAdminSetsSetIdQuestionsRouteRouteWithChildren
  '/app/admin/surveys/$surveyId/questions': typeof AppAdminSurveysSurveyIdQuestionsRouteRouteWithChildren
  '/app/admin/surveys/$surveyId/topics': typeof AppAdminSurveysSurveyIdTopicsRouteRouteWithChildren
  '/app/admin/users/$userId/organizations': typeof AppAdminUsersUserIdOrganizationsRouteRouteWithChildren
  '/app/organizations/$organizationId/sets/$setId': typeof AppOrganizationsOrganizationIdSetsSetIdRouteRouteWithChildren
  '/app/account/twc/join/$orgType': typeof AppAccountTwcJoinOrgTypeRouteWithChildren
  '/app/admin/demos/sets/default': typeof AppAdminDemosSetsDefaultRoute
  '/app/admin/lms/audio/$audioId': typeof AppAdminLmsAudioAudioIdRoute
  '/app/admin/lms/audio/new': typeof AppAdminLmsAudioNewRoute
  '/app/admin/lms/collections/$collectionId': typeof AppAdminLmsCollectionsCollectionIdRoute
  '/app/admin/lms/collections/new': typeof AppAdminLmsCollectionsNewRoute
  '/app/admin/lms/curricula/$curriculumId': typeof AppAdminLmsCurriculaCurriculumIdRoute
  '/app/admin/lms/curricula/new': typeof AppAdminLmsCurriculaNewRoute
  '/app/admin/lms/materials/$materialId': typeof AppAdminLmsMaterialsMaterialIdRoute
  '/app/admin/lms/microlearnings/$microlearningId': typeof AppAdminLmsMicrolearningsMicrolearningIdRoute
  '/app/admin/lms/microlearnings/new': typeof AppAdminLmsMicrolearningsNewRoute
  '/app/admin/lms/resources/$resourceId': typeof AppAdminLmsResourcesResourceIdRoute
  '/app/admin/lms/resources/new': typeof AppAdminLmsResourcesNewRoute
  '/app/admin/lms/trainings-local/$trainingId': typeof AppAdminLmsTrainingsLocalTrainingIdRoute
  '/app/admin/lms/trainings-local/new': typeof AppAdminLmsTrainingsLocalNewRoute
  '/app/admin/lms/trainings-on-demand/$trainingId': typeof AppAdminLmsTrainingsOnDemandTrainingIdRoute
  '/app/admin/lms/trainings-virtual/$trainingId': typeof AppAdminLmsTrainingsVirtualTrainingIdRoute
  '/app/admin/organizations/$organizationId/team': typeof AppAdminOrganizationsOrganizationIdTeamRoute
  '/app/admin/programs/$programId/organizations': typeof AppAdminProgramsProgramIdOrganizationsRoute
  '/app/admin/programs/$programId/sets': typeof AppAdminProgramsProgramIdSetsRoute
  '/app/admin/sets/$setId/clone': typeof AppAdminSetsSetIdCloneRoute
  '/app/admin/sets/$setId/demo': typeof AppAdminSetsSetIdDemoRoute
  '/app/admin/users/$userId/pending': typeof AppAdminUsersUserIdPendingRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteWithChildren
  '/app/organizations/$organizationId/overview/$tab': typeof AppOrganizationsOrganizationIdOverviewTabRoute
  '/app/organizations/$organizationId/surveys/$surveyId': typeof AppOrganizationsOrganizationIdSurveysSurveyIdRoute
  '/app/organizations/$organizationId/team/invite': typeof AppOrganizationsOrganizationIdTeamInviteRoute
  '/app/organizations/join/$orgtypeMachineName/$organizationId': typeof AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute
  '/app/organizations/join/$orgtypeMachineName/find': typeof AppOrganizationsJoinOrgtypeMachineNameFindRoute
  '/app/survey-previews/$surveyId/$languageId/confirmation': typeof AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute
  '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation': typeof AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute
  '/app/account/register/verification/': typeof AppAccountRegisterVerificationIndexRoute
  '/app/account/twc/join/': typeof AppAccountTwcJoinIndexRoute
  '/app/admin/demos/sets/': typeof AppAdminDemosSetsIndexRoute
  '/app/admin/organizations/$organizationId/': typeof AppAdminOrganizationsOrganizationIdIndexRoute
  '/app/admin/programs/$programId/': typeof AppAdminProgramsProgramIdIndexRoute
  '/app/admin/sets/$setId/': typeof AppAdminSetsSetIdIndexRoute
  '/app/admin/surveys/$surveyId/': typeof AppAdminSurveysSurveyIdIndexRoute
  '/app/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/app/deeplinks/programs/$programId/': typeof AppDeeplinksProgramsProgramIdIndexRoute
  '/app/demos/sets/$setId/': typeof AppDemosSetsSetIdIndexRoute
  '/app/organizations/$organizationId/builder/': typeof AppOrganizationsOrganizationIdBuilderIndexRoute
  '/app/organizations/$organizationId/overview/': typeof AppOrganizationsOrganizationIdOverviewIndexRoute
  '/app/organizations/$organizationId/plan/': typeof AppOrganizationsOrganizationIdPlanIndexRoute
  '/app/organizations/$organizationId/quick-start/': typeof AppOrganizationsOrganizationIdQuickStartIndexRoute
  '/app/organizations/$organizationId/reports/': typeof AppOrganizationsOrganizationIdReportsIndexRoute
  '/app/organizations/$organizationId/sets/': typeof AppOrganizationsOrganizationIdSetsIndexRoute
  '/app/programs/$programId/organizations/': typeof AppProgramsProgramIdOrganizationsIndexRoute
  '/app/survey-previews/$surveyId/$languageId/': typeof AppSurveyPreviewsSurveyIdLanguageIdIndexRoute
  '/app/surveys/$surveyOrganizationUuid/$languageId/': typeof AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteWithChildren
  '/app/account/register/verification/url/$encodedUrl': typeof AppAccountRegisterVerificationUrlEncodedUrlRoute
  '/app/account/twc/join/$orgType/$orgId': typeof AppAccountTwcJoinOrgTypeOrgIdRouteWithChildren
  '/app/admin/sets/$setId/modules/$moduleId': typeof AppAdminSetsSetIdModulesModuleIdRoute
  '/app/admin/sets/$setId/modules/new': typeof AppAdminSetsSetIdModulesNewRoute
  '/app/admin/sets/$setId/questions/$questionId': typeof AppAdminSetsSetIdQuestionsQuestionIdRoute
  '/app/admin/sets/$setId/questions/new': typeof AppAdminSetsSetIdQuestionsNewRoute
  '/app/admin/surveys/$surveyId/questions/$questionId': typeof AppAdminSurveysSurveyIdQuestionsQuestionIdRoute
  '/app/admin/surveys/$surveyId/questions/new': typeof AppAdminSurveysSurveyIdQuestionsNewRoute
  '/app/admin/surveys/$surveyId/topics/$topicId': typeof AppAdminSurveysSurveyIdTopicsTopicIdRoute
  '/app/admin/surveys/$surveyId/topics/new': typeof AppAdminSurveysSurveyIdTopicsNewRoute
  '/app/admin/users/$userId/organizations/$organizationId': typeof AppAdminUsersUserIdOrganizationsOrganizationIdRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteWithChildren
  '/app/organizations/$organizationId/plan/items/$itemId': typeof AppOrganizationsOrganizationIdPlanItemsItemIdRoute
  '/app/organizations/$organizationId/plan/items/new': typeof AppOrganizationsOrganizationIdPlanItemsNewRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteWithChildren
  '/app/organizations/$organizationId/reports/modules/$moduleId': typeof AppOrganizationsOrganizationIdReportsModulesModuleIdRoute
  '/app/organizations/$organizationId/reports/sets/$setId': typeof AppOrganizationsOrganizationIdReportsSetsSetIdRoute
  '/app/organizations/$organizationId/sets/$setId/calculator': typeof AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  '/app/organizations/$organizationId/sets/$setId/glossary': typeof AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute
  '/app/organizations/$organizationId/sets/$setId/report': typeof AppOrganizationsOrganizationIdSetsSetIdReportRouteWithChildren
  '/app/admin/sets/$setId/modules/': typeof AppAdminSetsSetIdModulesIndexRoute
  '/app/admin/sets/$setId/questions/': typeof AppAdminSetsSetIdQuestionsIndexRoute
  '/app/admin/surveys/$surveyId/questions/': typeof AppAdminSurveysSurveyIdQuestionsIndexRoute
  '/app/admin/surveys/$surveyId/topics/': typeof AppAdminSurveysSurveyIdTopicsIndexRoute
  '/app/admin/users/$userId/organizations/': typeof AppAdminUsersUserIdOrganizationsIndexRoute
  '/app/demos/sets/$setId/view/': typeof AppDemosSetsSetIdViewIndexRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute
  '/app/organizations/$organizationId/sets/$setId/': typeof AppOrganizationsOrganizationIdSetsSetIdIndexRoute
  '/app/account/twc/join/$orgType/$orgId/$ufcId': typeof AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute
  '/app/demos/sets/$setId/view/$activeDemoView/$questionId': typeof AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute
  '/app/organizations/$organizationId/sets/$setId/modules/$moduleId': typeof AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute
  '/app/organizations/$organizationId/sets/$setId/questions/$questionId': typeof AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute
  '/app/deeplinks/programs/$programId/sets/$setId/': typeof AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute
  '/app/demos/sets/$setId/view/$activeDemoView/': typeof AppDemosSetsSetIdViewActiveDemoViewIndexRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute
  '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId': typeof AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute
  '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId': typeof AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute
  '/app/organizations/$organizationId/sets/$setId/report/download/$format': typeof AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator': typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary': typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/deeplinks': typeof AppDeeplinksRouteRouteWithChildren
  '/app/admin/pending': typeof AppAdminPendingRouteRouteWithChildren
  '/app/account/curricula': typeof AppAccountCurriculaRoute
  '/app/account/dashboard': typeof AppAccountDashboardRoute
  '/app/account/deactivate': typeof AppAccountDeactivateRoute
  '/app/account/favorites': typeof AppAccountFavoritesRoute
  '/app/account/forgot': typeof AppAccountForgotRoute
  '/app/account/logged-out': typeof AppAccountLoggedOutRoute
  '/app/account/login': typeof AppAccountLoginRoute
  '/app/account/logout': typeof AppAccountLogoutRoute
  '/app/account/profile': typeof AppAccountProfileRoute
  '/app/account/reactivate': typeof AppAccountReactivateRoute
  '/app/account/welcome-back': typeof AppAccountWelcomeBackRouteWithChildren
  '/app/admin/activity-log': typeof AppAdminActivityLogRoute
  '/app/admin/metrics': typeof AppAdminMetricsRoute
  '/app/deeplink-question/$questionId': typeof AppDeeplinkQuestionQuestionIdRoute
  '/app/deeplink-set/$setId': typeof AppDeeplinkSetSetIdRoute
  '/app/deeplinks/plan': typeof AppDeeplinksPlanRoute
  '/app/deeplinks/team': typeof AppDeeplinksTeamRoute
  '/app/materials/$materialId': typeof AppMaterialsMaterialIdRoute
  '/app/programs/$programId': typeof AppProgramsProgramIdRouteWithChildren
  '/app/resources/$resourceId': typeof AppResourcesResourceIdRoute
  '/app/account': typeof AppAccountIndexRoute
  '/app/admin': typeof AppAdminIndexRoute
  '/app/demos': typeof AppDemosIndexRoute
  '/app/organizations': typeof AppOrganizationsIndexRoute
  '/app/programs': typeof AppProgramsIndexRoute
  '/app/resources': typeof AppResourcesIndexRoute
  '/app/admin/lms/audio': typeof AppAdminLmsAudioRouteRouteWithChildren
  '/app/admin/lms/collections': typeof AppAdminLmsCollectionsRouteRouteWithChildren
  '/app/admin/lms/curricula': typeof AppAdminLmsCurriculaRouteRouteWithChildren
  '/app/admin/lms/microlearnings': typeof AppAdminLmsMicrolearningsRouteRouteWithChildren
  '/app/admin/lms/resources': typeof AppAdminLmsResourcesRouteRouteWithChildren
  '/app/admin/lms/trainings-local': typeof AppAdminLmsTrainingsLocalRouteRouteWithChildren
  '/app/organizations/$organizationId/ahs': typeof AppOrganizationsOrganizationIdAhsRouteRoute
  '/app/organizations/$organizationId/pending': typeof AppOrganizationsOrganizationIdPendingRouteRoute
  '/app/organizations/$organizationId/surveys': typeof AppOrganizationsOrganizationIdSurveysRouteRouteWithChildren
  '/app/organizations/$organizationId/team': typeof AppOrganizationsOrganizationIdTeamRouteRouteWithChildren
  '/app/organizations/join/$orgtypeMachineName': typeof AppOrganizationsJoinOrgtypeMachineNameRouteRouteWithChildren
  '/app/account/activity-log/$': typeof AppAccountActivityLogSplatRoute
  '/app/account/redeem-invite/$inviteToken': typeof AppAccountRedeemInviteInviteTokenRoute
  '/app/account/reset-password/$token': typeof AppAccountResetPasswordTokenRoute
  '/app/account/welcome-back/$token': typeof AppAccountWelcomeBackTokenRoute
  '/app/admin/content/$contentId': typeof AppAdminContentContentIdRoute
  '/app/admin/content/new': typeof AppAdminContentNewRoute
  '/app/admin/criteria/$criterionId': typeof AppAdminCriteriaCriterionIdRoute
  '/app/admin/criteria/new': typeof AppAdminCriteriaNewRoute
  '/app/admin/criterion-topics/$criterionTopicId': typeof AppAdminCriterionTopicsCriterionTopicIdRoute
  '/app/admin/criterion-topics/new': typeof AppAdminCriterionTopicsNewRoute
  '/app/admin/pending/invites': typeof AppAdminPendingInvitesRoute
  '/app/admin/pending/requests': typeof AppAdminPendingRequestsRoute
  '/app/admin/sets/new': typeof AppAdminSetsNewRoute
  '/app/admin/settings/$settingId': typeof AppAdminSettingsSettingIdRoute
  '/app/admin/settings/new': typeof AppAdminSettingsNewRoute
  '/app/admin/surveys/new': typeof AppAdminSurveysNewRoute
  '/app/admin/tags/$tagId': typeof AppAdminTagsTagIdRoute
  '/app/admin/tags/new': typeof AppAdminTagsNewRoute
  '/app/admin/terms/$termId': typeof AppAdminTermsTermIdRoute
  '/app/admin/terms/new': typeof AppAdminTermsNewRoute
  '/app/admin/users/new': typeof AppAdminUsersNewRoute
  '/app/programs/$programId/register': typeof AppProgramsProgramIdRegisterRoute
  '/app/resources/audio/$id': typeof AppResourcesAudioIdRoute
  '/app/resources/collections/$id': typeof AppResourcesCollectionsIdRoute
  '/app/resources/curricula/$id': typeof AppResourcesCurriculaIdRoute
  '/app/resources/microlearnings/$id': typeof AppResourcesMicrolearningsIdRoute
  '/app/resources/trainings-local/$id': typeof AppResourcesTrainingsLocalIdRoute
  '/app/resources/trainings-on-demand/$id': typeof AppResourcesTrainingsOnDemandIdRoute
  '/app/resources/trainings-virtual/$id': typeof AppResourcesTrainingsVirtualIdRoute
  '/app/account/register': typeof AppAccountRegisterIndexRoute
  '/app/account/twc': typeof AppAccountTwcIndexRoute
  '/app/admin/content': typeof AppAdminContentIndexRoute
  '/app/admin/criteria': typeof AppAdminCriteriaIndexRoute
  '/app/admin/criterion-topics': typeof AppAdminCriterionTopicsIndexRoute
  '/app/admin/demos': typeof AppAdminDemosIndexRoute
  '/app/admin/guides': typeof AppAdminGuidesIndexRoute
  '/app/admin/lms': typeof AppAdminLmsIndexRoute
  '/app/admin/organizations': typeof AppAdminOrganizationsIndexRoute
  '/app/admin/programs': typeof AppAdminProgramsIndexRoute
  '/app/admin/sets': typeof AppAdminSetsIndexRoute
  '/app/admin/settings': typeof AppAdminSettingsIndexRoute
  '/app/admin/surveys': typeof AppAdminSurveysIndexRoute
  '/app/admin/tags': typeof AppAdminTagsIndexRoute
  '/app/admin/terms': typeof AppAdminTermsIndexRoute
  '/app/admin/users': typeof AppAdminUsersIndexRoute
  '/app/demos/sets': typeof AppDemosSetsIndexRoute
  '/app/organizations/$organizationId': typeof AppOrganizationsOrganizationIdIndexRoute
  '/app/organizations/join': typeof AppOrganizationsJoinIndexRoute
  '/app/survey-previews/$surveyId': typeof AppSurveyPreviewsSurveyIdIndexRoute
  '/app/surveys/$surveyOrganizationUuid': typeof AppSurveysSurveyOrganizationUuidIndexRoute
  '/app/account/twc/join/$orgType': typeof AppAccountTwcJoinOrgTypeRouteWithChildren
  '/app/admin/demos/sets/default': typeof AppAdminDemosSetsDefaultRoute
  '/app/admin/lms/audio/$audioId': typeof AppAdminLmsAudioAudioIdRoute
  '/app/admin/lms/audio/new': typeof AppAdminLmsAudioNewRoute
  '/app/admin/lms/collections/$collectionId': typeof AppAdminLmsCollectionsCollectionIdRoute
  '/app/admin/lms/collections/new': typeof AppAdminLmsCollectionsNewRoute
  '/app/admin/lms/curricula/$curriculumId': typeof AppAdminLmsCurriculaCurriculumIdRoute
  '/app/admin/lms/curricula/new': typeof AppAdminLmsCurriculaNewRoute
  '/app/admin/lms/materials/$materialId': typeof AppAdminLmsMaterialsMaterialIdRoute
  '/app/admin/lms/microlearnings/$microlearningId': typeof AppAdminLmsMicrolearningsMicrolearningIdRoute
  '/app/admin/lms/microlearnings/new': typeof AppAdminLmsMicrolearningsNewRoute
  '/app/admin/lms/resources/$resourceId': typeof AppAdminLmsResourcesResourceIdRoute
  '/app/admin/lms/resources/new': typeof AppAdminLmsResourcesNewRoute
  '/app/admin/lms/trainings-local/$trainingId': typeof AppAdminLmsTrainingsLocalTrainingIdRoute
  '/app/admin/lms/trainings-local/new': typeof AppAdminLmsTrainingsLocalNewRoute
  '/app/admin/lms/trainings-on-demand/$trainingId': typeof AppAdminLmsTrainingsOnDemandTrainingIdRoute
  '/app/admin/lms/trainings-virtual/$trainingId': typeof AppAdminLmsTrainingsVirtualTrainingIdRoute
  '/app/admin/organizations/$organizationId/team': typeof AppAdminOrganizationsOrganizationIdTeamRoute
  '/app/admin/programs/$programId/organizations': typeof AppAdminProgramsProgramIdOrganizationsRoute
  '/app/admin/programs/$programId/sets': typeof AppAdminProgramsProgramIdSetsRoute
  '/app/admin/sets/$setId/clone': typeof AppAdminSetsSetIdCloneRoute
  '/app/admin/sets/$setId/demo': typeof AppAdminSetsSetIdDemoRoute
  '/app/admin/users/$userId/pending': typeof AppAdminUsersUserIdPendingRoute
  '/app/organizations/$organizationId/overview/$tab': typeof AppOrganizationsOrganizationIdOverviewTabRoute
  '/app/organizations/$organizationId/surveys/$surveyId': typeof AppOrganizationsOrganizationIdSurveysSurveyIdRoute
  '/app/organizations/$organizationId/team/invite': typeof AppOrganizationsOrganizationIdTeamInviteRoute
  '/app/organizations/join/$orgtypeMachineName/$organizationId': typeof AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute
  '/app/organizations/join/$orgtypeMachineName/find': typeof AppOrganizationsJoinOrgtypeMachineNameFindRoute
  '/app/survey-previews/$surveyId/$languageId/confirmation': typeof AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute
  '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation': typeof AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute
  '/app/account/register/verification': typeof AppAccountRegisterVerificationIndexRoute
  '/app/account/twc/join': typeof AppAccountTwcJoinIndexRoute
  '/app/admin/demos/sets': typeof AppAdminDemosSetsIndexRoute
  '/app/admin/organizations/$organizationId': typeof AppAdminOrganizationsOrganizationIdIndexRoute
  '/app/admin/programs/$programId': typeof AppAdminProgramsProgramIdIndexRoute
  '/app/admin/sets/$setId': typeof AppAdminSetsSetIdIndexRoute
  '/app/admin/surveys/$surveyId': typeof AppAdminSurveysSurveyIdIndexRoute
  '/app/admin/users/$userId': typeof AppAdminUsersUserIdIndexRoute
  '/app/deeplinks/programs/$programId': typeof AppDeeplinksProgramsProgramIdIndexRoute
  '/app/demos/sets/$setId': typeof AppDemosSetsSetIdIndexRoute
  '/app/organizations/$organizationId/builder': typeof AppOrganizationsOrganizationIdBuilderIndexRoute
  '/app/organizations/$organizationId/overview': typeof AppOrganizationsOrganizationIdOverviewIndexRoute
  '/app/organizations/$organizationId/plan': typeof AppOrganizationsOrganizationIdPlanIndexRoute
  '/app/organizations/$organizationId/quick-start': typeof AppOrganizationsOrganizationIdQuickStartIndexRoute
  '/app/organizations/$organizationId/reports': typeof AppOrganizationsOrganizationIdReportsIndexRoute
  '/app/organizations/$organizationId/sets': typeof AppOrganizationsOrganizationIdSetsIndexRoute
  '/app/programs/$programId/organizations': typeof AppProgramsProgramIdOrganizationsIndexRoute
  '/app/survey-previews/$surveyId/$languageId': typeof AppSurveyPreviewsSurveyIdLanguageIdIndexRoute
  '/app/surveys/$surveyOrganizationUuid/$languageId': typeof AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute
  '/app/account/register/verification/url/$encodedUrl': typeof AppAccountRegisterVerificationUrlEncodedUrlRoute
  '/app/account/twc/join/$orgType/$orgId': typeof AppAccountTwcJoinOrgTypeOrgIdRouteWithChildren
  '/app/admin/sets/$setId/modules/$moduleId': typeof AppAdminSetsSetIdModulesModuleIdRoute
  '/app/admin/sets/$setId/modules/new': typeof AppAdminSetsSetIdModulesNewRoute
  '/app/admin/sets/$setId/questions/$questionId': typeof AppAdminSetsSetIdQuestionsQuestionIdRoute
  '/app/admin/sets/$setId/questions/new': typeof AppAdminSetsSetIdQuestionsNewRoute
  '/app/admin/surveys/$surveyId/questions/$questionId': typeof AppAdminSurveysSurveyIdQuestionsQuestionIdRoute
  '/app/admin/surveys/$surveyId/questions/new': typeof AppAdminSurveysSurveyIdQuestionsNewRoute
  '/app/admin/surveys/$surveyId/topics/$topicId': typeof AppAdminSurveysSurveyIdTopicsTopicIdRoute
  '/app/admin/surveys/$surveyId/topics/new': typeof AppAdminSurveysSurveyIdTopicsNewRoute
  '/app/admin/users/$userId/organizations/$organizationId': typeof AppAdminUsersUserIdOrganizationsOrganizationIdRoute
  '/app/organizations/$organizationId/plan/items/$itemId': typeof AppOrganizationsOrganizationIdPlanItemsItemIdRoute
  '/app/organizations/$organizationId/plan/items/new': typeof AppOrganizationsOrganizationIdPlanItemsNewRoute
  '/app/organizations/$organizationId/reports/modules/$moduleId': typeof AppOrganizationsOrganizationIdReportsModulesModuleIdRoute
  '/app/organizations/$organizationId/reports/sets/$setId': typeof AppOrganizationsOrganizationIdReportsSetsSetIdRoute
  '/app/organizations/$organizationId/sets/$setId/calculator': typeof AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  '/app/organizations/$organizationId/sets/$setId/glossary': typeof AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute
  '/app/organizations/$organizationId/sets/$setId/report': typeof AppOrganizationsOrganizationIdSetsSetIdReportRouteWithChildren
  '/app/admin/sets/$setId/modules': typeof AppAdminSetsSetIdModulesIndexRoute
  '/app/admin/sets/$setId/questions': typeof AppAdminSetsSetIdQuestionsIndexRoute
  '/app/admin/surveys/$surveyId/questions': typeof AppAdminSurveysSurveyIdQuestionsIndexRoute
  '/app/admin/surveys/$surveyId/topics': typeof AppAdminSurveysSurveyIdTopicsIndexRoute
  '/app/admin/users/$userId/organizations': typeof AppAdminUsersUserIdOrganizationsIndexRoute
  '/app/demos/sets/$setId/view': typeof AppDemosSetsSetIdViewIndexRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute
  '/app/organizations/$organizationId/sets/$setId': typeof AppOrganizationsOrganizationIdSetsSetIdIndexRoute
  '/app/account/twc/join/$orgType/$orgId/$ufcId': typeof AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute
  '/app/demos/sets/$setId/view/$activeDemoView/$questionId': typeof AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute
  '/app/organizations/$organizationId/sets/$setId/modules/$moduleId': typeof AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute
  '/app/organizations/$organizationId/sets/$setId/questions/$questionId': typeof AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute
  '/app/deeplinks/programs/$programId/sets/$setId': typeof AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute
  '/app/demos/sets/$setId/view/$activeDemoView': typeof AppDemosSetsSetIdViewActiveDemoViewIndexRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute
  '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId': typeof AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute
  '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId': typeof AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute
  '/app/organizations/$organizationId/sets/$setId/report/download/$format': typeof AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator': typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary': typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/app/account': typeof AppAccountRouteRouteWithChildren
  '/app/admin': typeof AppAdminRouteRouteWithChildren
  '/app/deeplinks': typeof AppDeeplinksRouteRouteWithChildren
  '/app/organizations': typeof AppOrganizationsRouteRouteWithChildren
  '/app/resources': typeof AppResourcesRouteRouteWithChildren
  '/app/admin/content': typeof AppAdminContentRouteRouteWithChildren
  '/app/admin/criteria': typeof AppAdminCriteriaRouteRouteWithChildren
  '/app/admin/criterion-topics': typeof AppAdminCriterionTopicsRouteRouteWithChildren
  '/app/admin/lms': typeof AppAdminLmsRouteRouteWithChildren
  '/app/admin/organizations': typeof AppAdminOrganizationsRouteRouteWithChildren
  '/app/admin/pending': typeof AppAdminPendingRouteRouteWithChildren
  '/app/admin/programs': typeof AppAdminProgramsRouteRouteWithChildren
  '/app/admin/sets': typeof AppAdminSetsRouteRouteWithChildren
  '/app/admin/settings': typeof AppAdminSettingsRouteRouteWithChildren
  '/app/admin/surveys': typeof AppAdminSurveysRouteRouteWithChildren
  '/app/admin/tags': typeof AppAdminTagsRouteRouteWithChildren
  '/app/admin/terms': typeof AppAdminTermsRouteRouteWithChildren
  '/app/admin/users': typeof AppAdminUsersRouteRouteWithChildren
  '/app/organizations/$organizationId': typeof AppOrganizationsOrganizationIdRouteRouteWithChildren
  '/app/survey-previews/$surveyId': typeof AppSurveyPreviewsSurveyIdRouteRouteWithChildren
  '/app/surveys/$surveyOrganizationUuid': typeof AppSurveysSurveyOrganizationUuidRouteRouteWithChildren
  '/app/account/curricula': typeof AppAccountCurriculaRoute
  '/app/account/dashboard': typeof AppAccountDashboardRoute
  '/app/account/deactivate': typeof AppAccountDeactivateRoute
  '/app/account/favorites': typeof AppAccountFavoritesRoute
  '/app/account/forgot': typeof AppAccountForgotRoute
  '/app/account/logged-out': typeof AppAccountLoggedOutRoute
  '/app/account/login': typeof AppAccountLoginRoute
  '/app/account/logout': typeof AppAccountLogoutRoute
  '/app/account/profile': typeof AppAccountProfileRoute
  '/app/account/reactivate': typeof AppAccountReactivateRoute
  '/app/account/welcome-back': typeof AppAccountWelcomeBackRouteWithChildren
  '/app/admin/activity-log': typeof AppAdminActivityLogRoute
  '/app/admin/demos': typeof AppAdminDemosRouteWithChildren
  '/app/admin/guides': typeof AppAdminGuidesRouteWithChildren
  '/app/admin/metrics': typeof AppAdminMetricsRoute
  '/app/deeplink-question/$questionId': typeof AppDeeplinkQuestionQuestionIdRoute
  '/app/deeplink-set/$setId': typeof AppDeeplinkSetSetIdRoute
  '/app/deeplinks/plan': typeof AppDeeplinksPlanRoute
  '/app/deeplinks/team': typeof AppDeeplinksTeamRoute
  '/app/materials/$materialId': typeof AppMaterialsMaterialIdRoute
  '/app/programs/$programId': typeof AppProgramsProgramIdRouteWithChildren
  '/app/resources/$resourceId': typeof AppResourcesResourceIdRoute
  '/app/account/': typeof AppAccountIndexRoute
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/demos/': typeof AppDemosIndexRoute
  '/app/organizations/': typeof AppOrganizationsIndexRoute
  '/app/programs/': typeof AppProgramsIndexRoute
  '/app/resources/': typeof AppResourcesIndexRoute
  '/app/account/twc/join': typeof AppAccountTwcJoinRouteRouteWithChildren
  '/app/admin/lms/audio': typeof AppAdminLmsAudioRouteRouteWithChildren
  '/app/admin/lms/collections': typeof AppAdminLmsCollectionsRouteRouteWithChildren
  '/app/admin/lms/curricula': typeof AppAdminLmsCurriculaRouteRouteWithChildren
  '/app/admin/lms/microlearnings': typeof AppAdminLmsMicrolearningsRouteRouteWithChildren
  '/app/admin/lms/resources': typeof AppAdminLmsResourcesRouteRouteWithChildren
  '/app/admin/lms/trainings-local': typeof AppAdminLmsTrainingsLocalRouteRouteWithChildren
  '/app/admin/organizations/$organizationId': typeof AppAdminOrganizationsOrganizationIdRouteRouteWithChildren
  '/app/admin/programs/$programId': typeof AppAdminProgramsProgramIdRouteRouteWithChildren
  '/app/admin/sets/$setId': typeof AppAdminSetsSetIdRouteRouteWithChildren
  '/app/admin/users/$userId': typeof AppAdminUsersUserIdRouteRouteWithChildren
  '/app/organizations/$organizationId/ahs': typeof AppOrganizationsOrganizationIdAhsRouteRoute
  '/app/organizations/$organizationId/builder': typeof AppOrganizationsOrganizationIdBuilderRouteRouteWithChildren
  '/app/organizations/$organizationId/pending': typeof AppOrganizationsOrganizationIdPendingRouteRoute
  '/app/organizations/$organizationId/plan': typeof AppOrganizationsOrganizationIdPlanRouteRouteWithChildren
  '/app/organizations/$organizationId/quick-start': typeof AppOrganizationsOrganizationIdQuickStartRouteRouteWithChildren
  '/app/organizations/$organizationId/reports': typeof AppOrganizationsOrganizationIdReportsRouteRouteWithChildren
  '/app/organizations/$organizationId/sets': typeof AppOrganizationsOrganizationIdSetsRouteRouteWithChildren
  '/app/organizations/$organizationId/surveys': typeof AppOrganizationsOrganizationIdSurveysRouteRouteWithChildren
  '/app/organizations/$organizationId/team': typeof AppOrganizationsOrganizationIdTeamRouteRouteWithChildren
  '/app/organizations/join/$orgtypeMachineName': typeof AppOrganizationsJoinOrgtypeMachineNameRouteRouteWithChildren
  '/app/account/activity-log/$': typeof AppAccountActivityLogSplatRoute
  '/app/account/redeem-invite/$inviteToken': typeof AppAccountRedeemInviteInviteTokenRoute
  '/app/account/register/verification': typeof AppAccountRegisterVerificationRouteWithChildren
  '/app/account/reset-password/$token': typeof AppAccountResetPasswordTokenRoute
  '/app/account/welcome-back/$token': typeof AppAccountWelcomeBackTokenRoute
  '/app/admin/content/$contentId': typeof AppAdminContentContentIdRoute
  '/app/admin/content/new': typeof AppAdminContentNewRoute
  '/app/admin/criteria/$criterionId': typeof AppAdminCriteriaCriterionIdRoute
  '/app/admin/criteria/new': typeof AppAdminCriteriaNewRoute
  '/app/admin/criterion-topics/$criterionTopicId': typeof AppAdminCriterionTopicsCriterionTopicIdRoute
  '/app/admin/criterion-topics/new': typeof AppAdminCriterionTopicsNewRoute
  '/app/admin/pending/invites': typeof AppAdminPendingInvitesRoute
  '/app/admin/pending/requests': typeof AppAdminPendingRequestsRoute
  '/app/admin/sets/new': typeof AppAdminSetsNewRoute
  '/app/admin/settings/$settingId': typeof AppAdminSettingsSettingIdRoute
  '/app/admin/settings/new': typeof AppAdminSettingsNewRoute
  '/app/admin/surveys/new': typeof AppAdminSurveysNewRoute
  '/app/admin/tags/$tagId': typeof AppAdminTagsTagIdRoute
  '/app/admin/tags/new': typeof AppAdminTagsNewRoute
  '/app/admin/terms/$termId': typeof AppAdminTermsTermIdRoute
  '/app/admin/terms/new': typeof AppAdminTermsNewRoute
  '/app/admin/users/new': typeof AppAdminUsersNewRoute
  '/app/programs/$programId/register': typeof AppProgramsProgramIdRegisterRoute
  '/app/resources/audio/$id': typeof AppResourcesAudioIdRoute
  '/app/resources/collections/$id': typeof AppResourcesCollectionsIdRoute
  '/app/resources/curricula/$id': typeof AppResourcesCurriculaIdRoute
  '/app/resources/microlearnings/$id': typeof AppResourcesMicrolearningsIdRoute
  '/app/resources/trainings-local/$id': typeof AppResourcesTrainingsLocalIdRoute
  '/app/resources/trainings-on-demand/$id': typeof AppResourcesTrainingsOnDemandIdRoute
  '/app/resources/trainings-virtual/$id': typeof AppResourcesTrainingsVirtualIdRoute
  '/app/account/register/': typeof AppAccountRegisterIndexRoute
  '/app/account/twc/': typeof AppAccountTwcIndexRoute
  '/app/admin/content/': typeof AppAdminContentIndexRoute
  '/app/admin/criteria/': typeof AppAdminCriteriaIndexRoute
  '/app/admin/criterion-topics/': typeof AppAdminCriterionTopicsIndexRoute
  '/app/admin/demos/': typeof AppAdminDemosIndexRoute
  '/app/admin/guides/': typeof AppAdminGuidesIndexRoute
  '/app/admin/lms/': typeof AppAdminLmsIndexRoute
  '/app/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/app/admin/programs/': typeof AppAdminProgramsIndexRoute
  '/app/admin/sets/': typeof AppAdminSetsIndexRoute
  '/app/admin/settings/': typeof AppAdminSettingsIndexRoute
  '/app/admin/surveys/': typeof AppAdminSurveysIndexRoute
  '/app/admin/tags/': typeof AppAdminTagsIndexRoute
  '/app/admin/terms/': typeof AppAdminTermsIndexRoute
  '/app/admin/users/': typeof AppAdminUsersIndexRoute
  '/app/demos/sets/': typeof AppDemosSetsIndexRoute
  '/app/organizations/$organizationId/': typeof AppOrganizationsOrganizationIdIndexRoute
  '/app/organizations/join/': typeof AppOrganizationsJoinIndexRoute
  '/app/survey-previews/$surveyId/': typeof AppSurveyPreviewsSurveyIdIndexRoute
  '/app/surveys/$surveyOrganizationUuid/': typeof AppSurveysSurveyOrganizationUuidIndexRoute
  '/app/admin/sets/$setId/modules': typeof AppAdminSetsSetIdModulesRouteRouteWithChildren
  '/app/admin/sets/$setId/questions': typeof AppAdminSetsSetIdQuestionsRouteRouteWithChildren
  '/app/admin/surveys/$surveyId/questions': typeof AppAdminSurveysSurveyIdQuestionsRouteRouteWithChildren
  '/app/admin/surveys/$surveyId/topics': typeof AppAdminSurveysSurveyIdTopicsRouteRouteWithChildren
  '/app/admin/users/$userId/organizations': typeof AppAdminUsersUserIdOrganizationsRouteRouteWithChildren
  '/app/organizations/$organizationId/sets/$setId': typeof AppOrganizationsOrganizationIdSetsSetIdRouteRouteWithChildren
  '/app/account/twc/join/$orgType': typeof AppAccountTwcJoinOrgTypeRouteWithChildren
  '/app/admin/demos/sets/default': typeof AppAdminDemosSetsDefaultRoute
  '/app/admin/lms/audio/$audioId': typeof AppAdminLmsAudioAudioIdRoute
  '/app/admin/lms/audio/new': typeof AppAdminLmsAudioNewRoute
  '/app/admin/lms/collections/$collectionId': typeof AppAdminLmsCollectionsCollectionIdRoute
  '/app/admin/lms/collections/new': typeof AppAdminLmsCollectionsNewRoute
  '/app/admin/lms/curricula/$curriculumId': typeof AppAdminLmsCurriculaCurriculumIdRoute
  '/app/admin/lms/curricula/new': typeof AppAdminLmsCurriculaNewRoute
  '/app/admin/lms/materials/$materialId': typeof AppAdminLmsMaterialsMaterialIdRoute
  '/app/admin/lms/microlearnings/$microlearningId': typeof AppAdminLmsMicrolearningsMicrolearningIdRoute
  '/app/admin/lms/microlearnings/new': typeof AppAdminLmsMicrolearningsNewRoute
  '/app/admin/lms/resources/$resourceId': typeof AppAdminLmsResourcesResourceIdRoute
  '/app/admin/lms/resources/new': typeof AppAdminLmsResourcesNewRoute
  '/app/admin/lms/trainings-local/$trainingId': typeof AppAdminLmsTrainingsLocalTrainingIdRoute
  '/app/admin/lms/trainings-local/new': typeof AppAdminLmsTrainingsLocalNewRoute
  '/app/admin/lms/trainings-on-demand/$trainingId': typeof AppAdminLmsTrainingsOnDemandTrainingIdRoute
  '/app/admin/lms/trainings-virtual/$trainingId': typeof AppAdminLmsTrainingsVirtualTrainingIdRoute
  '/app/admin/organizations/$organizationId/team': typeof AppAdminOrganizationsOrganizationIdTeamRoute
  '/app/admin/programs/$programId/organizations': typeof AppAdminProgramsProgramIdOrganizationsRoute
  '/app/admin/programs/$programId/sets': typeof AppAdminProgramsProgramIdSetsRoute
  '/app/admin/sets/$setId/clone': typeof AppAdminSetsSetIdCloneRoute
  '/app/admin/sets/$setId/demo': typeof AppAdminSetsSetIdDemoRoute
  '/app/admin/users/$userId/pending': typeof AppAdminUsersUserIdPendingRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteWithChildren
  '/app/organizations/$organizationId/overview/$tab': typeof AppOrganizationsOrganizationIdOverviewTabRoute
  '/app/organizations/$organizationId/surveys/$surveyId': typeof AppOrganizationsOrganizationIdSurveysSurveyIdRoute
  '/app/organizations/$organizationId/team/invite': typeof AppOrganizationsOrganizationIdTeamInviteRoute
  '/app/organizations/join/$orgtypeMachineName/$organizationId': typeof AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute
  '/app/organizations/join/$orgtypeMachineName/find': typeof AppOrganizationsJoinOrgtypeMachineNameFindRoute
  '/app/survey-previews/$surveyId/$languageId/confirmation': typeof AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute
  '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation': typeof AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute
  '/app/account/register/verification/': typeof AppAccountRegisterVerificationIndexRoute
  '/app/account/twc/join/': typeof AppAccountTwcJoinIndexRoute
  '/app/admin/demos/sets/': typeof AppAdminDemosSetsIndexRoute
  '/app/admin/organizations/$organizationId/': typeof AppAdminOrganizationsOrganizationIdIndexRoute
  '/app/admin/programs/$programId/': typeof AppAdminProgramsProgramIdIndexRoute
  '/app/admin/sets/$setId/': typeof AppAdminSetsSetIdIndexRoute
  '/app/admin/surveys/$surveyId/': typeof AppAdminSurveysSurveyIdIndexRoute
  '/app/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/app/deeplinks/programs/$programId/': typeof AppDeeplinksProgramsProgramIdIndexRoute
  '/app/demos/sets/$setId/': typeof AppDemosSetsSetIdIndexRoute
  '/app/organizations/$organizationId/builder/': typeof AppOrganizationsOrganizationIdBuilderIndexRoute
  '/app/organizations/$organizationId/overview/': typeof AppOrganizationsOrganizationIdOverviewIndexRoute
  '/app/organizations/$organizationId/plan/': typeof AppOrganizationsOrganizationIdPlanIndexRoute
  '/app/organizations/$organizationId/quick-start/': typeof AppOrganizationsOrganizationIdQuickStartIndexRoute
  '/app/organizations/$organizationId/reports/': typeof AppOrganizationsOrganizationIdReportsIndexRoute
  '/app/organizations/$organizationId/sets/': typeof AppOrganizationsOrganizationIdSetsIndexRoute
  '/app/programs/$programId/organizations/': typeof AppProgramsProgramIdOrganizationsIndexRoute
  '/app/survey-previews/$surveyId/$languageId/': typeof AppSurveyPreviewsSurveyIdLanguageIdIndexRoute
  '/app/surveys/$surveyOrganizationUuid/$languageId/': typeof AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteWithChildren
  '/app/account/register/verification/url/$encodedUrl': typeof AppAccountRegisterVerificationUrlEncodedUrlRoute
  '/app/account/twc/join/$orgType/$orgId': typeof AppAccountTwcJoinOrgTypeOrgIdRouteWithChildren
  '/app/admin/sets/$setId/modules/$moduleId': typeof AppAdminSetsSetIdModulesModuleIdRoute
  '/app/admin/sets/$setId/modules/new': typeof AppAdminSetsSetIdModulesNewRoute
  '/app/admin/sets/$setId/questions/$questionId': typeof AppAdminSetsSetIdQuestionsQuestionIdRoute
  '/app/admin/sets/$setId/questions/new': typeof AppAdminSetsSetIdQuestionsNewRoute
  '/app/admin/surveys/$surveyId/questions/$questionId': typeof AppAdminSurveysSurveyIdQuestionsQuestionIdRoute
  '/app/admin/surveys/$surveyId/questions/new': typeof AppAdminSurveysSurveyIdQuestionsNewRoute
  '/app/admin/surveys/$surveyId/topics/$topicId': typeof AppAdminSurveysSurveyIdTopicsTopicIdRoute
  '/app/admin/surveys/$surveyId/topics/new': typeof AppAdminSurveysSurveyIdTopicsNewRoute
  '/app/admin/users/$userId/organizations/$organizationId': typeof AppAdminUsersUserIdOrganizationsOrganizationIdRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteWithChildren
  '/app/organizations/$organizationId/plan/items/$itemId': typeof AppOrganizationsOrganizationIdPlanItemsItemIdRoute
  '/app/organizations/$organizationId/plan/items/new': typeof AppOrganizationsOrganizationIdPlanItemsNewRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteWithChildren
  '/app/organizations/$organizationId/reports/modules/$moduleId': typeof AppOrganizationsOrganizationIdReportsModulesModuleIdRoute
  '/app/organizations/$organizationId/reports/sets/$setId': typeof AppOrganizationsOrganizationIdReportsSetsSetIdRoute
  '/app/organizations/$organizationId/sets/$setId/calculator': typeof AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  '/app/organizations/$organizationId/sets/$setId/glossary': typeof AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute
  '/app/organizations/$organizationId/sets/$setId/report': typeof AppOrganizationsOrganizationIdSetsSetIdReportRouteWithChildren
  '/app/admin/sets/$setId/modules/': typeof AppAdminSetsSetIdModulesIndexRoute
  '/app/admin/sets/$setId/questions/': typeof AppAdminSetsSetIdQuestionsIndexRoute
  '/app/admin/surveys/$surveyId/questions/': typeof AppAdminSurveysSurveyIdQuestionsIndexRoute
  '/app/admin/surveys/$surveyId/topics/': typeof AppAdminSurveysSurveyIdTopicsIndexRoute
  '/app/admin/users/$userId/organizations/': typeof AppAdminUsersUserIdOrganizationsIndexRoute
  '/app/demos/sets/$setId/view/': typeof AppDemosSetsSetIdViewIndexRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute
  '/app/organizations/$organizationId/sets/$setId/': typeof AppOrganizationsOrganizationIdSetsSetIdIndexRoute
  '/app/account/twc/join/$orgType/$orgId/$ufcId': typeof AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute
  '/app/demos/sets/$setId/view/$activeDemoView/$questionId': typeof AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute
  '/app/organizations/$organizationId/sets/$setId/modules/$moduleId': typeof AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute
  '/app/organizations/$organizationId/sets/$setId/questions/$questionId': typeof AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute
  '/app/deeplinks/programs/$programId/sets/$setId/': typeof AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute
  '/app/demos/sets/$setId/view/$activeDemoView/': typeof AppDemosSetsSetIdViewActiveDemoViewIndexRoute
  '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/': typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute
  '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/': typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute
  '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId': typeof AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute
  '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId': typeof AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute
  '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId': typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute
  '/app/organizations/$organizationId/sets/$setId/report/download/$format': typeof AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator': typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary': typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/app/account'
    | '/app/admin'
    | '/app/deeplinks'
    | '/app/organizations'
    | '/app/resources'
    | '/app/admin/content'
    | '/app/admin/criteria'
    | '/app/admin/criterion-topics'
    | '/app/admin/lms'
    | '/app/admin/organizations'
    | '/app/admin/pending'
    | '/app/admin/programs'
    | '/app/admin/sets'
    | '/app/admin/settings'
    | '/app/admin/surveys'
    | '/app/admin/tags'
    | '/app/admin/terms'
    | '/app/admin/users'
    | '/app/organizations/$organizationId'
    | '/app/survey-previews/$surveyId'
    | '/app/surveys/$surveyOrganizationUuid'
    | '/app/account/curricula'
    | '/app/account/dashboard'
    | '/app/account/deactivate'
    | '/app/account/favorites'
    | '/app/account/forgot'
    | '/app/account/logged-out'
    | '/app/account/login'
    | '/app/account/logout'
    | '/app/account/profile'
    | '/app/account/reactivate'
    | '/app/account/welcome-back'
    | '/app/admin/activity-log'
    | '/app/admin/demos'
    | '/app/admin/guides'
    | '/app/admin/metrics'
    | '/app/deeplink-question/$questionId'
    | '/app/deeplink-set/$setId'
    | '/app/deeplinks/plan'
    | '/app/deeplinks/team'
    | '/app/materials/$materialId'
    | '/app/programs/$programId'
    | '/app/resources/$resourceId'
    | '/app/account/'
    | '/app/admin/'
    | '/app/demos/'
    | '/app/organizations/'
    | '/app/programs/'
    | '/app/resources/'
    | '/app/account/twc/join'
    | '/app/admin/lms/audio'
    | '/app/admin/lms/collections'
    | '/app/admin/lms/curricula'
    | '/app/admin/lms/microlearnings'
    | '/app/admin/lms/resources'
    | '/app/admin/lms/trainings-local'
    | '/app/admin/organizations/$organizationId'
    | '/app/admin/programs/$programId'
    | '/app/admin/sets/$setId'
    | '/app/admin/users/$userId'
    | '/app/organizations/$organizationId/ahs'
    | '/app/organizations/$organizationId/builder'
    | '/app/organizations/$organizationId/pending'
    | '/app/organizations/$organizationId/plan'
    | '/app/organizations/$organizationId/quick-start'
    | '/app/organizations/$organizationId/reports'
    | '/app/organizations/$organizationId/sets'
    | '/app/organizations/$organizationId/surveys'
    | '/app/organizations/$organizationId/team'
    | '/app/organizations/join/$orgtypeMachineName'
    | '/app/account/activity-log/$'
    | '/app/account/redeem-invite/$inviteToken'
    | '/app/account/register/verification'
    | '/app/account/reset-password/$token'
    | '/app/account/welcome-back/$token'
    | '/app/admin/content/$contentId'
    | '/app/admin/content/new'
    | '/app/admin/criteria/$criterionId'
    | '/app/admin/criteria/new'
    | '/app/admin/criterion-topics/$criterionTopicId'
    | '/app/admin/criterion-topics/new'
    | '/app/admin/pending/invites'
    | '/app/admin/pending/requests'
    | '/app/admin/sets/new'
    | '/app/admin/settings/$settingId'
    | '/app/admin/settings/new'
    | '/app/admin/surveys/new'
    | '/app/admin/tags/$tagId'
    | '/app/admin/tags/new'
    | '/app/admin/terms/$termId'
    | '/app/admin/terms/new'
    | '/app/admin/users/new'
    | '/app/programs/$programId/register'
    | '/app/resources/audio/$id'
    | '/app/resources/collections/$id'
    | '/app/resources/curricula/$id'
    | '/app/resources/microlearnings/$id'
    | '/app/resources/trainings-local/$id'
    | '/app/resources/trainings-on-demand/$id'
    | '/app/resources/trainings-virtual/$id'
    | '/app/account/register/'
    | '/app/account/twc/'
    | '/app/admin/content/'
    | '/app/admin/criteria/'
    | '/app/admin/criterion-topics/'
    | '/app/admin/demos/'
    | '/app/admin/guides/'
    | '/app/admin/lms/'
    | '/app/admin/organizations/'
    | '/app/admin/programs/'
    | '/app/admin/sets/'
    | '/app/admin/settings/'
    | '/app/admin/surveys/'
    | '/app/admin/tags/'
    | '/app/admin/terms/'
    | '/app/admin/users/'
    | '/app/demos/sets/'
    | '/app/organizations/$organizationId/'
    | '/app/organizations/join/'
    | '/app/survey-previews/$surveyId/'
    | '/app/surveys/$surveyOrganizationUuid/'
    | '/app/admin/sets/$setId/modules'
    | '/app/admin/sets/$setId/questions'
    | '/app/admin/surveys/$surveyId/questions'
    | '/app/admin/surveys/$surveyId/topics'
    | '/app/admin/users/$userId/organizations'
    | '/app/organizations/$organizationId/sets/$setId'
    | '/app/account/twc/join/$orgType'
    | '/app/admin/demos/sets/default'
    | '/app/admin/lms/audio/$audioId'
    | '/app/admin/lms/audio/new'
    | '/app/admin/lms/collections/$collectionId'
    | '/app/admin/lms/collections/new'
    | '/app/admin/lms/curricula/$curriculumId'
    | '/app/admin/lms/curricula/new'
    | '/app/admin/lms/materials/$materialId'
    | '/app/admin/lms/microlearnings/$microlearningId'
    | '/app/admin/lms/microlearnings/new'
    | '/app/admin/lms/resources/$resourceId'
    | '/app/admin/lms/resources/new'
    | '/app/admin/lms/trainings-local/$trainingId'
    | '/app/admin/lms/trainings-local/new'
    | '/app/admin/lms/trainings-on-demand/$trainingId'
    | '/app/admin/lms/trainings-virtual/$trainingId'
    | '/app/admin/organizations/$organizationId/team'
    | '/app/admin/programs/$programId/organizations'
    | '/app/admin/programs/$programId/sets'
    | '/app/admin/sets/$setId/clone'
    | '/app/admin/sets/$setId/demo'
    | '/app/admin/users/$userId/pending'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug'
    | '/app/organizations/$organizationId/overview/$tab'
    | '/app/organizations/$organizationId/surveys/$surveyId'
    | '/app/organizations/$organizationId/team/invite'
    | '/app/organizations/join/$orgtypeMachineName/$organizationId'
    | '/app/organizations/join/$orgtypeMachineName/find'
    | '/app/survey-previews/$surveyId/$languageId/confirmation'
    | '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation'
    | '/app/account/register/verification/'
    | '/app/account/twc/join/'
    | '/app/admin/demos/sets/'
    | '/app/admin/organizations/$organizationId/'
    | '/app/admin/programs/$programId/'
    | '/app/admin/sets/$setId/'
    | '/app/admin/surveys/$surveyId/'
    | '/app/admin/users/$userId/'
    | '/app/deeplinks/programs/$programId/'
    | '/app/demos/sets/$setId/'
    | '/app/organizations/$organizationId/builder/'
    | '/app/organizations/$organizationId/overview/'
    | '/app/organizations/$organizationId/plan/'
    | '/app/organizations/$organizationId/quick-start/'
    | '/app/organizations/$organizationId/reports/'
    | '/app/organizations/$organizationId/sets/'
    | '/app/programs/$programId/organizations/'
    | '/app/survey-previews/$surveyId/$languageId/'
    | '/app/surveys/$surveyOrganizationUuid/$languageId/'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId'
    | '/app/account/register/verification/url/$encodedUrl'
    | '/app/account/twc/join/$orgType/$orgId'
    | '/app/admin/sets/$setId/modules/$moduleId'
    | '/app/admin/sets/$setId/modules/new'
    | '/app/admin/sets/$setId/questions/$questionId'
    | '/app/admin/sets/$setId/questions/new'
    | '/app/admin/surveys/$surveyId/questions/$questionId'
    | '/app/admin/surveys/$surveyId/questions/new'
    | '/app/admin/surveys/$surveyId/topics/$topicId'
    | '/app/admin/surveys/$surveyId/topics/new'
    | '/app/admin/users/$userId/organizations/$organizationId'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format'
    | '/app/organizations/$organizationId/plan/items/$itemId'
    | '/app/organizations/$organizationId/plan/items/new'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName'
    | '/app/organizations/$organizationId/reports/modules/$moduleId'
    | '/app/organizations/$organizationId/reports/sets/$setId'
    | '/app/organizations/$organizationId/sets/$setId/calculator'
    | '/app/organizations/$organizationId/sets/$setId/glossary'
    | '/app/organizations/$organizationId/sets/$setId/report'
    | '/app/admin/sets/$setId/modules/'
    | '/app/admin/sets/$setId/questions/'
    | '/app/admin/surveys/$surveyId/questions/'
    | '/app/admin/surveys/$surveyId/topics/'
    | '/app/admin/users/$userId/organizations/'
    | '/app/demos/sets/$setId/view/'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/'
    | '/app/organizations/$organizationId/sets/$setId/'
    | '/app/account/twc/join/$orgType/$orgId/$ufcId'
    | '/app/demos/sets/$setId/view/$activeDemoView/$questionId'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide'
    | '/app/organizations/$organizationId/sets/$setId/modules/$moduleId'
    | '/app/organizations/$organizationId/sets/$setId/questions/$questionId'
    | '/app/deeplinks/programs/$programId/sets/$setId/'
    | '/app/demos/sets/$setId/view/$activeDemoView/'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/'
    | '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId'
    | '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId'
    | '/app/organizations/$organizationId/sets/$setId/report/download/$format'
    | '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator'
    | '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/app/deeplinks'
    | '/app/admin/pending'
    | '/app/account/curricula'
    | '/app/account/dashboard'
    | '/app/account/deactivate'
    | '/app/account/favorites'
    | '/app/account/forgot'
    | '/app/account/logged-out'
    | '/app/account/login'
    | '/app/account/logout'
    | '/app/account/profile'
    | '/app/account/reactivate'
    | '/app/account/welcome-back'
    | '/app/admin/activity-log'
    | '/app/admin/metrics'
    | '/app/deeplink-question/$questionId'
    | '/app/deeplink-set/$setId'
    | '/app/deeplinks/plan'
    | '/app/deeplinks/team'
    | '/app/materials/$materialId'
    | '/app/programs/$programId'
    | '/app/resources/$resourceId'
    | '/app/account'
    | '/app/admin'
    | '/app/demos'
    | '/app/organizations'
    | '/app/programs'
    | '/app/resources'
    | '/app/admin/lms/audio'
    | '/app/admin/lms/collections'
    | '/app/admin/lms/curricula'
    | '/app/admin/lms/microlearnings'
    | '/app/admin/lms/resources'
    | '/app/admin/lms/trainings-local'
    | '/app/organizations/$organizationId/ahs'
    | '/app/organizations/$organizationId/pending'
    | '/app/organizations/$organizationId/surveys'
    | '/app/organizations/$organizationId/team'
    | '/app/organizations/join/$orgtypeMachineName'
    | '/app/account/activity-log/$'
    | '/app/account/redeem-invite/$inviteToken'
    | '/app/account/reset-password/$token'
    | '/app/account/welcome-back/$token'
    | '/app/admin/content/$contentId'
    | '/app/admin/content/new'
    | '/app/admin/criteria/$criterionId'
    | '/app/admin/criteria/new'
    | '/app/admin/criterion-topics/$criterionTopicId'
    | '/app/admin/criterion-topics/new'
    | '/app/admin/pending/invites'
    | '/app/admin/pending/requests'
    | '/app/admin/sets/new'
    | '/app/admin/settings/$settingId'
    | '/app/admin/settings/new'
    | '/app/admin/surveys/new'
    | '/app/admin/tags/$tagId'
    | '/app/admin/tags/new'
    | '/app/admin/terms/$termId'
    | '/app/admin/terms/new'
    | '/app/admin/users/new'
    | '/app/programs/$programId/register'
    | '/app/resources/audio/$id'
    | '/app/resources/collections/$id'
    | '/app/resources/curricula/$id'
    | '/app/resources/microlearnings/$id'
    | '/app/resources/trainings-local/$id'
    | '/app/resources/trainings-on-demand/$id'
    | '/app/resources/trainings-virtual/$id'
    | '/app/account/register'
    | '/app/account/twc'
    | '/app/admin/content'
    | '/app/admin/criteria'
    | '/app/admin/criterion-topics'
    | '/app/admin/demos'
    | '/app/admin/guides'
    | '/app/admin/lms'
    | '/app/admin/organizations'
    | '/app/admin/programs'
    | '/app/admin/sets'
    | '/app/admin/settings'
    | '/app/admin/surveys'
    | '/app/admin/tags'
    | '/app/admin/terms'
    | '/app/admin/users'
    | '/app/demos/sets'
    | '/app/organizations/$organizationId'
    | '/app/organizations/join'
    | '/app/survey-previews/$surveyId'
    | '/app/surveys/$surveyOrganizationUuid'
    | '/app/account/twc/join/$orgType'
    | '/app/admin/demos/sets/default'
    | '/app/admin/lms/audio/$audioId'
    | '/app/admin/lms/audio/new'
    | '/app/admin/lms/collections/$collectionId'
    | '/app/admin/lms/collections/new'
    | '/app/admin/lms/curricula/$curriculumId'
    | '/app/admin/lms/curricula/new'
    | '/app/admin/lms/materials/$materialId'
    | '/app/admin/lms/microlearnings/$microlearningId'
    | '/app/admin/lms/microlearnings/new'
    | '/app/admin/lms/resources/$resourceId'
    | '/app/admin/lms/resources/new'
    | '/app/admin/lms/trainings-local/$trainingId'
    | '/app/admin/lms/trainings-local/new'
    | '/app/admin/lms/trainings-on-demand/$trainingId'
    | '/app/admin/lms/trainings-virtual/$trainingId'
    | '/app/admin/organizations/$organizationId/team'
    | '/app/admin/programs/$programId/organizations'
    | '/app/admin/programs/$programId/sets'
    | '/app/admin/sets/$setId/clone'
    | '/app/admin/sets/$setId/demo'
    | '/app/admin/users/$userId/pending'
    | '/app/organizations/$organizationId/overview/$tab'
    | '/app/organizations/$organizationId/surveys/$surveyId'
    | '/app/organizations/$organizationId/team/invite'
    | '/app/organizations/join/$orgtypeMachineName/$organizationId'
    | '/app/organizations/join/$orgtypeMachineName/find'
    | '/app/survey-previews/$surveyId/$languageId/confirmation'
    | '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation'
    | '/app/account/register/verification'
    | '/app/account/twc/join'
    | '/app/admin/demos/sets'
    | '/app/admin/organizations/$organizationId'
    | '/app/admin/programs/$programId'
    | '/app/admin/sets/$setId'
    | '/app/admin/surveys/$surveyId'
    | '/app/admin/users/$userId'
    | '/app/deeplinks/programs/$programId'
    | '/app/demos/sets/$setId'
    | '/app/organizations/$organizationId/builder'
    | '/app/organizations/$organizationId/overview'
    | '/app/organizations/$organizationId/plan'
    | '/app/organizations/$organizationId/quick-start'
    | '/app/organizations/$organizationId/reports'
    | '/app/organizations/$organizationId/sets'
    | '/app/programs/$programId/organizations'
    | '/app/survey-previews/$surveyId/$languageId'
    | '/app/surveys/$surveyOrganizationUuid/$languageId'
    | '/app/account/register/verification/url/$encodedUrl'
    | '/app/account/twc/join/$orgType/$orgId'
    | '/app/admin/sets/$setId/modules/$moduleId'
    | '/app/admin/sets/$setId/modules/new'
    | '/app/admin/sets/$setId/questions/$questionId'
    | '/app/admin/sets/$setId/questions/new'
    | '/app/admin/surveys/$surveyId/questions/$questionId'
    | '/app/admin/surveys/$surveyId/questions/new'
    | '/app/admin/surveys/$surveyId/topics/$topicId'
    | '/app/admin/surveys/$surveyId/topics/new'
    | '/app/admin/users/$userId/organizations/$organizationId'
    | '/app/organizations/$organizationId/plan/items/$itemId'
    | '/app/organizations/$organizationId/plan/items/new'
    | '/app/organizations/$organizationId/reports/modules/$moduleId'
    | '/app/organizations/$organizationId/reports/sets/$setId'
    | '/app/organizations/$organizationId/sets/$setId/calculator'
    | '/app/organizations/$organizationId/sets/$setId/glossary'
    | '/app/organizations/$organizationId/sets/$setId/report'
    | '/app/admin/sets/$setId/modules'
    | '/app/admin/sets/$setId/questions'
    | '/app/admin/surveys/$surveyId/questions'
    | '/app/admin/surveys/$surveyId/topics'
    | '/app/admin/users/$userId/organizations'
    | '/app/demos/sets/$setId/view'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug'
    | '/app/organizations/$organizationId/sets/$setId'
    | '/app/account/twc/join/$orgType/$orgId/$ufcId'
    | '/app/demos/sets/$setId/view/$activeDemoView/$questionId'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide'
    | '/app/organizations/$organizationId/sets/$setId/modules/$moduleId'
    | '/app/organizations/$organizationId/sets/$setId/questions/$questionId'
    | '/app/deeplinks/programs/$programId/sets/$setId'
    | '/app/demos/sets/$setId/view/$activeDemoView'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName'
    | '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId'
    | '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId'
    | '/app/organizations/$organizationId/sets/$setId/report/download/$format'
    | '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator'
    | '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/app/account'
    | '/app/admin'
    | '/app/deeplinks'
    | '/app/organizations'
    | '/app/resources'
    | '/app/admin/content'
    | '/app/admin/criteria'
    | '/app/admin/criterion-topics'
    | '/app/admin/lms'
    | '/app/admin/organizations'
    | '/app/admin/pending'
    | '/app/admin/programs'
    | '/app/admin/sets'
    | '/app/admin/settings'
    | '/app/admin/surveys'
    | '/app/admin/tags'
    | '/app/admin/terms'
    | '/app/admin/users'
    | '/app/organizations/$organizationId'
    | '/app/survey-previews/$surveyId'
    | '/app/surveys/$surveyOrganizationUuid'
    | '/app/account/curricula'
    | '/app/account/dashboard'
    | '/app/account/deactivate'
    | '/app/account/favorites'
    | '/app/account/forgot'
    | '/app/account/logged-out'
    | '/app/account/login'
    | '/app/account/logout'
    | '/app/account/profile'
    | '/app/account/reactivate'
    | '/app/account/welcome-back'
    | '/app/admin/activity-log'
    | '/app/admin/demos'
    | '/app/admin/guides'
    | '/app/admin/metrics'
    | '/app/deeplink-question/$questionId'
    | '/app/deeplink-set/$setId'
    | '/app/deeplinks/plan'
    | '/app/deeplinks/team'
    | '/app/materials/$materialId'
    | '/app/programs/$programId'
    | '/app/resources/$resourceId'
    | '/app/account/'
    | '/app/admin/'
    | '/app/demos/'
    | '/app/organizations/'
    | '/app/programs/'
    | '/app/resources/'
    | '/app/account/twc/join'
    | '/app/admin/lms/audio'
    | '/app/admin/lms/collections'
    | '/app/admin/lms/curricula'
    | '/app/admin/lms/microlearnings'
    | '/app/admin/lms/resources'
    | '/app/admin/lms/trainings-local'
    | '/app/admin/organizations/$organizationId'
    | '/app/admin/programs/$programId'
    | '/app/admin/sets/$setId'
    | '/app/admin/users/$userId'
    | '/app/organizations/$organizationId/ahs'
    | '/app/organizations/$organizationId/builder'
    | '/app/organizations/$organizationId/pending'
    | '/app/organizations/$organizationId/plan'
    | '/app/organizations/$organizationId/quick-start'
    | '/app/organizations/$organizationId/reports'
    | '/app/organizations/$organizationId/sets'
    | '/app/organizations/$organizationId/surveys'
    | '/app/organizations/$organizationId/team'
    | '/app/organizations/join/$orgtypeMachineName'
    | '/app/account/activity-log/$'
    | '/app/account/redeem-invite/$inviteToken'
    | '/app/account/register/verification'
    | '/app/account/reset-password/$token'
    | '/app/account/welcome-back/$token'
    | '/app/admin/content/$contentId'
    | '/app/admin/content/new'
    | '/app/admin/criteria/$criterionId'
    | '/app/admin/criteria/new'
    | '/app/admin/criterion-topics/$criterionTopicId'
    | '/app/admin/criterion-topics/new'
    | '/app/admin/pending/invites'
    | '/app/admin/pending/requests'
    | '/app/admin/sets/new'
    | '/app/admin/settings/$settingId'
    | '/app/admin/settings/new'
    | '/app/admin/surveys/new'
    | '/app/admin/tags/$tagId'
    | '/app/admin/tags/new'
    | '/app/admin/terms/$termId'
    | '/app/admin/terms/new'
    | '/app/admin/users/new'
    | '/app/programs/$programId/register'
    | '/app/resources/audio/$id'
    | '/app/resources/collections/$id'
    | '/app/resources/curricula/$id'
    | '/app/resources/microlearnings/$id'
    | '/app/resources/trainings-local/$id'
    | '/app/resources/trainings-on-demand/$id'
    | '/app/resources/trainings-virtual/$id'
    | '/app/account/register/'
    | '/app/account/twc/'
    | '/app/admin/content/'
    | '/app/admin/criteria/'
    | '/app/admin/criterion-topics/'
    | '/app/admin/demos/'
    | '/app/admin/guides/'
    | '/app/admin/lms/'
    | '/app/admin/organizations/'
    | '/app/admin/programs/'
    | '/app/admin/sets/'
    | '/app/admin/settings/'
    | '/app/admin/surveys/'
    | '/app/admin/tags/'
    | '/app/admin/terms/'
    | '/app/admin/users/'
    | '/app/demos/sets/'
    | '/app/organizations/$organizationId/'
    | '/app/organizations/join/'
    | '/app/survey-previews/$surveyId/'
    | '/app/surveys/$surveyOrganizationUuid/'
    | '/app/admin/sets/$setId/modules'
    | '/app/admin/sets/$setId/questions'
    | '/app/admin/surveys/$surveyId/questions'
    | '/app/admin/surveys/$surveyId/topics'
    | '/app/admin/users/$userId/organizations'
    | '/app/organizations/$organizationId/sets/$setId'
    | '/app/account/twc/join/$orgType'
    | '/app/admin/demos/sets/default'
    | '/app/admin/lms/audio/$audioId'
    | '/app/admin/lms/audio/new'
    | '/app/admin/lms/collections/$collectionId'
    | '/app/admin/lms/collections/new'
    | '/app/admin/lms/curricula/$curriculumId'
    | '/app/admin/lms/curricula/new'
    | '/app/admin/lms/materials/$materialId'
    | '/app/admin/lms/microlearnings/$microlearningId'
    | '/app/admin/lms/microlearnings/new'
    | '/app/admin/lms/resources/$resourceId'
    | '/app/admin/lms/resources/new'
    | '/app/admin/lms/trainings-local/$trainingId'
    | '/app/admin/lms/trainings-local/new'
    | '/app/admin/lms/trainings-on-demand/$trainingId'
    | '/app/admin/lms/trainings-virtual/$trainingId'
    | '/app/admin/organizations/$organizationId/team'
    | '/app/admin/programs/$programId/organizations'
    | '/app/admin/programs/$programId/sets'
    | '/app/admin/sets/$setId/clone'
    | '/app/admin/sets/$setId/demo'
    | '/app/admin/users/$userId/pending'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug'
    | '/app/organizations/$organizationId/overview/$tab'
    | '/app/organizations/$organizationId/surveys/$surveyId'
    | '/app/organizations/$organizationId/team/invite'
    | '/app/organizations/join/$orgtypeMachineName/$organizationId'
    | '/app/organizations/join/$orgtypeMachineName/find'
    | '/app/survey-previews/$surveyId/$languageId/confirmation'
    | '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation'
    | '/app/account/register/verification/'
    | '/app/account/twc/join/'
    | '/app/admin/demos/sets/'
    | '/app/admin/organizations/$organizationId/'
    | '/app/admin/programs/$programId/'
    | '/app/admin/sets/$setId/'
    | '/app/admin/surveys/$surveyId/'
    | '/app/admin/users/$userId/'
    | '/app/deeplinks/programs/$programId/'
    | '/app/demos/sets/$setId/'
    | '/app/organizations/$organizationId/builder/'
    | '/app/organizations/$organizationId/overview/'
    | '/app/organizations/$organizationId/plan/'
    | '/app/organizations/$organizationId/quick-start/'
    | '/app/organizations/$organizationId/reports/'
    | '/app/organizations/$organizationId/sets/'
    | '/app/programs/$programId/organizations/'
    | '/app/survey-previews/$surveyId/$languageId/'
    | '/app/surveys/$surveyOrganizationUuid/$languageId/'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId'
    | '/app/account/register/verification/url/$encodedUrl'
    | '/app/account/twc/join/$orgType/$orgId'
    | '/app/admin/sets/$setId/modules/$moduleId'
    | '/app/admin/sets/$setId/modules/new'
    | '/app/admin/sets/$setId/questions/$questionId'
    | '/app/admin/sets/$setId/questions/new'
    | '/app/admin/surveys/$surveyId/questions/$questionId'
    | '/app/admin/surveys/$surveyId/questions/new'
    | '/app/admin/surveys/$surveyId/topics/$topicId'
    | '/app/admin/surveys/$surveyId/topics/new'
    | '/app/admin/users/$userId/organizations/$organizationId'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format'
    | '/app/organizations/$organizationId/plan/items/$itemId'
    | '/app/organizations/$organizationId/plan/items/new'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName'
    | '/app/organizations/$organizationId/reports/modules/$moduleId'
    | '/app/organizations/$organizationId/reports/sets/$setId'
    | '/app/organizations/$organizationId/sets/$setId/calculator'
    | '/app/organizations/$organizationId/sets/$setId/glossary'
    | '/app/organizations/$organizationId/sets/$setId/report'
    | '/app/admin/sets/$setId/modules/'
    | '/app/admin/sets/$setId/questions/'
    | '/app/admin/surveys/$surveyId/questions/'
    | '/app/admin/surveys/$surveyId/topics/'
    | '/app/admin/users/$userId/organizations/'
    | '/app/demos/sets/$setId/view/'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/'
    | '/app/organizations/$organizationId/sets/$setId/'
    | '/app/account/twc/join/$orgType/$orgId/$ufcId'
    | '/app/demos/sets/$setId/view/$activeDemoView/$questionId'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide'
    | '/app/organizations/$organizationId/sets/$setId/modules/$moduleId'
    | '/app/organizations/$organizationId/sets/$setId/questions/$questionId'
    | '/app/deeplinks/programs/$programId/sets/$setId/'
    | '/app/demos/sets/$setId/view/$activeDemoView/'
    | '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/'
    | '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/'
    | '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId'
    | '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId'
    | '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId'
    | '/app/organizations/$organizationId/sets/$setId/report/download/$format'
    | '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator'
    | '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/account': {
      id: '/app/account'
      path: '/account'
      fullPath: '/app/account'
      preLoaderRoute: typeof AppAccountRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/admin': {
      id: '/app/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/deeplinks': {
      id: '/app/deeplinks'
      path: '/deeplinks'
      fullPath: '/app/deeplinks'
      preLoaderRoute: typeof AppDeeplinksRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/organizations': {
      id: '/app/organizations'
      path: '/organizations'
      fullPath: '/app/organizations'
      preLoaderRoute: typeof AppOrganizationsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/resources': {
      id: '/app/resources'
      path: '/resources'
      fullPath: '/app/resources'
      preLoaderRoute: typeof AppResourcesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/account/': {
      id: '/app/account/'
      path: '/'
      fullPath: '/app/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/curricula': {
      id: '/app/account/curricula'
      path: '/curricula'
      fullPath: '/app/account/curricula'
      preLoaderRoute: typeof AppAccountCurriculaRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/dashboard': {
      id: '/app/account/dashboard'
      path: '/dashboard'
      fullPath: '/app/account/dashboard'
      preLoaderRoute: typeof AppAccountDashboardRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/deactivate': {
      id: '/app/account/deactivate'
      path: '/deactivate'
      fullPath: '/app/account/deactivate'
      preLoaderRoute: typeof AppAccountDeactivateRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/favorites': {
      id: '/app/account/favorites'
      path: '/favorites'
      fullPath: '/app/account/favorites'
      preLoaderRoute: typeof AppAccountFavoritesRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/forgot': {
      id: '/app/account/forgot'
      path: '/forgot'
      fullPath: '/app/account/forgot'
      preLoaderRoute: typeof AppAccountForgotRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/logged-out': {
      id: '/app/account/logged-out'
      path: '/logged-out'
      fullPath: '/app/account/logged-out'
      preLoaderRoute: typeof AppAccountLoggedOutRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/login': {
      id: '/app/account/login'
      path: '/login'
      fullPath: '/app/account/login'
      preLoaderRoute: typeof AppAccountLoginRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/logout': {
      id: '/app/account/logout'
      path: '/logout'
      fullPath: '/app/account/logout'
      preLoaderRoute: typeof AppAccountLogoutRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/profile': {
      id: '/app/account/profile'
      path: '/profile'
      fullPath: '/app/account/profile'
      preLoaderRoute: typeof AppAccountProfileRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/reactivate': {
      id: '/app/account/reactivate'
      path: '/reactivate'
      fullPath: '/app/account/reactivate'
      preLoaderRoute: typeof AppAccountReactivateRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/welcome-back': {
      id: '/app/account/welcome-back'
      path: '/welcome-back'
      fullPath: '/app/account/welcome-back'
      preLoaderRoute: typeof AppAccountWelcomeBackRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/admin/': {
      id: '/app/admin/'
      path: '/'
      fullPath: '/app/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/activity-log': {
      id: '/app/admin/activity-log'
      path: '/activity-log'
      fullPath: '/app/admin/activity-log'
      preLoaderRoute: typeof AppAdminActivityLogRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/content': {
      id: '/app/admin/content'
      path: '/content'
      fullPath: '/app/admin/content'
      preLoaderRoute: typeof AppAdminContentRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/criteria': {
      id: '/app/admin/criteria'
      path: '/criteria'
      fullPath: '/app/admin/criteria'
      preLoaderRoute: typeof AppAdminCriteriaRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/criterion-topics': {
      id: '/app/admin/criterion-topics'
      path: '/criterion-topics'
      fullPath: '/app/admin/criterion-topics'
      preLoaderRoute: typeof AppAdminCriterionTopicsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/demos': {
      id: '/app/admin/demos'
      path: '/demos'
      fullPath: '/app/admin/demos'
      preLoaderRoute: typeof AppAdminDemosRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/guides': {
      id: '/app/admin/guides'
      path: '/guides'
      fullPath: '/app/admin/guides'
      preLoaderRoute: typeof AppAdminGuidesRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/lms': {
      id: '/app/admin/lms'
      path: '/lms'
      fullPath: '/app/admin/lms'
      preLoaderRoute: typeof AppAdminLmsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/metrics': {
      id: '/app/admin/metrics'
      path: '/metrics'
      fullPath: '/app/admin/metrics'
      preLoaderRoute: typeof AppAdminMetricsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/organizations': {
      id: '/app/admin/organizations'
      path: '/organizations'
      fullPath: '/app/admin/organizations'
      preLoaderRoute: typeof AppAdminOrganizationsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/pending': {
      id: '/app/admin/pending'
      path: '/pending'
      fullPath: '/app/admin/pending'
      preLoaderRoute: typeof AppAdminPendingRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/programs': {
      id: '/app/admin/programs'
      path: '/programs'
      fullPath: '/app/admin/programs'
      preLoaderRoute: typeof AppAdminProgramsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/sets': {
      id: '/app/admin/sets'
      path: '/sets'
      fullPath: '/app/admin/sets'
      preLoaderRoute: typeof AppAdminSetsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/settings': {
      id: '/app/admin/settings'
      path: '/settings'
      fullPath: '/app/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/surveys': {
      id: '/app/admin/surveys'
      path: '/surveys'
      fullPath: '/app/admin/surveys'
      preLoaderRoute: typeof AppAdminSurveysRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/tags': {
      id: '/app/admin/tags'
      path: '/tags'
      fullPath: '/app/admin/tags'
      preLoaderRoute: typeof AppAdminTagsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/terms': {
      id: '/app/admin/terms'
      path: '/terms'
      fullPath: '/app/admin/terms'
      preLoaderRoute: typeof AppAdminTermsRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/admin/users': {
      id: '/app/admin/users'
      path: '/users'
      fullPath: '/app/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/app/deeplink-question/$questionId': {
      id: '/app/deeplink-question/$questionId'
      path: '/deeplink-question/$questionId'
      fullPath: '/app/deeplink-question/$questionId'
      preLoaderRoute: typeof AppDeeplinkQuestionQuestionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/deeplink-set/$setId': {
      id: '/app/deeplink-set/$setId'
      path: '/deeplink-set/$setId'
      fullPath: '/app/deeplink-set/$setId'
      preLoaderRoute: typeof AppDeeplinkSetSetIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/deeplinks/plan': {
      id: '/app/deeplinks/plan'
      path: '/plan'
      fullPath: '/app/deeplinks/plan'
      preLoaderRoute: typeof AppDeeplinksPlanRouteImport
      parentRoute: typeof AppDeeplinksRouteRoute
    }
    '/app/deeplinks/team': {
      id: '/app/deeplinks/team'
      path: '/team'
      fullPath: '/app/deeplinks/team'
      preLoaderRoute: typeof AppDeeplinksTeamRouteImport
      parentRoute: typeof AppDeeplinksRouteRoute
    }
    '/app/demos/': {
      id: '/app/demos/'
      path: '/demos'
      fullPath: '/app/demos/'
      preLoaderRoute: typeof AppDemosIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/materials/$materialId': {
      id: '/app/materials/$materialId'
      path: '/materials/$materialId'
      fullPath: '/app/materials/$materialId'
      preLoaderRoute: typeof AppMaterialsMaterialIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/organizations/': {
      id: '/app/organizations/'
      path: '/'
      fullPath: '/app/organizations/'
      preLoaderRoute: typeof AppOrganizationsIndexRouteImport
      parentRoute: typeof AppOrganizationsRouteRoute
    }
    '/app/organizations/$organizationId': {
      id: '/app/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/app/organizations/$organizationId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdRouteRouteImport
      parentRoute: typeof AppOrganizationsRouteRoute
    }
    '/app/programs/': {
      id: '/app/programs/'
      path: '/programs'
      fullPath: '/app/programs/'
      preLoaderRoute: typeof AppProgramsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/programs/$programId': {
      id: '/app/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/app/programs/$programId'
      preLoaderRoute: typeof AppProgramsProgramIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/resources/': {
      id: '/app/resources/'
      path: '/'
      fullPath: '/app/resources/'
      preLoaderRoute: typeof AppResourcesIndexRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/$resourceId': {
      id: '/app/resources/$resourceId'
      path: '/$resourceId'
      fullPath: '/app/resources/$resourceId'
      preLoaderRoute: typeof AppResourcesResourceIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/survey-previews/$surveyId': {
      id: '/app/survey-previews/$surveyId'
      path: '/survey-previews/$surveyId'
      fullPath: '/app/survey-previews/$surveyId'
      preLoaderRoute: typeof AppSurveyPreviewsSurveyIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/surveys/$surveyOrganizationUuid': {
      id: '/app/surveys/$surveyOrganizationUuid'
      path: '/surveys/$surveyOrganizationUuid'
      fullPath: '/app/surveys/$surveyOrganizationUuid'
      preLoaderRoute: typeof AppSurveysSurveyOrganizationUuidRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/account/activity-log/$': {
      id: '/app/account/activity-log/$'
      path: '/activity-log/$'
      fullPath: '/app/account/activity-log/$'
      preLoaderRoute: typeof AppAccountActivityLogSplatRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/redeem-invite/$inviteToken': {
      id: '/app/account/redeem-invite/$inviteToken'
      path: '/redeem-invite/$inviteToken'
      fullPath: '/app/account/redeem-invite/$inviteToken'
      preLoaderRoute: typeof AppAccountRedeemInviteInviteTokenRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/register/': {
      id: '/app/account/register/'
      path: '/register'
      fullPath: '/app/account/register/'
      preLoaderRoute: typeof AppAccountRegisterIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/register/verification': {
      id: '/app/account/register/verification'
      path: '/register/verification'
      fullPath: '/app/account/register/verification'
      preLoaderRoute: typeof AppAccountRegisterVerificationRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/reset-password/$token': {
      id: '/app/account/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/app/account/reset-password/$token'
      preLoaderRoute: typeof AppAccountResetPasswordTokenRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/twc/': {
      id: '/app/account/twc/'
      path: '/twc'
      fullPath: '/app/account/twc/'
      preLoaderRoute: typeof AppAccountTwcIndexRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/twc/join': {
      id: '/app/account/twc/join'
      path: '/twc/join'
      fullPath: '/app/account/twc/join'
      preLoaderRoute: typeof AppAccountTwcJoinRouteRouteImport
      parentRoute: typeof AppAccountRouteRoute
    }
    '/app/account/welcome-back/$token': {
      id: '/app/account/welcome-back/$token'
      path: '/$token'
      fullPath: '/app/account/welcome-back/$token'
      preLoaderRoute: typeof AppAccountWelcomeBackTokenRouteImport
      parentRoute: typeof AppAccountWelcomeBackRoute
    }
    '/app/admin/content/': {
      id: '/app/admin/content/'
      path: '/'
      fullPath: '/app/admin/content/'
      preLoaderRoute: typeof AppAdminContentIndexRouteImport
      parentRoute: typeof AppAdminContentRouteRoute
    }
    '/app/admin/content/$contentId': {
      id: '/app/admin/content/$contentId'
      path: '/$contentId'
      fullPath: '/app/admin/content/$contentId'
      preLoaderRoute: typeof AppAdminContentContentIdRouteImport
      parentRoute: typeof AppAdminContentRouteRoute
    }
    '/app/admin/content/new': {
      id: '/app/admin/content/new'
      path: '/new'
      fullPath: '/app/admin/content/new'
      preLoaderRoute: typeof AppAdminContentNewRouteImport
      parentRoute: typeof AppAdminContentRouteRoute
    }
    '/app/admin/criteria/': {
      id: '/app/admin/criteria/'
      path: '/'
      fullPath: '/app/admin/criteria/'
      preLoaderRoute: typeof AppAdminCriteriaIndexRouteImport
      parentRoute: typeof AppAdminCriteriaRouteRoute
    }
    '/app/admin/criteria/$criterionId': {
      id: '/app/admin/criteria/$criterionId'
      path: '/$criterionId'
      fullPath: '/app/admin/criteria/$criterionId'
      preLoaderRoute: typeof AppAdminCriteriaCriterionIdRouteImport
      parentRoute: typeof AppAdminCriteriaRouteRoute
    }
    '/app/admin/criteria/new': {
      id: '/app/admin/criteria/new'
      path: '/new'
      fullPath: '/app/admin/criteria/new'
      preLoaderRoute: typeof AppAdminCriteriaNewRouteImport
      parentRoute: typeof AppAdminCriteriaRouteRoute
    }
    '/app/admin/criterion-topics/': {
      id: '/app/admin/criterion-topics/'
      path: '/'
      fullPath: '/app/admin/criterion-topics/'
      preLoaderRoute: typeof AppAdminCriterionTopicsIndexRouteImport
      parentRoute: typeof AppAdminCriterionTopicsRouteRoute
    }
    '/app/admin/criterion-topics/$criterionTopicId': {
      id: '/app/admin/criterion-topics/$criterionTopicId'
      path: '/$criterionTopicId'
      fullPath: '/app/admin/criterion-topics/$criterionTopicId'
      preLoaderRoute: typeof AppAdminCriterionTopicsCriterionTopicIdRouteImport
      parentRoute: typeof AppAdminCriterionTopicsRouteRoute
    }
    '/app/admin/criterion-topics/new': {
      id: '/app/admin/criterion-topics/new'
      path: '/new'
      fullPath: '/app/admin/criterion-topics/new'
      preLoaderRoute: typeof AppAdminCriterionTopicsNewRouteImport
      parentRoute: typeof AppAdminCriterionTopicsRouteRoute
    }
    '/app/admin/demos/': {
      id: '/app/admin/demos/'
      path: '/'
      fullPath: '/app/admin/demos/'
      preLoaderRoute: typeof AppAdminDemosIndexRouteImport
      parentRoute: typeof AppAdminDemosRoute
    }
    '/app/admin/guides/': {
      id: '/app/admin/guides/'
      path: '/'
      fullPath: '/app/admin/guides/'
      preLoaderRoute: typeof AppAdminGuidesIndexRouteImport
      parentRoute: typeof AppAdminGuidesRoute
    }
    '/app/admin/lms/': {
      id: '/app/admin/lms/'
      path: '/'
      fullPath: '/app/admin/lms/'
      preLoaderRoute: typeof AppAdminLmsIndexRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/audio': {
      id: '/app/admin/lms/audio'
      path: '/audio'
      fullPath: '/app/admin/lms/audio'
      preLoaderRoute: typeof AppAdminLmsAudioRouteRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/collections': {
      id: '/app/admin/lms/collections'
      path: '/collections'
      fullPath: '/app/admin/lms/collections'
      preLoaderRoute: typeof AppAdminLmsCollectionsRouteRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/curricula': {
      id: '/app/admin/lms/curricula'
      path: '/curricula'
      fullPath: '/app/admin/lms/curricula'
      preLoaderRoute: typeof AppAdminLmsCurriculaRouteRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/microlearnings': {
      id: '/app/admin/lms/microlearnings'
      path: '/microlearnings'
      fullPath: '/app/admin/lms/microlearnings'
      preLoaderRoute: typeof AppAdminLmsMicrolearningsRouteRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/resources': {
      id: '/app/admin/lms/resources'
      path: '/resources'
      fullPath: '/app/admin/lms/resources'
      preLoaderRoute: typeof AppAdminLmsResourcesRouteRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/trainings-local': {
      id: '/app/admin/lms/trainings-local'
      path: '/trainings-local'
      fullPath: '/app/admin/lms/trainings-local'
      preLoaderRoute: typeof AppAdminLmsTrainingsLocalRouteRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/organizations/': {
      id: '/app/admin/organizations/'
      path: '/'
      fullPath: '/app/admin/organizations/'
      preLoaderRoute: typeof AppAdminOrganizationsIndexRouteImport
      parentRoute: typeof AppAdminOrganizationsRouteRoute
    }
    '/app/admin/organizations/$organizationId': {
      id: '/app/admin/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/app/admin/organizations/$organizationId'
      preLoaderRoute: typeof AppAdminOrganizationsOrganizationIdRouteRouteImport
      parentRoute: typeof AppAdminOrganizationsRouteRoute
    }
    '/app/admin/pending/invites': {
      id: '/app/admin/pending/invites'
      path: '/invites'
      fullPath: '/app/admin/pending/invites'
      preLoaderRoute: typeof AppAdminPendingInvitesRouteImport
      parentRoute: typeof AppAdminPendingRouteRoute
    }
    '/app/admin/pending/requests': {
      id: '/app/admin/pending/requests'
      path: '/requests'
      fullPath: '/app/admin/pending/requests'
      preLoaderRoute: typeof AppAdminPendingRequestsRouteImport
      parentRoute: typeof AppAdminPendingRouteRoute
    }
    '/app/admin/programs/': {
      id: '/app/admin/programs/'
      path: '/'
      fullPath: '/app/admin/programs/'
      preLoaderRoute: typeof AppAdminProgramsIndexRouteImport
      parentRoute: typeof AppAdminProgramsRouteRoute
    }
    '/app/admin/programs/$programId': {
      id: '/app/admin/programs/$programId'
      path: '/$programId'
      fullPath: '/app/admin/programs/$programId'
      preLoaderRoute: typeof AppAdminProgramsProgramIdRouteRouteImport
      parentRoute: typeof AppAdminProgramsRouteRoute
    }
    '/app/admin/sets/': {
      id: '/app/admin/sets/'
      path: '/'
      fullPath: '/app/admin/sets/'
      preLoaderRoute: typeof AppAdminSetsIndexRouteImport
      parentRoute: typeof AppAdminSetsRouteRoute
    }
    '/app/admin/sets/$setId': {
      id: '/app/admin/sets/$setId'
      path: '/$setId'
      fullPath: '/app/admin/sets/$setId'
      preLoaderRoute: typeof AppAdminSetsSetIdRouteRouteImport
      parentRoute: typeof AppAdminSetsRouteRoute
    }
    '/app/admin/sets/new': {
      id: '/app/admin/sets/new'
      path: '/new'
      fullPath: '/app/admin/sets/new'
      preLoaderRoute: typeof AppAdminSetsNewRouteImport
      parentRoute: typeof AppAdminSetsRouteRoute
    }
    '/app/admin/settings/': {
      id: '/app/admin/settings/'
      path: '/'
      fullPath: '/app/admin/settings/'
      preLoaderRoute: typeof AppAdminSettingsIndexRouteImport
      parentRoute: typeof AppAdminSettingsRouteRoute
    }
    '/app/admin/settings/$settingId': {
      id: '/app/admin/settings/$settingId'
      path: '/$settingId'
      fullPath: '/app/admin/settings/$settingId'
      preLoaderRoute: typeof AppAdminSettingsSettingIdRouteImport
      parentRoute: typeof AppAdminSettingsRouteRoute
    }
    '/app/admin/settings/new': {
      id: '/app/admin/settings/new'
      path: '/new'
      fullPath: '/app/admin/settings/new'
      preLoaderRoute: typeof AppAdminSettingsNewRouteImport
      parentRoute: typeof AppAdminSettingsRouteRoute
    }
    '/app/admin/surveys/': {
      id: '/app/admin/surveys/'
      path: '/'
      fullPath: '/app/admin/surveys/'
      preLoaderRoute: typeof AppAdminSurveysIndexRouteImport
      parentRoute: typeof AppAdminSurveysRouteRoute
    }
    '/app/admin/surveys/new': {
      id: '/app/admin/surveys/new'
      path: '/new'
      fullPath: '/app/admin/surveys/new'
      preLoaderRoute: typeof AppAdminSurveysNewRouteImport
      parentRoute: typeof AppAdminSurveysRouteRoute
    }
    '/app/admin/tags/': {
      id: '/app/admin/tags/'
      path: '/'
      fullPath: '/app/admin/tags/'
      preLoaderRoute: typeof AppAdminTagsIndexRouteImport
      parentRoute: typeof AppAdminTagsRouteRoute
    }
    '/app/admin/tags/$tagId': {
      id: '/app/admin/tags/$tagId'
      path: '/$tagId'
      fullPath: '/app/admin/tags/$tagId'
      preLoaderRoute: typeof AppAdminTagsTagIdRouteImport
      parentRoute: typeof AppAdminTagsRouteRoute
    }
    '/app/admin/tags/new': {
      id: '/app/admin/tags/new'
      path: '/new'
      fullPath: '/app/admin/tags/new'
      preLoaderRoute: typeof AppAdminTagsNewRouteImport
      parentRoute: typeof AppAdminTagsRouteRoute
    }
    '/app/admin/terms/': {
      id: '/app/admin/terms/'
      path: '/'
      fullPath: '/app/admin/terms/'
      preLoaderRoute: typeof AppAdminTermsIndexRouteImport
      parentRoute: typeof AppAdminTermsRouteRoute
    }
    '/app/admin/terms/$termId': {
      id: '/app/admin/terms/$termId'
      path: '/$termId'
      fullPath: '/app/admin/terms/$termId'
      preLoaderRoute: typeof AppAdminTermsTermIdRouteImport
      parentRoute: typeof AppAdminTermsRouteRoute
    }
    '/app/admin/terms/new': {
      id: '/app/admin/terms/new'
      path: '/new'
      fullPath: '/app/admin/terms/new'
      preLoaderRoute: typeof AppAdminTermsNewRouteImport
      parentRoute: typeof AppAdminTermsRouteRoute
    }
    '/app/admin/users/': {
      id: '/app/admin/users/'
      path: '/'
      fullPath: '/app/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminUsersRouteRoute
    }
    '/app/admin/users/$userId': {
      id: '/app/admin/users/$userId'
      path: '/$userId'
      fullPath: '/app/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteRouteImport
      parentRoute: typeof AppAdminUsersRouteRoute
    }
    '/app/admin/users/new': {
      id: '/app/admin/users/new'
      path: '/new'
      fullPath: '/app/admin/users/new'
      preLoaderRoute: typeof AppAdminUsersNewRouteImport
      parentRoute: typeof AppAdminUsersRouteRoute
    }
    '/app/demos/sets/': {
      id: '/app/demos/sets/'
      path: '/demos/sets'
      fullPath: '/app/demos/sets/'
      preLoaderRoute: typeof AppDemosSetsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/organizations/$organizationId/': {
      id: '/app/organizations/$organizationId/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/ahs': {
      id: '/app/organizations/$organizationId/ahs'
      path: '/ahs'
      fullPath: '/app/organizations/$organizationId/ahs'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdAhsRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/builder': {
      id: '/app/organizations/$organizationId/builder'
      path: '/builder'
      fullPath: '/app/organizations/$organizationId/builder'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/pending': {
      id: '/app/organizations/$organizationId/pending'
      path: '/pending'
      fullPath: '/app/organizations/$organizationId/pending'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdPendingRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/plan': {
      id: '/app/organizations/$organizationId/plan'
      path: '/plan'
      fullPath: '/app/organizations/$organizationId/plan'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdPlanRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/quick-start': {
      id: '/app/organizations/$organizationId/quick-start'
      path: '/quick-start'
      fullPath: '/app/organizations/$organizationId/quick-start'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdQuickStartRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/reports': {
      id: '/app/organizations/$organizationId/reports'
      path: '/reports'
      fullPath: '/app/organizations/$organizationId/reports'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/sets': {
      id: '/app/organizations/$organizationId/sets'
      path: '/sets'
      fullPath: '/app/organizations/$organizationId/sets'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/surveys': {
      id: '/app/organizations/$organizationId/surveys'
      path: '/surveys'
      fullPath: '/app/organizations/$organizationId/surveys'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSurveysRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/team': {
      id: '/app/organizations/$organizationId/team'
      path: '/team'
      fullPath: '/app/organizations/$organizationId/team'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdTeamRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/join/': {
      id: '/app/organizations/join/'
      path: '/join'
      fullPath: '/app/organizations/join/'
      preLoaderRoute: typeof AppOrganizationsJoinIndexRouteImport
      parentRoute: typeof AppOrganizationsRouteRoute
    }
    '/app/organizations/join/$orgtypeMachineName': {
      id: '/app/organizations/join/$orgtypeMachineName'
      path: '/join/$orgtypeMachineName'
      fullPath: '/app/organizations/join/$orgtypeMachineName'
      preLoaderRoute: typeof AppOrganizationsJoinOrgtypeMachineNameRouteRouteImport
      parentRoute: typeof AppOrganizationsRouteRoute
    }
    '/app/programs/$programId/register': {
      id: '/app/programs/$programId/register'
      path: '/register'
      fullPath: '/app/programs/$programId/register'
      preLoaderRoute: typeof AppProgramsProgramIdRegisterRouteImport
      parentRoute: typeof AppProgramsProgramIdRoute
    }
    '/app/resources/audio/$id': {
      id: '/app/resources/audio/$id'
      path: '/audio/$id'
      fullPath: '/app/resources/audio/$id'
      preLoaderRoute: typeof AppResourcesAudioIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/collections/$id': {
      id: '/app/resources/collections/$id'
      path: '/collections/$id'
      fullPath: '/app/resources/collections/$id'
      preLoaderRoute: typeof AppResourcesCollectionsIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/curricula/$id': {
      id: '/app/resources/curricula/$id'
      path: '/curricula/$id'
      fullPath: '/app/resources/curricula/$id'
      preLoaderRoute: typeof AppResourcesCurriculaIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/microlearnings/$id': {
      id: '/app/resources/microlearnings/$id'
      path: '/microlearnings/$id'
      fullPath: '/app/resources/microlearnings/$id'
      preLoaderRoute: typeof AppResourcesMicrolearningsIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/trainings-local/$id': {
      id: '/app/resources/trainings-local/$id'
      path: '/trainings-local/$id'
      fullPath: '/app/resources/trainings-local/$id'
      preLoaderRoute: typeof AppResourcesTrainingsLocalIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/trainings-on-demand/$id': {
      id: '/app/resources/trainings-on-demand/$id'
      path: '/trainings-on-demand/$id'
      fullPath: '/app/resources/trainings-on-demand/$id'
      preLoaderRoute: typeof AppResourcesTrainingsOnDemandIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/resources/trainings-virtual/$id': {
      id: '/app/resources/trainings-virtual/$id'
      path: '/trainings-virtual/$id'
      fullPath: '/app/resources/trainings-virtual/$id'
      preLoaderRoute: typeof AppResourcesTrainingsVirtualIdRouteImport
      parentRoute: typeof AppResourcesRouteRoute
    }
    '/app/survey-previews/$surveyId/': {
      id: '/app/survey-previews/$surveyId/'
      path: '/'
      fullPath: '/app/survey-previews/$surveyId/'
      preLoaderRoute: typeof AppSurveyPreviewsSurveyIdIndexRouteImport
      parentRoute: typeof AppSurveyPreviewsSurveyIdRouteRoute
    }
    '/app/surveys/$surveyOrganizationUuid/': {
      id: '/app/surveys/$surveyOrganizationUuid/'
      path: '/'
      fullPath: '/app/surveys/$surveyOrganizationUuid/'
      preLoaderRoute: typeof AppSurveysSurveyOrganizationUuidIndexRouteImport
      parentRoute: typeof AppSurveysSurveyOrganizationUuidRouteRoute
    }
    '/app/account/register/verification/': {
      id: '/app/account/register/verification/'
      path: '/'
      fullPath: '/app/account/register/verification/'
      preLoaderRoute: typeof AppAccountRegisterVerificationIndexRouteImport
      parentRoute: typeof AppAccountRegisterVerificationRoute
    }
    '/app/account/twc/join/': {
      id: '/app/account/twc/join/'
      path: '/'
      fullPath: '/app/account/twc/join/'
      preLoaderRoute: typeof AppAccountTwcJoinIndexRouteImport
      parentRoute: typeof AppAccountTwcJoinRouteRoute
    }
    '/app/account/twc/join/$orgType': {
      id: '/app/account/twc/join/$orgType'
      path: '/$orgType'
      fullPath: '/app/account/twc/join/$orgType'
      preLoaderRoute: typeof AppAccountTwcJoinOrgTypeRouteImport
      parentRoute: typeof AppAccountTwcJoinRouteRoute
    }
    '/app/admin/demos/sets/': {
      id: '/app/admin/demos/sets/'
      path: '/sets'
      fullPath: '/app/admin/demos/sets/'
      preLoaderRoute: typeof AppAdminDemosSetsIndexRouteImport
      parentRoute: typeof AppAdminDemosRoute
    }
    '/app/admin/demos/sets/default': {
      id: '/app/admin/demos/sets/default'
      path: '/sets/default'
      fullPath: '/app/admin/demos/sets/default'
      preLoaderRoute: typeof AppAdminDemosSetsDefaultRouteImport
      parentRoute: typeof AppAdminDemosRoute
    }
    '/app/admin/lms/audio/$audioId': {
      id: '/app/admin/lms/audio/$audioId'
      path: '/$audioId'
      fullPath: '/app/admin/lms/audio/$audioId'
      preLoaderRoute: typeof AppAdminLmsAudioAudioIdRouteImport
      parentRoute: typeof AppAdminLmsAudioRouteRoute
    }
    '/app/admin/lms/audio/new': {
      id: '/app/admin/lms/audio/new'
      path: '/new'
      fullPath: '/app/admin/lms/audio/new'
      preLoaderRoute: typeof AppAdminLmsAudioNewRouteImport
      parentRoute: typeof AppAdminLmsAudioRouteRoute
    }
    '/app/admin/lms/collections/$collectionId': {
      id: '/app/admin/lms/collections/$collectionId'
      path: '/$collectionId'
      fullPath: '/app/admin/lms/collections/$collectionId'
      preLoaderRoute: typeof AppAdminLmsCollectionsCollectionIdRouteImport
      parentRoute: typeof AppAdminLmsCollectionsRouteRoute
    }
    '/app/admin/lms/collections/new': {
      id: '/app/admin/lms/collections/new'
      path: '/new'
      fullPath: '/app/admin/lms/collections/new'
      preLoaderRoute: typeof AppAdminLmsCollectionsNewRouteImport
      parentRoute: typeof AppAdminLmsCollectionsRouteRoute
    }
    '/app/admin/lms/curricula/$curriculumId': {
      id: '/app/admin/lms/curricula/$curriculumId'
      path: '/$curriculumId'
      fullPath: '/app/admin/lms/curricula/$curriculumId'
      preLoaderRoute: typeof AppAdminLmsCurriculaCurriculumIdRouteImport
      parentRoute: typeof AppAdminLmsCurriculaRouteRoute
    }
    '/app/admin/lms/curricula/new': {
      id: '/app/admin/lms/curricula/new'
      path: '/new'
      fullPath: '/app/admin/lms/curricula/new'
      preLoaderRoute: typeof AppAdminLmsCurriculaNewRouteImport
      parentRoute: typeof AppAdminLmsCurriculaRouteRoute
    }
    '/app/admin/lms/materials/$materialId': {
      id: '/app/admin/lms/materials/$materialId'
      path: '/materials/$materialId'
      fullPath: '/app/admin/lms/materials/$materialId'
      preLoaderRoute: typeof AppAdminLmsMaterialsMaterialIdRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/microlearnings/$microlearningId': {
      id: '/app/admin/lms/microlearnings/$microlearningId'
      path: '/$microlearningId'
      fullPath: '/app/admin/lms/microlearnings/$microlearningId'
      preLoaderRoute: typeof AppAdminLmsMicrolearningsMicrolearningIdRouteImport
      parentRoute: typeof AppAdminLmsMicrolearningsRouteRoute
    }
    '/app/admin/lms/microlearnings/new': {
      id: '/app/admin/lms/microlearnings/new'
      path: '/new'
      fullPath: '/app/admin/lms/microlearnings/new'
      preLoaderRoute: typeof AppAdminLmsMicrolearningsNewRouteImport
      parentRoute: typeof AppAdminLmsMicrolearningsRouteRoute
    }
    '/app/admin/lms/resources/$resourceId': {
      id: '/app/admin/lms/resources/$resourceId'
      path: '/$resourceId'
      fullPath: '/app/admin/lms/resources/$resourceId'
      preLoaderRoute: typeof AppAdminLmsResourcesResourceIdRouteImport
      parentRoute: typeof AppAdminLmsResourcesRouteRoute
    }
    '/app/admin/lms/resources/new': {
      id: '/app/admin/lms/resources/new'
      path: '/new'
      fullPath: '/app/admin/lms/resources/new'
      preLoaderRoute: typeof AppAdminLmsResourcesNewRouteImport
      parentRoute: typeof AppAdminLmsResourcesRouteRoute
    }
    '/app/admin/lms/trainings-local/$trainingId': {
      id: '/app/admin/lms/trainings-local/$trainingId'
      path: '/$trainingId'
      fullPath: '/app/admin/lms/trainings-local/$trainingId'
      preLoaderRoute: typeof AppAdminLmsTrainingsLocalTrainingIdRouteImport
      parentRoute: typeof AppAdminLmsTrainingsLocalRouteRoute
    }
    '/app/admin/lms/trainings-local/new': {
      id: '/app/admin/lms/trainings-local/new'
      path: '/new'
      fullPath: '/app/admin/lms/trainings-local/new'
      preLoaderRoute: typeof AppAdminLmsTrainingsLocalNewRouteImport
      parentRoute: typeof AppAdminLmsTrainingsLocalRouteRoute
    }
    '/app/admin/lms/trainings-on-demand/$trainingId': {
      id: '/app/admin/lms/trainings-on-demand/$trainingId'
      path: '/trainings-on-demand/$trainingId'
      fullPath: '/app/admin/lms/trainings-on-demand/$trainingId'
      preLoaderRoute: typeof AppAdminLmsTrainingsOnDemandTrainingIdRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/lms/trainings-virtual/$trainingId': {
      id: '/app/admin/lms/trainings-virtual/$trainingId'
      path: '/trainings-virtual/$trainingId'
      fullPath: '/app/admin/lms/trainings-virtual/$trainingId'
      preLoaderRoute: typeof AppAdminLmsTrainingsVirtualTrainingIdRouteImport
      parentRoute: typeof AppAdminLmsRouteRoute
    }
    '/app/admin/organizations/$organizationId/': {
      id: '/app/admin/organizations/$organizationId/'
      path: '/'
      fullPath: '/app/admin/organizations/$organizationId/'
      preLoaderRoute: typeof AppAdminOrganizationsOrganizationIdIndexRouteImport
      parentRoute: typeof AppAdminOrganizationsOrganizationIdRouteRoute
    }
    '/app/admin/organizations/$organizationId/team': {
      id: '/app/admin/organizations/$organizationId/team'
      path: '/team'
      fullPath: '/app/admin/organizations/$organizationId/team'
      preLoaderRoute: typeof AppAdminOrganizationsOrganizationIdTeamRouteImport
      parentRoute: typeof AppAdminOrganizationsOrganizationIdRouteRoute
    }
    '/app/admin/programs/$programId/': {
      id: '/app/admin/programs/$programId/'
      path: '/'
      fullPath: '/app/admin/programs/$programId/'
      preLoaderRoute: typeof AppAdminProgramsProgramIdIndexRouteImport
      parentRoute: typeof AppAdminProgramsProgramIdRouteRoute
    }
    '/app/admin/programs/$programId/organizations': {
      id: '/app/admin/programs/$programId/organizations'
      path: '/organizations'
      fullPath: '/app/admin/programs/$programId/organizations'
      preLoaderRoute: typeof AppAdminProgramsProgramIdOrganizationsRouteImport
      parentRoute: typeof AppAdminProgramsProgramIdRouteRoute
    }
    '/app/admin/programs/$programId/sets': {
      id: '/app/admin/programs/$programId/sets'
      path: '/sets'
      fullPath: '/app/admin/programs/$programId/sets'
      preLoaderRoute: typeof AppAdminProgramsProgramIdSetsRouteImport
      parentRoute: typeof AppAdminProgramsProgramIdRouteRoute
    }
    '/app/admin/sets/$setId/': {
      id: '/app/admin/sets/$setId/'
      path: '/'
      fullPath: '/app/admin/sets/$setId/'
      preLoaderRoute: typeof AppAdminSetsSetIdIndexRouteImport
      parentRoute: typeof AppAdminSetsSetIdRouteRoute
    }
    '/app/admin/sets/$setId/clone': {
      id: '/app/admin/sets/$setId/clone'
      path: '/clone'
      fullPath: '/app/admin/sets/$setId/clone'
      preLoaderRoute: typeof AppAdminSetsSetIdCloneRouteImport
      parentRoute: typeof AppAdminSetsSetIdRouteRoute
    }
    '/app/admin/sets/$setId/demo': {
      id: '/app/admin/sets/$setId/demo'
      path: '/demo'
      fullPath: '/app/admin/sets/$setId/demo'
      preLoaderRoute: typeof AppAdminSetsSetIdDemoRouteImport
      parentRoute: typeof AppAdminSetsSetIdRouteRoute
    }
    '/app/admin/sets/$setId/modules': {
      id: '/app/admin/sets/$setId/modules'
      path: '/modules'
      fullPath: '/app/admin/sets/$setId/modules'
      preLoaderRoute: typeof AppAdminSetsSetIdModulesRouteRouteImport
      parentRoute: typeof AppAdminSetsSetIdRouteRoute
    }
    '/app/admin/sets/$setId/questions': {
      id: '/app/admin/sets/$setId/questions'
      path: '/questions'
      fullPath: '/app/admin/sets/$setId/questions'
      preLoaderRoute: typeof AppAdminSetsSetIdQuestionsRouteRouteImport
      parentRoute: typeof AppAdminSetsSetIdRouteRoute
    }
    '/app/admin/surveys/$surveyId/': {
      id: '/app/admin/surveys/$surveyId/'
      path: '/$surveyId'
      fullPath: '/app/admin/surveys/$surveyId/'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdIndexRouteImport
      parentRoute: typeof AppAdminSurveysRouteRoute
    }
    '/app/admin/surveys/$surveyId/questions': {
      id: '/app/admin/surveys/$surveyId/questions'
      path: '/$surveyId/questions'
      fullPath: '/app/admin/surveys/$surveyId/questions'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdQuestionsRouteRouteImport
      parentRoute: typeof AppAdminSurveysRouteRoute
    }
    '/app/admin/surveys/$surveyId/topics': {
      id: '/app/admin/surveys/$surveyId/topics'
      path: '/$surveyId/topics'
      fullPath: '/app/admin/surveys/$surveyId/topics'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdTopicsRouteRouteImport
      parentRoute: typeof AppAdminSurveysRouteRoute
    }
    '/app/admin/users/$userId/': {
      id: '/app/admin/users/$userId/'
      path: '/'
      fullPath: '/app/admin/users/$userId/'
      preLoaderRoute: typeof AppAdminUsersUserIdIndexRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/app/admin/users/$userId/organizations': {
      id: '/app/admin/users/$userId/organizations'
      path: '/organizations'
      fullPath: '/app/admin/users/$userId/organizations'
      preLoaderRoute: typeof AppAdminUsersUserIdOrganizationsRouteRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/app/admin/users/$userId/pending': {
      id: '/app/admin/users/$userId/pending'
      path: '/pending'
      fullPath: '/app/admin/users/$userId/pending'
      preLoaderRoute: typeof AppAdminUsersUserIdPendingRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/app/deeplinks/programs/$programId/': {
      id: '/app/deeplinks/programs/$programId/'
      path: '/programs/$programId'
      fullPath: '/app/deeplinks/programs/$programId/'
      preLoaderRoute: typeof AppDeeplinksProgramsProgramIdIndexRouteImport
      parentRoute: typeof AppDeeplinksRouteRoute
    }
    '/app/demos/sets/$setId/': {
      id: '/app/demos/sets/$setId/'
      path: '/demos/sets/$setId'
      fullPath: '/app/demos/sets/$setId/'
      preLoaderRoute: typeof AppDemosSetsSetIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/organizations/$organizationId/builder/': {
      id: '/app/organizations/$organizationId/builder/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/builder/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdBuilderRouteRoute
    }
    '/app/organizations/$organizationId/builder/$docbuilderSlug': {
      id: '/app/organizations/$organizationId/builder/$docbuilderSlug'
      path: '/$docbuilderSlug'
      fullPath: '/app/organizations/$organizationId/builder/$docbuilderSlug'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdBuilderRouteRoute
    }
    '/app/organizations/$organizationId/overview/': {
      id: '/app/organizations/$organizationId/overview/'
      path: '/overview'
      fullPath: '/app/organizations/$organizationId/overview/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdOverviewIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/overview/$tab': {
      id: '/app/organizations/$organizationId/overview/$tab'
      path: '/overview/$tab'
      fullPath: '/app/organizations/$organizationId/overview/$tab'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdOverviewTabRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdRouteRoute
    }
    '/app/organizations/$organizationId/plan/': {
      id: '/app/organizations/$organizationId/plan/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/plan/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdPlanIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdPlanRouteRoute
    }
    '/app/organizations/$organizationId/quick-start/': {
      id: '/app/organizations/$organizationId/quick-start/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/quick-start/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdQuickStartIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdQuickStartRouteRoute
    }
    '/app/organizations/$organizationId/reports/': {
      id: '/app/organizations/$organizationId/reports/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/reports/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsRouteRoute
    }
    '/app/organizations/$organizationId/sets/': {
      id: '/app/organizations/$organizationId/sets/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/sets/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsRouteRoute
    }
    '/app/organizations/$organizationId/sets/$setId': {
      id: '/app/organizations/$organizationId/sets/$setId'
      path: '/$setId'
      fullPath: '/app/organizations/$organizationId/sets/$setId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsRouteRoute
    }
    '/app/organizations/$organizationId/surveys/$surveyId': {
      id: '/app/organizations/$organizationId/surveys/$surveyId'
      path: '/$surveyId'
      fullPath: '/app/organizations/$organizationId/surveys/$surveyId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSurveysSurveyIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSurveysRouteRoute
    }
    '/app/organizations/$organizationId/team/invite': {
      id: '/app/organizations/$organizationId/team/invite'
      path: '/invite'
      fullPath: '/app/organizations/$organizationId/team/invite'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdTeamInviteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdTeamRouteRoute
    }
    '/app/organizations/join/$orgtypeMachineName/$organizationId': {
      id: '/app/organizations/join/$orgtypeMachineName/$organizationId'
      path: '/$organizationId'
      fullPath: '/app/organizations/join/$orgtypeMachineName/$organizationId'
      preLoaderRoute: typeof AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRouteImport
      parentRoute: typeof AppOrganizationsJoinOrgtypeMachineNameRouteRoute
    }
    '/app/organizations/join/$orgtypeMachineName/find': {
      id: '/app/organizations/join/$orgtypeMachineName/find'
      path: '/find'
      fullPath: '/app/organizations/join/$orgtypeMachineName/find'
      preLoaderRoute: typeof AppOrganizationsJoinOrgtypeMachineNameFindRouteImport
      parentRoute: typeof AppOrganizationsJoinOrgtypeMachineNameRouteRoute
    }
    '/app/programs/$programId/organizations/': {
      id: '/app/programs/$programId/organizations/'
      path: '/organizations'
      fullPath: '/app/programs/$programId/organizations/'
      preLoaderRoute: typeof AppProgramsProgramIdOrganizationsIndexRouteImport
      parentRoute: typeof AppProgramsProgramIdRoute
    }
    '/app/survey-previews/$surveyId/$languageId/': {
      id: '/app/survey-previews/$surveyId/$languageId/'
      path: '/$languageId'
      fullPath: '/app/survey-previews/$surveyId/$languageId/'
      preLoaderRoute: typeof AppSurveyPreviewsSurveyIdLanguageIdIndexRouteImport
      parentRoute: typeof AppSurveyPreviewsSurveyIdRouteRoute
    }
    '/app/survey-previews/$surveyId/$languageId/confirmation': {
      id: '/app/survey-previews/$surveyId/$languageId/confirmation'
      path: '/$languageId/confirmation'
      fullPath: '/app/survey-previews/$surveyId/$languageId/confirmation'
      preLoaderRoute: typeof AppSurveyPreviewsSurveyIdLanguageIdConfirmationRouteImport
      parentRoute: typeof AppSurveyPreviewsSurveyIdRouteRoute
    }
    '/app/surveys/$surveyOrganizationUuid/$languageId/': {
      id: '/app/surveys/$surveyOrganizationUuid/$languageId/'
      path: '/$languageId'
      fullPath: '/app/surveys/$surveyOrganizationUuid/$languageId/'
      preLoaderRoute: typeof AppSurveysSurveyOrganizationUuidLanguageIdIndexRouteImport
      parentRoute: typeof AppSurveysSurveyOrganizationUuidRouteRoute
    }
    '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation': {
      id: '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation'
      path: '/$languageId/confirmation'
      fullPath: '/app/surveys/$surveyOrganizationUuid/$languageId/confirmation'
      preLoaderRoute: typeof AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRouteImport
      parentRoute: typeof AppSurveysSurveyOrganizationUuidRouteRoute
    }
    '/app/account/register/verification/url/$encodedUrl': {
      id: '/app/account/register/verification/url/$encodedUrl'
      path: '/url/$encodedUrl'
      fullPath: '/app/account/register/verification/url/$encodedUrl'
      preLoaderRoute: typeof AppAccountRegisterVerificationUrlEncodedUrlRouteImport
      parentRoute: typeof AppAccountRegisterVerificationRoute
    }
    '/app/account/twc/join/$orgType/$orgId': {
      id: '/app/account/twc/join/$orgType/$orgId'
      path: '/$orgId'
      fullPath: '/app/account/twc/join/$orgType/$orgId'
      preLoaderRoute: typeof AppAccountTwcJoinOrgTypeOrgIdRouteImport
      parentRoute: typeof AppAccountTwcJoinOrgTypeRoute
    }
    '/app/admin/sets/$setId/modules/': {
      id: '/app/admin/sets/$setId/modules/'
      path: '/'
      fullPath: '/app/admin/sets/$setId/modules/'
      preLoaderRoute: typeof AppAdminSetsSetIdModulesIndexRouteImport
      parentRoute: typeof AppAdminSetsSetIdModulesRouteRoute
    }
    '/app/admin/sets/$setId/modules/$moduleId': {
      id: '/app/admin/sets/$setId/modules/$moduleId'
      path: '/$moduleId'
      fullPath: '/app/admin/sets/$setId/modules/$moduleId'
      preLoaderRoute: typeof AppAdminSetsSetIdModulesModuleIdRouteImport
      parentRoute: typeof AppAdminSetsSetIdModulesRouteRoute
    }
    '/app/admin/sets/$setId/modules/new': {
      id: '/app/admin/sets/$setId/modules/new'
      path: '/new'
      fullPath: '/app/admin/sets/$setId/modules/new'
      preLoaderRoute: typeof AppAdminSetsSetIdModulesNewRouteImport
      parentRoute: typeof AppAdminSetsSetIdModulesRouteRoute
    }
    '/app/admin/sets/$setId/questions/': {
      id: '/app/admin/sets/$setId/questions/'
      path: '/'
      fullPath: '/app/admin/sets/$setId/questions/'
      preLoaderRoute: typeof AppAdminSetsSetIdQuestionsIndexRouteImport
      parentRoute: typeof AppAdminSetsSetIdQuestionsRouteRoute
    }
    '/app/admin/sets/$setId/questions/$questionId': {
      id: '/app/admin/sets/$setId/questions/$questionId'
      path: '/$questionId'
      fullPath: '/app/admin/sets/$setId/questions/$questionId'
      preLoaderRoute: typeof AppAdminSetsSetIdQuestionsQuestionIdRouteImport
      parentRoute: typeof AppAdminSetsSetIdQuestionsRouteRoute
    }
    '/app/admin/sets/$setId/questions/new': {
      id: '/app/admin/sets/$setId/questions/new'
      path: '/new'
      fullPath: '/app/admin/sets/$setId/questions/new'
      preLoaderRoute: typeof AppAdminSetsSetIdQuestionsNewRouteImport
      parentRoute: typeof AppAdminSetsSetIdQuestionsRouteRoute
    }
    '/app/admin/surveys/$surveyId/questions/': {
      id: '/app/admin/surveys/$surveyId/questions/'
      path: '/'
      fullPath: '/app/admin/surveys/$surveyId/questions/'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdQuestionsIndexRouteImport
      parentRoute: typeof AppAdminSurveysSurveyIdQuestionsRouteRoute
    }
    '/app/admin/surveys/$surveyId/questions/$questionId': {
      id: '/app/admin/surveys/$surveyId/questions/$questionId'
      path: '/$questionId'
      fullPath: '/app/admin/surveys/$surveyId/questions/$questionId'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdQuestionsQuestionIdRouteImport
      parentRoute: typeof AppAdminSurveysSurveyIdQuestionsRouteRoute
    }
    '/app/admin/surveys/$surveyId/questions/new': {
      id: '/app/admin/surveys/$surveyId/questions/new'
      path: '/new'
      fullPath: '/app/admin/surveys/$surveyId/questions/new'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdQuestionsNewRouteImport
      parentRoute: typeof AppAdminSurveysSurveyIdQuestionsRouteRoute
    }
    '/app/admin/surveys/$surveyId/topics/': {
      id: '/app/admin/surveys/$surveyId/topics/'
      path: '/'
      fullPath: '/app/admin/surveys/$surveyId/topics/'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdTopicsIndexRouteImport
      parentRoute: typeof AppAdminSurveysSurveyIdTopicsRouteRoute
    }
    '/app/admin/surveys/$surveyId/topics/$topicId': {
      id: '/app/admin/surveys/$surveyId/topics/$topicId'
      path: '/$topicId'
      fullPath: '/app/admin/surveys/$surveyId/topics/$topicId'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdTopicsTopicIdRouteImport
      parentRoute: typeof AppAdminSurveysSurveyIdTopicsRouteRoute
    }
    '/app/admin/surveys/$surveyId/topics/new': {
      id: '/app/admin/surveys/$surveyId/topics/new'
      path: '/new'
      fullPath: '/app/admin/surveys/$surveyId/topics/new'
      preLoaderRoute: typeof AppAdminSurveysSurveyIdTopicsNewRouteImport
      parentRoute: typeof AppAdminSurveysSurveyIdTopicsRouteRoute
    }
    '/app/admin/users/$userId/organizations/': {
      id: '/app/admin/users/$userId/organizations/'
      path: '/'
      fullPath: '/app/admin/users/$userId/organizations/'
      preLoaderRoute: typeof AppAdminUsersUserIdOrganizationsIndexRouteImport
      parentRoute: typeof AppAdminUsersUserIdOrganizationsRouteRoute
    }
    '/app/admin/users/$userId/organizations/$organizationId': {
      id: '/app/admin/users/$userId/organizations/$organizationId'
      path: '/$organizationId'
      fullPath: '/app/admin/users/$userId/organizations/$organizationId'
      preLoaderRoute: typeof AppAdminUsersUserIdOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AppAdminUsersUserIdOrganizationsRouteRoute
    }
    '/app/demos/sets/$setId/view/': {
      id: '/app/demos/sets/$setId/view/'
      path: '/demos/sets/$setId/view'
      fullPath: '/app/demos/sets/$setId/view/'
      preLoaderRoute: typeof AppDemosSetsSetIdViewIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/organizations/$organizationId/builder/$docbuilderSlug/': {
      id: '/app/organizations/$organizationId/builder/$docbuilderSlug/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/builder/$docbuilderSlug/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute
    }
    '/app/organizations/$organizationId/builder/$docbuilderSlug/$format': {
      id: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format'
      path: '/$format'
      fullPath: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute
    }
    '/app/organizations/$organizationId/plan/items/$itemId': {
      id: '/app/organizations/$organizationId/plan/items/$itemId'
      path: '/items/$itemId'
      fullPath: '/app/organizations/$organizationId/plan/items/$itemId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdPlanItemsItemIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdPlanRouteRoute
    }
    '/app/organizations/$organizationId/plan/items/new': {
      id: '/app/organizations/$organizationId/plan/items/new'
      path: '/items/new'
      fullPath: '/app/organizations/$organizationId/plan/items/new'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdPlanItemsNewRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdPlanRouteRoute
    }
    '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId': {
      id: '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId'
      path: '/subtopics/$subtopicId'
      fullPath: '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdQuickStartRouteRoute
    }
    '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName': {
      id: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName'
      path: '/children/$childOrgTypeMachineName'
      fullPath: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsRouteRoute
    }
    '/app/organizations/$organizationId/reports/modules/$moduleId': {
      id: '/app/organizations/$organizationId/reports/modules/$moduleId'
      path: '/modules/$moduleId'
      fullPath: '/app/organizations/$organizationId/reports/modules/$moduleId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsModulesModuleIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsRouteRoute
    }
    '/app/organizations/$organizationId/reports/sets/$setId': {
      id: '/app/organizations/$organizationId/reports/sets/$setId'
      path: '/sets/$setId'
      fullPath: '/app/organizations/$organizationId/reports/sets/$setId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsSetsSetIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsRouteRoute
    }
    '/app/organizations/$organizationId/sets/$setId/': {
      id: '/app/organizations/$organizationId/sets/$setId/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/sets/$setId/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRoute
    }
    '/app/organizations/$organizationId/sets/$setId/calculator': {
      id: '/app/organizations/$organizationId/sets/$setId/calculator'
      path: '/calculator'
      fullPath: '/app/organizations/$organizationId/sets/$setId/calculator'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdCalculatorRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRoute
    }
    '/app/organizations/$organizationId/sets/$setId/glossary': {
      id: '/app/organizations/$organizationId/sets/$setId/glossary'
      path: '/glossary'
      fullPath: '/app/organizations/$organizationId/sets/$setId/glossary'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdGlossaryRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRoute
    }
    '/app/organizations/$organizationId/sets/$setId/report': {
      id: '/app/organizations/$organizationId/sets/$setId/report'
      path: '/report'
      fullPath: '/app/organizations/$organizationId/sets/$setId/report'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdReportRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRoute
    }
    '/app/account/twc/join/$orgType/$orgId/$ufcId': {
      id: '/app/account/twc/join/$orgType/$orgId/$ufcId'
      path: '/$ufcId'
      fullPath: '/app/account/twc/join/$orgType/$orgId/$ufcId'
      preLoaderRoute: typeof AppAccountTwcJoinOrgTypeOrgIdUfcIdRouteImport
      parentRoute: typeof AppAccountTwcJoinOrgTypeOrgIdRoute
    }
    '/app/deeplinks/programs/$programId/sets/$setId/': {
      id: '/app/deeplinks/programs/$programId/sets/$setId/'
      path: '/programs/$programId/sets/$setId'
      fullPath: '/app/deeplinks/programs/$programId/sets/$setId/'
      preLoaderRoute: typeof AppDeeplinksProgramsProgramIdSetsSetIdIndexRouteImport
      parentRoute: typeof AppDeeplinksRouteRoute
    }
    '/app/demos/sets/$setId/view/$activeDemoView/': {
      id: '/app/demos/sets/$setId/view/$activeDemoView/'
      path: '/demos/sets/$setId/view/$activeDemoView'
      fullPath: '/app/demos/sets/$setId/view/$activeDemoView/'
      preLoaderRoute: typeof AppDemosSetsSetIdViewActiveDemoViewIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/demos/sets/$setId/view/$activeDemoView/$questionId': {
      id: '/app/demos/sets/$setId/view/$activeDemoView/$questionId'
      path: '/demos/sets/$setId/view/$activeDemoView/$questionId'
      fullPath: '/app/demos/sets/$setId/view/$activeDemoView/$questionId'
      preLoaderRoute: typeof AppDemosSetsSetIdViewActiveDemoViewQuestionIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/': {
      id: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute
    }
    '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId': {
      id: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId'
      path: '/$subsectionId'
      fullPath: '/app/organizations/$organizationId/builder/$docbuilderSlug/$format/$subsectionId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute
    }
    '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/': {
      id: '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute
    }
    '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide': {
      id: '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide'
      path: '/guide'
      fullPath: '/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/guide'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute
    }
    '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/': {
      id: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/'
      path: '/'
      fullPath: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute
    }
    '/app/organizations/$organizationId/sets/$setId/modules/$moduleId': {
      id: '/app/organizations/$organizationId/sets/$setId/modules/$moduleId'
      path: '/modules/$moduleId'
      fullPath: '/app/organizations/$organizationId/sets/$setId/modules/$moduleId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRoute
    }
    '/app/organizations/$organizationId/sets/$setId/questions/$questionId': {
      id: '/app/organizations/$organizationId/sets/$setId/questions/$questionId'
      path: '/questions/$questionId'
      fullPath: '/app/organizations/$organizationId/sets/$setId/questions/$questionId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRoute
    }
    '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId': {
      id: '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId'
      path: '/programs/$programId/sets/$setId/modules/$moduleId'
      fullPath: '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId'
      preLoaderRoute: typeof AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRouteImport
      parentRoute: typeof AppDeeplinksRouteRoute
    }
    '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId': {
      id: '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId'
      path: '/programs/$programId/sets/$setId/questions/$questionId'
      fullPath: '/app/deeplinks/programs/$programId/sets/$setId/questions/$questionId'
      preLoaderRoute: typeof AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRouteImport
      parentRoute: typeof AppDeeplinksRouteRoute
    }
    '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId': {
      id: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId'
      path: '/modules/$moduleId'
      fullPath: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/modules/$moduleId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute
    }
    '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId': {
      id: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId'
      path: '/sets/$setId'
      fullPath: '/app/organizations/$organizationId/reports/children/$childOrgTypeMachineName/sets/$setId'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute
    }
    '/app/organizations/$organizationId/sets/$setId/report/download/$format': {
      id: '/app/organizations/$organizationId/sets/$setId/report/download/$format'
      path: '/download/$format'
      fullPath: '/app/organizations/$organizationId/sets/$setId/report/download/$format'
      preLoaderRoute: typeof AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRouteImport
      parentRoute: typeof AppOrganizationsOrganizationIdSetsSetIdReportRoute
    }
    '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator': {
      id: '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator'
      path: '/organizations/$organizationId/sets/$setId/calculator'
      fullPath: '/app/programs/$programId/organizations/$organizationId/sets/$setId/calculator'
      preLoaderRoute: typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRouteImport
      parentRoute: typeof AppProgramsProgramIdRoute
    }
    '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary': {
      id: '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary'
      path: '/organizations/$organizationId/sets/$setId/glossary'
      fullPath: '/app/programs/$programId/organizations/$organizationId/sets/$setId/glossary'
      preLoaderRoute: typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRouteImport
      parentRoute: typeof AppProgramsProgramIdRoute
    }
  }
}

interface AppAccountWelcomeBackRouteChildren {
  AppAccountWelcomeBackTokenRoute: typeof AppAccountWelcomeBackTokenRoute
}

const AppAccountWelcomeBackRouteChildren: AppAccountWelcomeBackRouteChildren = {
  AppAccountWelcomeBackTokenRoute: AppAccountWelcomeBackTokenRoute,
}

const AppAccountWelcomeBackRouteWithChildren =
  AppAccountWelcomeBackRoute._addFileChildren(
    AppAccountWelcomeBackRouteChildren,
  )

interface AppAccountTwcJoinOrgTypeOrgIdRouteChildren {
  AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute: typeof AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute
}

const AppAccountTwcJoinOrgTypeOrgIdRouteChildren: AppAccountTwcJoinOrgTypeOrgIdRouteChildren =
  {
    AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute:
      AppAccountTwcJoinOrgTypeOrgIdUfcIdRoute,
  }

const AppAccountTwcJoinOrgTypeOrgIdRouteWithChildren =
  AppAccountTwcJoinOrgTypeOrgIdRoute._addFileChildren(
    AppAccountTwcJoinOrgTypeOrgIdRouteChildren,
  )

interface AppAccountTwcJoinOrgTypeRouteChildren {
  AppAccountTwcJoinOrgTypeOrgIdRoute: typeof AppAccountTwcJoinOrgTypeOrgIdRouteWithChildren
}

const AppAccountTwcJoinOrgTypeRouteChildren: AppAccountTwcJoinOrgTypeRouteChildren =
  {
    AppAccountTwcJoinOrgTypeOrgIdRoute:
      AppAccountTwcJoinOrgTypeOrgIdRouteWithChildren,
  }

const AppAccountTwcJoinOrgTypeRouteWithChildren =
  AppAccountTwcJoinOrgTypeRoute._addFileChildren(
    AppAccountTwcJoinOrgTypeRouteChildren,
  )

interface AppAccountTwcJoinRouteRouteChildren {
  AppAccountTwcJoinOrgTypeRoute: typeof AppAccountTwcJoinOrgTypeRouteWithChildren
  AppAccountTwcJoinIndexRoute: typeof AppAccountTwcJoinIndexRoute
}

const AppAccountTwcJoinRouteRouteChildren: AppAccountTwcJoinRouteRouteChildren =
  {
    AppAccountTwcJoinOrgTypeRoute: AppAccountTwcJoinOrgTypeRouteWithChildren,
    AppAccountTwcJoinIndexRoute: AppAccountTwcJoinIndexRoute,
  }

const AppAccountTwcJoinRouteRouteWithChildren =
  AppAccountTwcJoinRouteRoute._addFileChildren(
    AppAccountTwcJoinRouteRouteChildren,
  )

interface AppAccountRegisterVerificationRouteChildren {
  AppAccountRegisterVerificationIndexRoute: typeof AppAccountRegisterVerificationIndexRoute
  AppAccountRegisterVerificationUrlEncodedUrlRoute: typeof AppAccountRegisterVerificationUrlEncodedUrlRoute
}

const AppAccountRegisterVerificationRouteChildren: AppAccountRegisterVerificationRouteChildren =
  {
    AppAccountRegisterVerificationIndexRoute:
      AppAccountRegisterVerificationIndexRoute,
    AppAccountRegisterVerificationUrlEncodedUrlRoute:
      AppAccountRegisterVerificationUrlEncodedUrlRoute,
  }

const AppAccountRegisterVerificationRouteWithChildren =
  AppAccountRegisterVerificationRoute._addFileChildren(
    AppAccountRegisterVerificationRouteChildren,
  )

interface AppAccountRouteRouteChildren {
  AppAccountCurriculaRoute: typeof AppAccountCurriculaRoute
  AppAccountDashboardRoute: typeof AppAccountDashboardRoute
  AppAccountDeactivateRoute: typeof AppAccountDeactivateRoute
  AppAccountFavoritesRoute: typeof AppAccountFavoritesRoute
  AppAccountForgotRoute: typeof AppAccountForgotRoute
  AppAccountLoggedOutRoute: typeof AppAccountLoggedOutRoute
  AppAccountLoginRoute: typeof AppAccountLoginRoute
  AppAccountLogoutRoute: typeof AppAccountLogoutRoute
  AppAccountProfileRoute: typeof AppAccountProfileRoute
  AppAccountReactivateRoute: typeof AppAccountReactivateRoute
  AppAccountWelcomeBackRoute: typeof AppAccountWelcomeBackRouteWithChildren
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppAccountTwcJoinRouteRoute: typeof AppAccountTwcJoinRouteRouteWithChildren
  AppAccountActivityLogSplatRoute: typeof AppAccountActivityLogSplatRoute
  AppAccountRedeemInviteInviteTokenRoute: typeof AppAccountRedeemInviteInviteTokenRoute
  AppAccountRegisterVerificationRoute: typeof AppAccountRegisterVerificationRouteWithChildren
  AppAccountResetPasswordTokenRoute: typeof AppAccountResetPasswordTokenRoute
  AppAccountRegisterIndexRoute: typeof AppAccountRegisterIndexRoute
  AppAccountTwcIndexRoute: typeof AppAccountTwcIndexRoute
}

const AppAccountRouteRouteChildren: AppAccountRouteRouteChildren = {
  AppAccountCurriculaRoute: AppAccountCurriculaRoute,
  AppAccountDashboardRoute: AppAccountDashboardRoute,
  AppAccountDeactivateRoute: AppAccountDeactivateRoute,
  AppAccountFavoritesRoute: AppAccountFavoritesRoute,
  AppAccountForgotRoute: AppAccountForgotRoute,
  AppAccountLoggedOutRoute: AppAccountLoggedOutRoute,
  AppAccountLoginRoute: AppAccountLoginRoute,
  AppAccountLogoutRoute: AppAccountLogoutRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAccountReactivateRoute: AppAccountReactivateRoute,
  AppAccountWelcomeBackRoute: AppAccountWelcomeBackRouteWithChildren,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppAccountTwcJoinRouteRoute: AppAccountTwcJoinRouteRouteWithChildren,
  AppAccountActivityLogSplatRoute: AppAccountActivityLogSplatRoute,
  AppAccountRedeemInviteInviteTokenRoute:
    AppAccountRedeemInviteInviteTokenRoute,
  AppAccountRegisterVerificationRoute:
    AppAccountRegisterVerificationRouteWithChildren,
  AppAccountResetPasswordTokenRoute: AppAccountResetPasswordTokenRoute,
  AppAccountRegisterIndexRoute: AppAccountRegisterIndexRoute,
  AppAccountTwcIndexRoute: AppAccountTwcIndexRoute,
}

const AppAccountRouteRouteWithChildren = AppAccountRouteRoute._addFileChildren(
  AppAccountRouteRouteChildren,
)

interface AppAdminContentRouteRouteChildren {
  AppAdminContentContentIdRoute: typeof AppAdminContentContentIdRoute
  AppAdminContentNewRoute: typeof AppAdminContentNewRoute
  AppAdminContentIndexRoute: typeof AppAdminContentIndexRoute
}

const AppAdminContentRouteRouteChildren: AppAdminContentRouteRouteChildren = {
  AppAdminContentContentIdRoute: AppAdminContentContentIdRoute,
  AppAdminContentNewRoute: AppAdminContentNewRoute,
  AppAdminContentIndexRoute: AppAdminContentIndexRoute,
}

const AppAdminContentRouteRouteWithChildren =
  AppAdminContentRouteRoute._addFileChildren(AppAdminContentRouteRouteChildren)

interface AppAdminCriteriaRouteRouteChildren {
  AppAdminCriteriaCriterionIdRoute: typeof AppAdminCriteriaCriterionIdRoute
  AppAdminCriteriaNewRoute: typeof AppAdminCriteriaNewRoute
  AppAdminCriteriaIndexRoute: typeof AppAdminCriteriaIndexRoute
}

const AppAdminCriteriaRouteRouteChildren: AppAdminCriteriaRouteRouteChildren = {
  AppAdminCriteriaCriterionIdRoute: AppAdminCriteriaCriterionIdRoute,
  AppAdminCriteriaNewRoute: AppAdminCriteriaNewRoute,
  AppAdminCriteriaIndexRoute: AppAdminCriteriaIndexRoute,
}

const AppAdminCriteriaRouteRouteWithChildren =
  AppAdminCriteriaRouteRoute._addFileChildren(
    AppAdminCriteriaRouteRouteChildren,
  )

interface AppAdminCriterionTopicsRouteRouteChildren {
  AppAdminCriterionTopicsCriterionTopicIdRoute: typeof AppAdminCriterionTopicsCriterionTopicIdRoute
  AppAdminCriterionTopicsNewRoute: typeof AppAdminCriterionTopicsNewRoute
  AppAdminCriterionTopicsIndexRoute: typeof AppAdminCriterionTopicsIndexRoute
}

const AppAdminCriterionTopicsRouteRouteChildren: AppAdminCriterionTopicsRouteRouteChildren =
  {
    AppAdminCriterionTopicsCriterionTopicIdRoute:
      AppAdminCriterionTopicsCriterionTopicIdRoute,
    AppAdminCriterionTopicsNewRoute: AppAdminCriterionTopicsNewRoute,
    AppAdminCriterionTopicsIndexRoute: AppAdminCriterionTopicsIndexRoute,
  }

const AppAdminCriterionTopicsRouteRouteWithChildren =
  AppAdminCriterionTopicsRouteRoute._addFileChildren(
    AppAdminCriterionTopicsRouteRouteChildren,
  )

interface AppAdminLmsAudioRouteRouteChildren {
  AppAdminLmsAudioAudioIdRoute: typeof AppAdminLmsAudioAudioIdRoute
  AppAdminLmsAudioNewRoute: typeof AppAdminLmsAudioNewRoute
}

const AppAdminLmsAudioRouteRouteChildren: AppAdminLmsAudioRouteRouteChildren = {
  AppAdminLmsAudioAudioIdRoute: AppAdminLmsAudioAudioIdRoute,
  AppAdminLmsAudioNewRoute: AppAdminLmsAudioNewRoute,
}

const AppAdminLmsAudioRouteRouteWithChildren =
  AppAdminLmsAudioRouteRoute._addFileChildren(
    AppAdminLmsAudioRouteRouteChildren,
  )

interface AppAdminLmsCollectionsRouteRouteChildren {
  AppAdminLmsCollectionsCollectionIdRoute: typeof AppAdminLmsCollectionsCollectionIdRoute
  AppAdminLmsCollectionsNewRoute: typeof AppAdminLmsCollectionsNewRoute
}

const AppAdminLmsCollectionsRouteRouteChildren: AppAdminLmsCollectionsRouteRouteChildren =
  {
    AppAdminLmsCollectionsCollectionIdRoute:
      AppAdminLmsCollectionsCollectionIdRoute,
    AppAdminLmsCollectionsNewRoute: AppAdminLmsCollectionsNewRoute,
  }

const AppAdminLmsCollectionsRouteRouteWithChildren =
  AppAdminLmsCollectionsRouteRoute._addFileChildren(
    AppAdminLmsCollectionsRouteRouteChildren,
  )

interface AppAdminLmsCurriculaRouteRouteChildren {
  AppAdminLmsCurriculaCurriculumIdRoute: typeof AppAdminLmsCurriculaCurriculumIdRoute
  AppAdminLmsCurriculaNewRoute: typeof AppAdminLmsCurriculaNewRoute
}

const AppAdminLmsCurriculaRouteRouteChildren: AppAdminLmsCurriculaRouteRouteChildren =
  {
    AppAdminLmsCurriculaCurriculumIdRoute:
      AppAdminLmsCurriculaCurriculumIdRoute,
    AppAdminLmsCurriculaNewRoute: AppAdminLmsCurriculaNewRoute,
  }

const AppAdminLmsCurriculaRouteRouteWithChildren =
  AppAdminLmsCurriculaRouteRoute._addFileChildren(
    AppAdminLmsCurriculaRouteRouteChildren,
  )

interface AppAdminLmsMicrolearningsRouteRouteChildren {
  AppAdminLmsMicrolearningsMicrolearningIdRoute: typeof AppAdminLmsMicrolearningsMicrolearningIdRoute
  AppAdminLmsMicrolearningsNewRoute: typeof AppAdminLmsMicrolearningsNewRoute
}

const AppAdminLmsMicrolearningsRouteRouteChildren: AppAdminLmsMicrolearningsRouteRouteChildren =
  {
    AppAdminLmsMicrolearningsMicrolearningIdRoute:
      AppAdminLmsMicrolearningsMicrolearningIdRoute,
    AppAdminLmsMicrolearningsNewRoute: AppAdminLmsMicrolearningsNewRoute,
  }

const AppAdminLmsMicrolearningsRouteRouteWithChildren =
  AppAdminLmsMicrolearningsRouteRoute._addFileChildren(
    AppAdminLmsMicrolearningsRouteRouteChildren,
  )

interface AppAdminLmsResourcesRouteRouteChildren {
  AppAdminLmsResourcesResourceIdRoute: typeof AppAdminLmsResourcesResourceIdRoute
  AppAdminLmsResourcesNewRoute: typeof AppAdminLmsResourcesNewRoute
}

const AppAdminLmsResourcesRouteRouteChildren: AppAdminLmsResourcesRouteRouteChildren =
  {
    AppAdminLmsResourcesResourceIdRoute: AppAdminLmsResourcesResourceIdRoute,
    AppAdminLmsResourcesNewRoute: AppAdminLmsResourcesNewRoute,
  }

const AppAdminLmsResourcesRouteRouteWithChildren =
  AppAdminLmsResourcesRouteRoute._addFileChildren(
    AppAdminLmsResourcesRouteRouteChildren,
  )

interface AppAdminLmsTrainingsLocalRouteRouteChildren {
  AppAdminLmsTrainingsLocalTrainingIdRoute: typeof AppAdminLmsTrainingsLocalTrainingIdRoute
  AppAdminLmsTrainingsLocalNewRoute: typeof AppAdminLmsTrainingsLocalNewRoute
}

const AppAdminLmsTrainingsLocalRouteRouteChildren: AppAdminLmsTrainingsLocalRouteRouteChildren =
  {
    AppAdminLmsTrainingsLocalTrainingIdRoute:
      AppAdminLmsTrainingsLocalTrainingIdRoute,
    AppAdminLmsTrainingsLocalNewRoute: AppAdminLmsTrainingsLocalNewRoute,
  }

const AppAdminLmsTrainingsLocalRouteRouteWithChildren =
  AppAdminLmsTrainingsLocalRouteRoute._addFileChildren(
    AppAdminLmsTrainingsLocalRouteRouteChildren,
  )

interface AppAdminLmsRouteRouteChildren {
  AppAdminLmsAudioRouteRoute: typeof AppAdminLmsAudioRouteRouteWithChildren
  AppAdminLmsCollectionsRouteRoute: typeof AppAdminLmsCollectionsRouteRouteWithChildren
  AppAdminLmsCurriculaRouteRoute: typeof AppAdminLmsCurriculaRouteRouteWithChildren
  AppAdminLmsMicrolearningsRouteRoute: typeof AppAdminLmsMicrolearningsRouteRouteWithChildren
  AppAdminLmsResourcesRouteRoute: typeof AppAdminLmsResourcesRouteRouteWithChildren
  AppAdminLmsTrainingsLocalRouteRoute: typeof AppAdminLmsTrainingsLocalRouteRouteWithChildren
  AppAdminLmsIndexRoute: typeof AppAdminLmsIndexRoute
  AppAdminLmsMaterialsMaterialIdRoute: typeof AppAdminLmsMaterialsMaterialIdRoute
  AppAdminLmsTrainingsOnDemandTrainingIdRoute: typeof AppAdminLmsTrainingsOnDemandTrainingIdRoute
  AppAdminLmsTrainingsVirtualTrainingIdRoute: typeof AppAdminLmsTrainingsVirtualTrainingIdRoute
}

const AppAdminLmsRouteRouteChildren: AppAdminLmsRouteRouteChildren = {
  AppAdminLmsAudioRouteRoute: AppAdminLmsAudioRouteRouteWithChildren,
  AppAdminLmsCollectionsRouteRoute:
    AppAdminLmsCollectionsRouteRouteWithChildren,
  AppAdminLmsCurriculaRouteRoute: AppAdminLmsCurriculaRouteRouteWithChildren,
  AppAdminLmsMicrolearningsRouteRoute:
    AppAdminLmsMicrolearningsRouteRouteWithChildren,
  AppAdminLmsResourcesRouteRoute: AppAdminLmsResourcesRouteRouteWithChildren,
  AppAdminLmsTrainingsLocalRouteRoute:
    AppAdminLmsTrainingsLocalRouteRouteWithChildren,
  AppAdminLmsIndexRoute: AppAdminLmsIndexRoute,
  AppAdminLmsMaterialsMaterialIdRoute: AppAdminLmsMaterialsMaterialIdRoute,
  AppAdminLmsTrainingsOnDemandTrainingIdRoute:
    AppAdminLmsTrainingsOnDemandTrainingIdRoute,
  AppAdminLmsTrainingsVirtualTrainingIdRoute:
    AppAdminLmsTrainingsVirtualTrainingIdRoute,
}

const AppAdminLmsRouteRouteWithChildren =
  AppAdminLmsRouteRoute._addFileChildren(AppAdminLmsRouteRouteChildren)

interface AppAdminOrganizationsOrganizationIdRouteRouteChildren {
  AppAdminOrganizationsOrganizationIdTeamRoute: typeof AppAdminOrganizationsOrganizationIdTeamRoute
  AppAdminOrganizationsOrganizationIdIndexRoute: typeof AppAdminOrganizationsOrganizationIdIndexRoute
}

const AppAdminOrganizationsOrganizationIdRouteRouteChildren: AppAdminOrganizationsOrganizationIdRouteRouteChildren =
  {
    AppAdminOrganizationsOrganizationIdTeamRoute:
      AppAdminOrganizationsOrganizationIdTeamRoute,
    AppAdminOrganizationsOrganizationIdIndexRoute:
      AppAdminOrganizationsOrganizationIdIndexRoute,
  }

const AppAdminOrganizationsOrganizationIdRouteRouteWithChildren =
  AppAdminOrganizationsOrganizationIdRouteRoute._addFileChildren(
    AppAdminOrganizationsOrganizationIdRouteRouteChildren,
  )

interface AppAdminOrganizationsRouteRouteChildren {
  AppAdminOrganizationsOrganizationIdRouteRoute: typeof AppAdminOrganizationsOrganizationIdRouteRouteWithChildren
  AppAdminOrganizationsIndexRoute: typeof AppAdminOrganizationsIndexRoute
}

const AppAdminOrganizationsRouteRouteChildren: AppAdminOrganizationsRouteRouteChildren =
  {
    AppAdminOrganizationsOrganizationIdRouteRoute:
      AppAdminOrganizationsOrganizationIdRouteRouteWithChildren,
    AppAdminOrganizationsIndexRoute: AppAdminOrganizationsIndexRoute,
  }

const AppAdminOrganizationsRouteRouteWithChildren =
  AppAdminOrganizationsRouteRoute._addFileChildren(
    AppAdminOrganizationsRouteRouteChildren,
  )

interface AppAdminPendingRouteRouteChildren {
  AppAdminPendingInvitesRoute: typeof AppAdminPendingInvitesRoute
  AppAdminPendingRequestsRoute: typeof AppAdminPendingRequestsRoute
}

const AppAdminPendingRouteRouteChildren: AppAdminPendingRouteRouteChildren = {
  AppAdminPendingInvitesRoute: AppAdminPendingInvitesRoute,
  AppAdminPendingRequestsRoute: AppAdminPendingRequestsRoute,
}

const AppAdminPendingRouteRouteWithChildren =
  AppAdminPendingRouteRoute._addFileChildren(AppAdminPendingRouteRouteChildren)

interface AppAdminProgramsProgramIdRouteRouteChildren {
  AppAdminProgramsProgramIdOrganizationsRoute: typeof AppAdminProgramsProgramIdOrganizationsRoute
  AppAdminProgramsProgramIdSetsRoute: typeof AppAdminProgramsProgramIdSetsRoute
  AppAdminProgramsProgramIdIndexRoute: typeof AppAdminProgramsProgramIdIndexRoute
}

const AppAdminProgramsProgramIdRouteRouteChildren: AppAdminProgramsProgramIdRouteRouteChildren =
  {
    AppAdminProgramsProgramIdOrganizationsRoute:
      AppAdminProgramsProgramIdOrganizationsRoute,
    AppAdminProgramsProgramIdSetsRoute: AppAdminProgramsProgramIdSetsRoute,
    AppAdminProgramsProgramIdIndexRoute: AppAdminProgramsProgramIdIndexRoute,
  }

const AppAdminProgramsProgramIdRouteRouteWithChildren =
  AppAdminProgramsProgramIdRouteRoute._addFileChildren(
    AppAdminProgramsProgramIdRouteRouteChildren,
  )

interface AppAdminProgramsRouteRouteChildren {
  AppAdminProgramsProgramIdRouteRoute: typeof AppAdminProgramsProgramIdRouteRouteWithChildren
  AppAdminProgramsIndexRoute: typeof AppAdminProgramsIndexRoute
}

const AppAdminProgramsRouteRouteChildren: AppAdminProgramsRouteRouteChildren = {
  AppAdminProgramsProgramIdRouteRoute:
    AppAdminProgramsProgramIdRouteRouteWithChildren,
  AppAdminProgramsIndexRoute: AppAdminProgramsIndexRoute,
}

const AppAdminProgramsRouteRouteWithChildren =
  AppAdminProgramsRouteRoute._addFileChildren(
    AppAdminProgramsRouteRouteChildren,
  )

interface AppAdminSetsSetIdModulesRouteRouteChildren {
  AppAdminSetsSetIdModulesModuleIdRoute: typeof AppAdminSetsSetIdModulesModuleIdRoute
  AppAdminSetsSetIdModulesNewRoute: typeof AppAdminSetsSetIdModulesNewRoute
  AppAdminSetsSetIdModulesIndexRoute: typeof AppAdminSetsSetIdModulesIndexRoute
}

const AppAdminSetsSetIdModulesRouteRouteChildren: AppAdminSetsSetIdModulesRouteRouteChildren =
  {
    AppAdminSetsSetIdModulesModuleIdRoute:
      AppAdminSetsSetIdModulesModuleIdRoute,
    AppAdminSetsSetIdModulesNewRoute: AppAdminSetsSetIdModulesNewRoute,
    AppAdminSetsSetIdModulesIndexRoute: AppAdminSetsSetIdModulesIndexRoute,
  }

const AppAdminSetsSetIdModulesRouteRouteWithChildren =
  AppAdminSetsSetIdModulesRouteRoute._addFileChildren(
    AppAdminSetsSetIdModulesRouteRouteChildren,
  )

interface AppAdminSetsSetIdQuestionsRouteRouteChildren {
  AppAdminSetsSetIdQuestionsQuestionIdRoute: typeof AppAdminSetsSetIdQuestionsQuestionIdRoute
  AppAdminSetsSetIdQuestionsNewRoute: typeof AppAdminSetsSetIdQuestionsNewRoute
  AppAdminSetsSetIdQuestionsIndexRoute: typeof AppAdminSetsSetIdQuestionsIndexRoute
}

const AppAdminSetsSetIdQuestionsRouteRouteChildren: AppAdminSetsSetIdQuestionsRouteRouteChildren =
  {
    AppAdminSetsSetIdQuestionsQuestionIdRoute:
      AppAdminSetsSetIdQuestionsQuestionIdRoute,
    AppAdminSetsSetIdQuestionsNewRoute: AppAdminSetsSetIdQuestionsNewRoute,
    AppAdminSetsSetIdQuestionsIndexRoute: AppAdminSetsSetIdQuestionsIndexRoute,
  }

const AppAdminSetsSetIdQuestionsRouteRouteWithChildren =
  AppAdminSetsSetIdQuestionsRouteRoute._addFileChildren(
    AppAdminSetsSetIdQuestionsRouteRouteChildren,
  )

interface AppAdminSetsSetIdRouteRouteChildren {
  AppAdminSetsSetIdModulesRouteRoute: typeof AppAdminSetsSetIdModulesRouteRouteWithChildren
  AppAdminSetsSetIdQuestionsRouteRoute: typeof AppAdminSetsSetIdQuestionsRouteRouteWithChildren
  AppAdminSetsSetIdCloneRoute: typeof AppAdminSetsSetIdCloneRoute
  AppAdminSetsSetIdDemoRoute: typeof AppAdminSetsSetIdDemoRoute
  AppAdminSetsSetIdIndexRoute: typeof AppAdminSetsSetIdIndexRoute
}

const AppAdminSetsSetIdRouteRouteChildren: AppAdminSetsSetIdRouteRouteChildren =
  {
    AppAdminSetsSetIdModulesRouteRoute:
      AppAdminSetsSetIdModulesRouteRouteWithChildren,
    AppAdminSetsSetIdQuestionsRouteRoute:
      AppAdminSetsSetIdQuestionsRouteRouteWithChildren,
    AppAdminSetsSetIdCloneRoute: AppAdminSetsSetIdCloneRoute,
    AppAdminSetsSetIdDemoRoute: AppAdminSetsSetIdDemoRoute,
    AppAdminSetsSetIdIndexRoute: AppAdminSetsSetIdIndexRoute,
  }

const AppAdminSetsSetIdRouteRouteWithChildren =
  AppAdminSetsSetIdRouteRoute._addFileChildren(
    AppAdminSetsSetIdRouteRouteChildren,
  )

interface AppAdminSetsRouteRouteChildren {
  AppAdminSetsSetIdRouteRoute: typeof AppAdminSetsSetIdRouteRouteWithChildren
  AppAdminSetsNewRoute: typeof AppAdminSetsNewRoute
  AppAdminSetsIndexRoute: typeof AppAdminSetsIndexRoute
}

const AppAdminSetsRouteRouteChildren: AppAdminSetsRouteRouteChildren = {
  AppAdminSetsSetIdRouteRoute: AppAdminSetsSetIdRouteRouteWithChildren,
  AppAdminSetsNewRoute: AppAdminSetsNewRoute,
  AppAdminSetsIndexRoute: AppAdminSetsIndexRoute,
}

const AppAdminSetsRouteRouteWithChildren =
  AppAdminSetsRouteRoute._addFileChildren(AppAdminSetsRouteRouteChildren)

interface AppAdminSettingsRouteRouteChildren {
  AppAdminSettingsSettingIdRoute: typeof AppAdminSettingsSettingIdRoute
  AppAdminSettingsNewRoute: typeof AppAdminSettingsNewRoute
  AppAdminSettingsIndexRoute: typeof AppAdminSettingsIndexRoute
}

const AppAdminSettingsRouteRouteChildren: AppAdminSettingsRouteRouteChildren = {
  AppAdminSettingsSettingIdRoute: AppAdminSettingsSettingIdRoute,
  AppAdminSettingsNewRoute: AppAdminSettingsNewRoute,
  AppAdminSettingsIndexRoute: AppAdminSettingsIndexRoute,
}

const AppAdminSettingsRouteRouteWithChildren =
  AppAdminSettingsRouteRoute._addFileChildren(
    AppAdminSettingsRouteRouteChildren,
  )

interface AppAdminSurveysSurveyIdQuestionsRouteRouteChildren {
  AppAdminSurveysSurveyIdQuestionsQuestionIdRoute: typeof AppAdminSurveysSurveyIdQuestionsQuestionIdRoute
  AppAdminSurveysSurveyIdQuestionsNewRoute: typeof AppAdminSurveysSurveyIdQuestionsNewRoute
  AppAdminSurveysSurveyIdQuestionsIndexRoute: typeof AppAdminSurveysSurveyIdQuestionsIndexRoute
}

const AppAdminSurveysSurveyIdQuestionsRouteRouteChildren: AppAdminSurveysSurveyIdQuestionsRouteRouteChildren =
  {
    AppAdminSurveysSurveyIdQuestionsQuestionIdRoute:
      AppAdminSurveysSurveyIdQuestionsQuestionIdRoute,
    AppAdminSurveysSurveyIdQuestionsNewRoute:
      AppAdminSurveysSurveyIdQuestionsNewRoute,
    AppAdminSurveysSurveyIdQuestionsIndexRoute:
      AppAdminSurveysSurveyIdQuestionsIndexRoute,
  }

const AppAdminSurveysSurveyIdQuestionsRouteRouteWithChildren =
  AppAdminSurveysSurveyIdQuestionsRouteRoute._addFileChildren(
    AppAdminSurveysSurveyIdQuestionsRouteRouteChildren,
  )

interface AppAdminSurveysSurveyIdTopicsRouteRouteChildren {
  AppAdminSurveysSurveyIdTopicsTopicIdRoute: typeof AppAdminSurveysSurveyIdTopicsTopicIdRoute
  AppAdminSurveysSurveyIdTopicsNewRoute: typeof AppAdminSurveysSurveyIdTopicsNewRoute
  AppAdminSurveysSurveyIdTopicsIndexRoute: typeof AppAdminSurveysSurveyIdTopicsIndexRoute
}

const AppAdminSurveysSurveyIdTopicsRouteRouteChildren: AppAdminSurveysSurveyIdTopicsRouteRouteChildren =
  {
    AppAdminSurveysSurveyIdTopicsTopicIdRoute:
      AppAdminSurveysSurveyIdTopicsTopicIdRoute,
    AppAdminSurveysSurveyIdTopicsNewRoute:
      AppAdminSurveysSurveyIdTopicsNewRoute,
    AppAdminSurveysSurveyIdTopicsIndexRoute:
      AppAdminSurveysSurveyIdTopicsIndexRoute,
  }

const AppAdminSurveysSurveyIdTopicsRouteRouteWithChildren =
  AppAdminSurveysSurveyIdTopicsRouteRoute._addFileChildren(
    AppAdminSurveysSurveyIdTopicsRouteRouteChildren,
  )

interface AppAdminSurveysRouteRouteChildren {
  AppAdminSurveysNewRoute: typeof AppAdminSurveysNewRoute
  AppAdminSurveysIndexRoute: typeof AppAdminSurveysIndexRoute
  AppAdminSurveysSurveyIdQuestionsRouteRoute: typeof AppAdminSurveysSurveyIdQuestionsRouteRouteWithChildren
  AppAdminSurveysSurveyIdTopicsRouteRoute: typeof AppAdminSurveysSurveyIdTopicsRouteRouteWithChildren
  AppAdminSurveysSurveyIdIndexRoute: typeof AppAdminSurveysSurveyIdIndexRoute
}

const AppAdminSurveysRouteRouteChildren: AppAdminSurveysRouteRouteChildren = {
  AppAdminSurveysNewRoute: AppAdminSurveysNewRoute,
  AppAdminSurveysIndexRoute: AppAdminSurveysIndexRoute,
  AppAdminSurveysSurveyIdQuestionsRouteRoute:
    AppAdminSurveysSurveyIdQuestionsRouteRouteWithChildren,
  AppAdminSurveysSurveyIdTopicsRouteRoute:
    AppAdminSurveysSurveyIdTopicsRouteRouteWithChildren,
  AppAdminSurveysSurveyIdIndexRoute: AppAdminSurveysSurveyIdIndexRoute,
}

const AppAdminSurveysRouteRouteWithChildren =
  AppAdminSurveysRouteRoute._addFileChildren(AppAdminSurveysRouteRouteChildren)

interface AppAdminTagsRouteRouteChildren {
  AppAdminTagsTagIdRoute: typeof AppAdminTagsTagIdRoute
  AppAdminTagsNewRoute: typeof AppAdminTagsNewRoute
  AppAdminTagsIndexRoute: typeof AppAdminTagsIndexRoute
}

const AppAdminTagsRouteRouteChildren: AppAdminTagsRouteRouteChildren = {
  AppAdminTagsTagIdRoute: AppAdminTagsTagIdRoute,
  AppAdminTagsNewRoute: AppAdminTagsNewRoute,
  AppAdminTagsIndexRoute: AppAdminTagsIndexRoute,
}

const AppAdminTagsRouteRouteWithChildren =
  AppAdminTagsRouteRoute._addFileChildren(AppAdminTagsRouteRouteChildren)

interface AppAdminTermsRouteRouteChildren {
  AppAdminTermsTermIdRoute: typeof AppAdminTermsTermIdRoute
  AppAdminTermsNewRoute: typeof AppAdminTermsNewRoute
  AppAdminTermsIndexRoute: typeof AppAdminTermsIndexRoute
}

const AppAdminTermsRouteRouteChildren: AppAdminTermsRouteRouteChildren = {
  AppAdminTermsTermIdRoute: AppAdminTermsTermIdRoute,
  AppAdminTermsNewRoute: AppAdminTermsNewRoute,
  AppAdminTermsIndexRoute: AppAdminTermsIndexRoute,
}

const AppAdminTermsRouteRouteWithChildren =
  AppAdminTermsRouteRoute._addFileChildren(AppAdminTermsRouteRouteChildren)

interface AppAdminUsersUserIdOrganizationsRouteRouteChildren {
  AppAdminUsersUserIdOrganizationsOrganizationIdRoute: typeof AppAdminUsersUserIdOrganizationsOrganizationIdRoute
  AppAdminUsersUserIdOrganizationsIndexRoute: typeof AppAdminUsersUserIdOrganizationsIndexRoute
}

const AppAdminUsersUserIdOrganizationsRouteRouteChildren: AppAdminUsersUserIdOrganizationsRouteRouteChildren =
  {
    AppAdminUsersUserIdOrganizationsOrganizationIdRoute:
      AppAdminUsersUserIdOrganizationsOrganizationIdRoute,
    AppAdminUsersUserIdOrganizationsIndexRoute:
      AppAdminUsersUserIdOrganizationsIndexRoute,
  }

const AppAdminUsersUserIdOrganizationsRouteRouteWithChildren =
  AppAdminUsersUserIdOrganizationsRouteRoute._addFileChildren(
    AppAdminUsersUserIdOrganizationsRouteRouteChildren,
  )

interface AppAdminUsersUserIdRouteRouteChildren {
  AppAdminUsersUserIdOrganizationsRouteRoute: typeof AppAdminUsersUserIdOrganizationsRouteRouteWithChildren
  AppAdminUsersUserIdPendingRoute: typeof AppAdminUsersUserIdPendingRoute
  AppAdminUsersUserIdIndexRoute: typeof AppAdminUsersUserIdIndexRoute
}

const AppAdminUsersUserIdRouteRouteChildren: AppAdminUsersUserIdRouteRouteChildren =
  {
    AppAdminUsersUserIdOrganizationsRouteRoute:
      AppAdminUsersUserIdOrganizationsRouteRouteWithChildren,
    AppAdminUsersUserIdPendingRoute: AppAdminUsersUserIdPendingRoute,
    AppAdminUsersUserIdIndexRoute: AppAdminUsersUserIdIndexRoute,
  }

const AppAdminUsersUserIdRouteRouteWithChildren =
  AppAdminUsersUserIdRouteRoute._addFileChildren(
    AppAdminUsersUserIdRouteRouteChildren,
  )

interface AppAdminUsersRouteRouteChildren {
  AppAdminUsersUserIdRouteRoute: typeof AppAdminUsersUserIdRouteRouteWithChildren
  AppAdminUsersNewRoute: typeof AppAdminUsersNewRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminUsersRouteRouteChildren: AppAdminUsersRouteRouteChildren = {
  AppAdminUsersUserIdRouteRoute: AppAdminUsersUserIdRouteRouteWithChildren,
  AppAdminUsersNewRoute: AppAdminUsersNewRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminUsersRouteRouteWithChildren =
  AppAdminUsersRouteRoute._addFileChildren(AppAdminUsersRouteRouteChildren)

interface AppAdminDemosRouteChildren {
  AppAdminDemosIndexRoute: typeof AppAdminDemosIndexRoute
  AppAdminDemosSetsDefaultRoute: typeof AppAdminDemosSetsDefaultRoute
  AppAdminDemosSetsIndexRoute: typeof AppAdminDemosSetsIndexRoute
}

const AppAdminDemosRouteChildren: AppAdminDemosRouteChildren = {
  AppAdminDemosIndexRoute: AppAdminDemosIndexRoute,
  AppAdminDemosSetsDefaultRoute: AppAdminDemosSetsDefaultRoute,
  AppAdminDemosSetsIndexRoute: AppAdminDemosSetsIndexRoute,
}

const AppAdminDemosRouteWithChildren = AppAdminDemosRoute._addFileChildren(
  AppAdminDemosRouteChildren,
)

interface AppAdminGuidesRouteChildren {
  AppAdminGuidesIndexRoute: typeof AppAdminGuidesIndexRoute
}

const AppAdminGuidesRouteChildren: AppAdminGuidesRouteChildren = {
  AppAdminGuidesIndexRoute: AppAdminGuidesIndexRoute,
}

const AppAdminGuidesRouteWithChildren = AppAdminGuidesRoute._addFileChildren(
  AppAdminGuidesRouteChildren,
)

interface AppAdminRouteRouteChildren {
  AppAdminContentRouteRoute: typeof AppAdminContentRouteRouteWithChildren
  AppAdminCriteriaRouteRoute: typeof AppAdminCriteriaRouteRouteWithChildren
  AppAdminCriterionTopicsRouteRoute: typeof AppAdminCriterionTopicsRouteRouteWithChildren
  AppAdminLmsRouteRoute: typeof AppAdminLmsRouteRouteWithChildren
  AppAdminOrganizationsRouteRoute: typeof AppAdminOrganizationsRouteRouteWithChildren
  AppAdminPendingRouteRoute: typeof AppAdminPendingRouteRouteWithChildren
  AppAdminProgramsRouteRoute: typeof AppAdminProgramsRouteRouteWithChildren
  AppAdminSetsRouteRoute: typeof AppAdminSetsRouteRouteWithChildren
  AppAdminSettingsRouteRoute: typeof AppAdminSettingsRouteRouteWithChildren
  AppAdminSurveysRouteRoute: typeof AppAdminSurveysRouteRouteWithChildren
  AppAdminTagsRouteRoute: typeof AppAdminTagsRouteRouteWithChildren
  AppAdminTermsRouteRoute: typeof AppAdminTermsRouteRouteWithChildren
  AppAdminUsersRouteRoute: typeof AppAdminUsersRouteRouteWithChildren
  AppAdminActivityLogRoute: typeof AppAdminActivityLogRoute
  AppAdminDemosRoute: typeof AppAdminDemosRouteWithChildren
  AppAdminGuidesRoute: typeof AppAdminGuidesRouteWithChildren
  AppAdminMetricsRoute: typeof AppAdminMetricsRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminContentRouteRoute: AppAdminContentRouteRouteWithChildren,
  AppAdminCriteriaRouteRoute: AppAdminCriteriaRouteRouteWithChildren,
  AppAdminCriterionTopicsRouteRoute:
    AppAdminCriterionTopicsRouteRouteWithChildren,
  AppAdminLmsRouteRoute: AppAdminLmsRouteRouteWithChildren,
  AppAdminOrganizationsRouteRoute: AppAdminOrganizationsRouteRouteWithChildren,
  AppAdminPendingRouteRoute: AppAdminPendingRouteRouteWithChildren,
  AppAdminProgramsRouteRoute: AppAdminProgramsRouteRouteWithChildren,
  AppAdminSetsRouteRoute: AppAdminSetsRouteRouteWithChildren,
  AppAdminSettingsRouteRoute: AppAdminSettingsRouteRouteWithChildren,
  AppAdminSurveysRouteRoute: AppAdminSurveysRouteRouteWithChildren,
  AppAdminTagsRouteRoute: AppAdminTagsRouteRouteWithChildren,
  AppAdminTermsRouteRoute: AppAdminTermsRouteRouteWithChildren,
  AppAdminUsersRouteRoute: AppAdminUsersRouteRouteWithChildren,
  AppAdminActivityLogRoute: AppAdminActivityLogRoute,
  AppAdminDemosRoute: AppAdminDemosRouteWithChildren,
  AppAdminGuidesRoute: AppAdminGuidesRouteWithChildren,
  AppAdminMetricsRoute: AppAdminMetricsRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppDeeplinksRouteRouteChildren {
  AppDeeplinksPlanRoute: typeof AppDeeplinksPlanRoute
  AppDeeplinksTeamRoute: typeof AppDeeplinksTeamRoute
  AppDeeplinksProgramsProgramIdIndexRoute: typeof AppDeeplinksProgramsProgramIdIndexRoute
  AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute: typeof AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute
  AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute: typeof AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute
  AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute: typeof AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute
}

const AppDeeplinksRouteRouteChildren: AppDeeplinksRouteRouteChildren = {
  AppDeeplinksPlanRoute: AppDeeplinksPlanRoute,
  AppDeeplinksTeamRoute: AppDeeplinksTeamRoute,
  AppDeeplinksProgramsProgramIdIndexRoute:
    AppDeeplinksProgramsProgramIdIndexRoute,
  AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute:
    AppDeeplinksProgramsProgramIdSetsSetIdIndexRoute,
  AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute:
    AppDeeplinksProgramsProgramIdSetsSetIdModulesModuleIdRoute,
  AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute:
    AppDeeplinksProgramsProgramIdSetsSetIdQuestionsQuestionIdRoute,
}

const AppDeeplinksRouteRouteWithChildren =
  AppDeeplinksRouteRoute._addFileChildren(AppDeeplinksRouteRouteChildren)

interface AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteChildren {
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute
}

const AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteChildren: AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteChildren =
  {
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute:
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatSubsectionIdRoute,
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute:
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatIndexRoute,
  }

const AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteWithChildren =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute._addFileChildren(
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteChildren,
  )

interface AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteChildren {
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteWithChildren
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute
}

const AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteChildren: AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteChildren =
  {
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRoute:
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugFormatRouteWithChildren,
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute:
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugIndexRoute,
  }

const AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteWithChildren =
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute._addFileChildren(
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteChildren,
  )

interface AppOrganizationsOrganizationIdBuilderRouteRouteChildren {
  AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute: typeof AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteWithChildren
  AppOrganizationsOrganizationIdBuilderIndexRoute: typeof AppOrganizationsOrganizationIdBuilderIndexRoute
}

const AppOrganizationsOrganizationIdBuilderRouteRouteChildren: AppOrganizationsOrganizationIdBuilderRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdBuilderDocbuilderSlugRoute:
      AppOrganizationsOrganizationIdBuilderDocbuilderSlugRouteWithChildren,
    AppOrganizationsOrganizationIdBuilderIndexRoute:
      AppOrganizationsOrganizationIdBuilderIndexRoute,
  }

const AppOrganizationsOrganizationIdBuilderRouteRouteWithChildren =
  AppOrganizationsOrganizationIdBuilderRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdBuilderRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdPlanRouteRouteChildren {
  AppOrganizationsOrganizationIdPlanIndexRoute: typeof AppOrganizationsOrganizationIdPlanIndexRoute
  AppOrganizationsOrganizationIdPlanItemsItemIdRoute: typeof AppOrganizationsOrganizationIdPlanItemsItemIdRoute
  AppOrganizationsOrganizationIdPlanItemsNewRoute: typeof AppOrganizationsOrganizationIdPlanItemsNewRoute
}

const AppOrganizationsOrganizationIdPlanRouteRouteChildren: AppOrganizationsOrganizationIdPlanRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdPlanIndexRoute:
      AppOrganizationsOrganizationIdPlanIndexRoute,
    AppOrganizationsOrganizationIdPlanItemsItemIdRoute:
      AppOrganizationsOrganizationIdPlanItemsItemIdRoute,
    AppOrganizationsOrganizationIdPlanItemsNewRoute:
      AppOrganizationsOrganizationIdPlanItemsNewRoute,
  }

const AppOrganizationsOrganizationIdPlanRouteRouteWithChildren =
  AppOrganizationsOrganizationIdPlanRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdPlanRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteChildren {
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute
}

const AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteChildren: AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute:
      AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdGuideRoute,
    AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute:
      AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdIndexRoute,
  }

const AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteWithChildren =
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdQuickStartRouteRouteChildren {
  AppOrganizationsOrganizationIdQuickStartIndexRoute: typeof AppOrganizationsOrganizationIdQuickStartIndexRoute
  AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute: typeof AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteWithChildren
}

const AppOrganizationsOrganizationIdQuickStartRouteRouteChildren: AppOrganizationsOrganizationIdQuickStartRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdQuickStartIndexRoute:
      AppOrganizationsOrganizationIdQuickStartIndexRoute,
    AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRoute:
      AppOrganizationsOrganizationIdQuickStartSubtopicsSubtopicIdRouteRouteWithChildren,
  }

const AppOrganizationsOrganizationIdQuickStartRouteRouteWithChildren =
  AppOrganizationsOrganizationIdQuickStartRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdQuickStartRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteChildren {
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute
}

const AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteChildren: AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteChildren =
  {
    AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute:
      AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameIndexRoute,
    AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute:
      AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameModulesModuleIdRoute,
    AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute:
      AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameSetsSetIdRoute,
  }

const AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteWithChildren =
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute._addFileChildren(
    AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteChildren,
  )

interface AppOrganizationsOrganizationIdReportsRouteRouteChildren {
  AppOrganizationsOrganizationIdReportsIndexRoute: typeof AppOrganizationsOrganizationIdReportsIndexRoute
  AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute: typeof AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteWithChildren
  AppOrganizationsOrganizationIdReportsModulesModuleIdRoute: typeof AppOrganizationsOrganizationIdReportsModulesModuleIdRoute
  AppOrganizationsOrganizationIdReportsSetsSetIdRoute: typeof AppOrganizationsOrganizationIdReportsSetsSetIdRoute
}

const AppOrganizationsOrganizationIdReportsRouteRouteChildren: AppOrganizationsOrganizationIdReportsRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdReportsIndexRoute:
      AppOrganizationsOrganizationIdReportsIndexRoute,
    AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRoute:
      AppOrganizationsOrganizationIdReportsChildrenChildOrgTypeMachineNameRouteWithChildren,
    AppOrganizationsOrganizationIdReportsModulesModuleIdRoute:
      AppOrganizationsOrganizationIdReportsModulesModuleIdRoute,
    AppOrganizationsOrganizationIdReportsSetsSetIdRoute:
      AppOrganizationsOrganizationIdReportsSetsSetIdRoute,
  }

const AppOrganizationsOrganizationIdReportsRouteRouteWithChildren =
  AppOrganizationsOrganizationIdReportsRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdReportsRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdSetsSetIdReportRouteChildren {
  AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute: typeof AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute
}

const AppOrganizationsOrganizationIdSetsSetIdReportRouteChildren: AppOrganizationsOrganizationIdSetsSetIdReportRouteChildren =
  {
    AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute:
      AppOrganizationsOrganizationIdSetsSetIdReportDownloadFormatRoute,
  }

const AppOrganizationsOrganizationIdSetsSetIdReportRouteWithChildren =
  AppOrganizationsOrganizationIdSetsSetIdReportRoute._addFileChildren(
    AppOrganizationsOrganizationIdSetsSetIdReportRouteChildren,
  )

interface AppOrganizationsOrganizationIdSetsSetIdRouteRouteChildren {
  AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute: typeof AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute: typeof AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute
  AppOrganizationsOrganizationIdSetsSetIdReportRoute: typeof AppOrganizationsOrganizationIdSetsSetIdReportRouteWithChildren
  AppOrganizationsOrganizationIdSetsSetIdIndexRoute: typeof AppOrganizationsOrganizationIdSetsSetIdIndexRoute
  AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute: typeof AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute
  AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute: typeof AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute
}

const AppOrganizationsOrganizationIdSetsSetIdRouteRouteChildren: AppOrganizationsOrganizationIdSetsSetIdRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute:
      AppOrganizationsOrganizationIdSetsSetIdCalculatorRoute,
    AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute:
      AppOrganizationsOrganizationIdSetsSetIdGlossaryRoute,
    AppOrganizationsOrganizationIdSetsSetIdReportRoute:
      AppOrganizationsOrganizationIdSetsSetIdReportRouteWithChildren,
    AppOrganizationsOrganizationIdSetsSetIdIndexRoute:
      AppOrganizationsOrganizationIdSetsSetIdIndexRoute,
    AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute:
      AppOrganizationsOrganizationIdSetsSetIdModulesModuleIdRoute,
    AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute:
      AppOrganizationsOrganizationIdSetsSetIdQuestionsQuestionIdRoute,
  }

const AppOrganizationsOrganizationIdSetsSetIdRouteRouteWithChildren =
  AppOrganizationsOrganizationIdSetsSetIdRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdSetsSetIdRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdSetsRouteRouteChildren {
  AppOrganizationsOrganizationIdSetsSetIdRouteRoute: typeof AppOrganizationsOrganizationIdSetsSetIdRouteRouteWithChildren
  AppOrganizationsOrganizationIdSetsIndexRoute: typeof AppOrganizationsOrganizationIdSetsIndexRoute
}

const AppOrganizationsOrganizationIdSetsRouteRouteChildren: AppOrganizationsOrganizationIdSetsRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdSetsSetIdRouteRoute:
      AppOrganizationsOrganizationIdSetsSetIdRouteRouteWithChildren,
    AppOrganizationsOrganizationIdSetsIndexRoute:
      AppOrganizationsOrganizationIdSetsIndexRoute,
  }

const AppOrganizationsOrganizationIdSetsRouteRouteWithChildren =
  AppOrganizationsOrganizationIdSetsRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdSetsRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdSurveysRouteRouteChildren {
  AppOrganizationsOrganizationIdSurveysSurveyIdRoute: typeof AppOrganizationsOrganizationIdSurveysSurveyIdRoute
}

const AppOrganizationsOrganizationIdSurveysRouteRouteChildren: AppOrganizationsOrganizationIdSurveysRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdSurveysSurveyIdRoute:
      AppOrganizationsOrganizationIdSurveysSurveyIdRoute,
  }

const AppOrganizationsOrganizationIdSurveysRouteRouteWithChildren =
  AppOrganizationsOrganizationIdSurveysRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdSurveysRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdTeamRouteRouteChildren {
  AppOrganizationsOrganizationIdTeamInviteRoute: typeof AppOrganizationsOrganizationIdTeamInviteRoute
}

const AppOrganizationsOrganizationIdTeamRouteRouteChildren: AppOrganizationsOrganizationIdTeamRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdTeamInviteRoute:
      AppOrganizationsOrganizationIdTeamInviteRoute,
  }

const AppOrganizationsOrganizationIdTeamRouteRouteWithChildren =
  AppOrganizationsOrganizationIdTeamRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdTeamRouteRouteChildren,
  )

interface AppOrganizationsOrganizationIdRouteRouteChildren {
  AppOrganizationsOrganizationIdAhsRouteRoute: typeof AppOrganizationsOrganizationIdAhsRouteRoute
  AppOrganizationsOrganizationIdBuilderRouteRoute: typeof AppOrganizationsOrganizationIdBuilderRouteRouteWithChildren
  AppOrganizationsOrganizationIdPendingRouteRoute: typeof AppOrganizationsOrganizationIdPendingRouteRoute
  AppOrganizationsOrganizationIdPlanRouteRoute: typeof AppOrganizationsOrganizationIdPlanRouteRouteWithChildren
  AppOrganizationsOrganizationIdQuickStartRouteRoute: typeof AppOrganizationsOrganizationIdQuickStartRouteRouteWithChildren
  AppOrganizationsOrganizationIdReportsRouteRoute: typeof AppOrganizationsOrganizationIdReportsRouteRouteWithChildren
  AppOrganizationsOrganizationIdSetsRouteRoute: typeof AppOrganizationsOrganizationIdSetsRouteRouteWithChildren
  AppOrganizationsOrganizationIdSurveysRouteRoute: typeof AppOrganizationsOrganizationIdSurveysRouteRouteWithChildren
  AppOrganizationsOrganizationIdTeamRouteRoute: typeof AppOrganizationsOrganizationIdTeamRouteRouteWithChildren
  AppOrganizationsOrganizationIdIndexRoute: typeof AppOrganizationsOrganizationIdIndexRoute
  AppOrganizationsOrganizationIdOverviewTabRoute: typeof AppOrganizationsOrganizationIdOverviewTabRoute
  AppOrganizationsOrganizationIdOverviewIndexRoute: typeof AppOrganizationsOrganizationIdOverviewIndexRoute
}

const AppOrganizationsOrganizationIdRouteRouteChildren: AppOrganizationsOrganizationIdRouteRouteChildren =
  {
    AppOrganizationsOrganizationIdAhsRouteRoute:
      AppOrganizationsOrganizationIdAhsRouteRoute,
    AppOrganizationsOrganizationIdBuilderRouteRoute:
      AppOrganizationsOrganizationIdBuilderRouteRouteWithChildren,
    AppOrganizationsOrganizationIdPendingRouteRoute:
      AppOrganizationsOrganizationIdPendingRouteRoute,
    AppOrganizationsOrganizationIdPlanRouteRoute:
      AppOrganizationsOrganizationIdPlanRouteRouteWithChildren,
    AppOrganizationsOrganizationIdQuickStartRouteRoute:
      AppOrganizationsOrganizationIdQuickStartRouteRouteWithChildren,
    AppOrganizationsOrganizationIdReportsRouteRoute:
      AppOrganizationsOrganizationIdReportsRouteRouteWithChildren,
    AppOrganizationsOrganizationIdSetsRouteRoute:
      AppOrganizationsOrganizationIdSetsRouteRouteWithChildren,
    AppOrganizationsOrganizationIdSurveysRouteRoute:
      AppOrganizationsOrganizationIdSurveysRouteRouteWithChildren,
    AppOrganizationsOrganizationIdTeamRouteRoute:
      AppOrganizationsOrganizationIdTeamRouteRouteWithChildren,
    AppOrganizationsOrganizationIdIndexRoute:
      AppOrganizationsOrganizationIdIndexRoute,
    AppOrganizationsOrganizationIdOverviewTabRoute:
      AppOrganizationsOrganizationIdOverviewTabRoute,
    AppOrganizationsOrganizationIdOverviewIndexRoute:
      AppOrganizationsOrganizationIdOverviewIndexRoute,
  }

const AppOrganizationsOrganizationIdRouteRouteWithChildren =
  AppOrganizationsOrganizationIdRouteRoute._addFileChildren(
    AppOrganizationsOrganizationIdRouteRouteChildren,
  )

interface AppOrganizationsJoinOrgtypeMachineNameRouteRouteChildren {
  AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute: typeof AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute
  AppOrganizationsJoinOrgtypeMachineNameFindRoute: typeof AppOrganizationsJoinOrgtypeMachineNameFindRoute
}

const AppOrganizationsJoinOrgtypeMachineNameRouteRouteChildren: AppOrganizationsJoinOrgtypeMachineNameRouteRouteChildren =
  {
    AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute:
      AppOrganizationsJoinOrgtypeMachineNameOrganizationIdRoute,
    AppOrganizationsJoinOrgtypeMachineNameFindRoute:
      AppOrganizationsJoinOrgtypeMachineNameFindRoute,
  }

const AppOrganizationsJoinOrgtypeMachineNameRouteRouteWithChildren =
  AppOrganizationsJoinOrgtypeMachineNameRouteRoute._addFileChildren(
    AppOrganizationsJoinOrgtypeMachineNameRouteRouteChildren,
  )

interface AppOrganizationsRouteRouteChildren {
  AppOrganizationsOrganizationIdRouteRoute: typeof AppOrganizationsOrganizationIdRouteRouteWithChildren
  AppOrganizationsIndexRoute: typeof AppOrganizationsIndexRoute
  AppOrganizationsJoinOrgtypeMachineNameRouteRoute: typeof AppOrganizationsJoinOrgtypeMachineNameRouteRouteWithChildren
  AppOrganizationsJoinIndexRoute: typeof AppOrganizationsJoinIndexRoute
}

const AppOrganizationsRouteRouteChildren: AppOrganizationsRouteRouteChildren = {
  AppOrganizationsOrganizationIdRouteRoute:
    AppOrganizationsOrganizationIdRouteRouteWithChildren,
  AppOrganizationsIndexRoute: AppOrganizationsIndexRoute,
  AppOrganizationsJoinOrgtypeMachineNameRouteRoute:
    AppOrganizationsJoinOrgtypeMachineNameRouteRouteWithChildren,
  AppOrganizationsJoinIndexRoute: AppOrganizationsJoinIndexRoute,
}

const AppOrganizationsRouteRouteWithChildren =
  AppOrganizationsRouteRoute._addFileChildren(
    AppOrganizationsRouteRouteChildren,
  )

interface AppResourcesRouteRouteChildren {
  AppResourcesResourceIdRoute: typeof AppResourcesResourceIdRoute
  AppResourcesIndexRoute: typeof AppResourcesIndexRoute
  AppResourcesAudioIdRoute: typeof AppResourcesAudioIdRoute
  AppResourcesCollectionsIdRoute: typeof AppResourcesCollectionsIdRoute
  AppResourcesCurriculaIdRoute: typeof AppResourcesCurriculaIdRoute
  AppResourcesMicrolearningsIdRoute: typeof AppResourcesMicrolearningsIdRoute
  AppResourcesTrainingsLocalIdRoute: typeof AppResourcesTrainingsLocalIdRoute
  AppResourcesTrainingsOnDemandIdRoute: typeof AppResourcesTrainingsOnDemandIdRoute
  AppResourcesTrainingsVirtualIdRoute: typeof AppResourcesTrainingsVirtualIdRoute
}

const AppResourcesRouteRouteChildren: AppResourcesRouteRouteChildren = {
  AppResourcesResourceIdRoute: AppResourcesResourceIdRoute,
  AppResourcesIndexRoute: AppResourcesIndexRoute,
  AppResourcesAudioIdRoute: AppResourcesAudioIdRoute,
  AppResourcesCollectionsIdRoute: AppResourcesCollectionsIdRoute,
  AppResourcesCurriculaIdRoute: AppResourcesCurriculaIdRoute,
  AppResourcesMicrolearningsIdRoute: AppResourcesMicrolearningsIdRoute,
  AppResourcesTrainingsLocalIdRoute: AppResourcesTrainingsLocalIdRoute,
  AppResourcesTrainingsOnDemandIdRoute: AppResourcesTrainingsOnDemandIdRoute,
  AppResourcesTrainingsVirtualIdRoute: AppResourcesTrainingsVirtualIdRoute,
}

const AppResourcesRouteRouteWithChildren =
  AppResourcesRouteRoute._addFileChildren(AppResourcesRouteRouteChildren)

interface AppSurveyPreviewsSurveyIdRouteRouteChildren {
  AppSurveyPreviewsSurveyIdIndexRoute: typeof AppSurveyPreviewsSurveyIdIndexRoute
  AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute: typeof AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute
  AppSurveyPreviewsSurveyIdLanguageIdIndexRoute: typeof AppSurveyPreviewsSurveyIdLanguageIdIndexRoute
}

const AppSurveyPreviewsSurveyIdRouteRouteChildren: AppSurveyPreviewsSurveyIdRouteRouteChildren =
  {
    AppSurveyPreviewsSurveyIdIndexRoute: AppSurveyPreviewsSurveyIdIndexRoute,
    AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute:
      AppSurveyPreviewsSurveyIdLanguageIdConfirmationRoute,
    AppSurveyPreviewsSurveyIdLanguageIdIndexRoute:
      AppSurveyPreviewsSurveyIdLanguageIdIndexRoute,
  }

const AppSurveyPreviewsSurveyIdRouteRouteWithChildren =
  AppSurveyPreviewsSurveyIdRouteRoute._addFileChildren(
    AppSurveyPreviewsSurveyIdRouteRouteChildren,
  )

interface AppSurveysSurveyOrganizationUuidRouteRouteChildren {
  AppSurveysSurveyOrganizationUuidIndexRoute: typeof AppSurveysSurveyOrganizationUuidIndexRoute
  AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute: typeof AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute
  AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute: typeof AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute
}

const AppSurveysSurveyOrganizationUuidRouteRouteChildren: AppSurveysSurveyOrganizationUuidRouteRouteChildren =
  {
    AppSurveysSurveyOrganizationUuidIndexRoute:
      AppSurveysSurveyOrganizationUuidIndexRoute,
    AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute:
      AppSurveysSurveyOrganizationUuidLanguageIdConfirmationRoute,
    AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute:
      AppSurveysSurveyOrganizationUuidLanguageIdIndexRoute,
  }

const AppSurveysSurveyOrganizationUuidRouteRouteWithChildren =
  AppSurveysSurveyOrganizationUuidRouteRoute._addFileChildren(
    AppSurveysSurveyOrganizationUuidRouteRouteChildren,
  )

interface AppProgramsProgramIdRouteChildren {
  AppProgramsProgramIdRegisterRoute: typeof AppProgramsProgramIdRegisterRoute
  AppProgramsProgramIdOrganizationsIndexRoute: typeof AppProgramsProgramIdOrganizationsIndexRoute
  AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute: typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute
  AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute: typeof AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute
}

const AppProgramsProgramIdRouteChildren: AppProgramsProgramIdRouteChildren = {
  AppProgramsProgramIdRegisterRoute: AppProgramsProgramIdRegisterRoute,
  AppProgramsProgramIdOrganizationsIndexRoute:
    AppProgramsProgramIdOrganizationsIndexRoute,
  AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute:
    AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdCalculatorRoute,
  AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute:
    AppProgramsProgramIdOrganizationsOrganizationIdSetsSetIdGlossaryRoute,
}

const AppProgramsProgramIdRouteWithChildren =
  AppProgramsProgramIdRoute._addFileChildren(AppProgramsProgramIdRouteChildren)

interface AppRouteRouteChildren {
  AppAccountRouteRoute: typeof AppAccountRouteRouteWithChildren
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppDeeplinksRouteRoute: typeof AppDeeplinksRouteRouteWithChildren
  AppOrganizationsRouteRoute: typeof AppOrganizationsRouteRouteWithChildren
  AppResourcesRouteRoute: typeof AppResourcesRouteRouteWithChildren
  AppSurveyPreviewsSurveyIdRouteRoute: typeof AppSurveyPreviewsSurveyIdRouteRouteWithChildren
  AppSurveysSurveyOrganizationUuidRouteRoute: typeof AppSurveysSurveyOrganizationUuidRouteRouteWithChildren
  AppDeeplinkQuestionQuestionIdRoute: typeof AppDeeplinkQuestionQuestionIdRoute
  AppDeeplinkSetSetIdRoute: typeof AppDeeplinkSetSetIdRoute
  AppMaterialsMaterialIdRoute: typeof AppMaterialsMaterialIdRoute
  AppProgramsProgramIdRoute: typeof AppProgramsProgramIdRouteWithChildren
  AppDemosIndexRoute: typeof AppDemosIndexRoute
  AppProgramsIndexRoute: typeof AppProgramsIndexRoute
  AppDemosSetsIndexRoute: typeof AppDemosSetsIndexRoute
  AppDemosSetsSetIdIndexRoute: typeof AppDemosSetsSetIdIndexRoute
  AppDemosSetsSetIdViewIndexRoute: typeof AppDemosSetsSetIdViewIndexRoute
  AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute: typeof AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute
  AppDemosSetsSetIdViewActiveDemoViewIndexRoute: typeof AppDemosSetsSetIdViewActiveDemoViewIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAccountRouteRoute: AppAccountRouteRouteWithChildren,
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppDeeplinksRouteRoute: AppDeeplinksRouteRouteWithChildren,
  AppOrganizationsRouteRoute: AppOrganizationsRouteRouteWithChildren,
  AppResourcesRouteRoute: AppResourcesRouteRouteWithChildren,
  AppSurveyPreviewsSurveyIdRouteRoute:
    AppSurveyPreviewsSurveyIdRouteRouteWithChildren,
  AppSurveysSurveyOrganizationUuidRouteRoute:
    AppSurveysSurveyOrganizationUuidRouteRouteWithChildren,
  AppDeeplinkQuestionQuestionIdRoute: AppDeeplinkQuestionQuestionIdRoute,
  AppDeeplinkSetSetIdRoute: AppDeeplinkSetSetIdRoute,
  AppMaterialsMaterialIdRoute: AppMaterialsMaterialIdRoute,
  AppProgramsProgramIdRoute: AppProgramsProgramIdRouteWithChildren,
  AppDemosIndexRoute: AppDemosIndexRoute,
  AppProgramsIndexRoute: AppProgramsIndexRoute,
  AppDemosSetsIndexRoute: AppDemosSetsIndexRoute,
  AppDemosSetsSetIdIndexRoute: AppDemosSetsSetIdIndexRoute,
  AppDemosSetsSetIdViewIndexRoute: AppDemosSetsSetIdViewIndexRoute,
  AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute:
    AppDemosSetsSetIdViewActiveDemoViewQuestionIdRoute,
  AppDemosSetsSetIdViewActiveDemoViewIndexRoute:
    AppDemosSetsSetIdViewActiveDemoViewIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
